<template>
    <div>
        <div v-if="step1" id="bulk-change">
            <nav v-if="selectedCarrrier == 1" class="select-actions">
                <b-button variant="link" id="bulkSimonActionsButton" :class="[(this.selectedActions == true) ? 'active' : '' ]" @click="selectActionsModal()">Actions</b-button>
                <b-button variant="link" id="bulkSimonPlanChangeButton" :class="[(this.selectedChangePlan == true) ? 'active' : '' ]" @click="selectPlanModal()">Plan Change</b-button>
                <b-button variant="link" id="bulkSimonSimSwapButton" :class="[(this.selectedSimSwap == true) ? 'active' : '' ]" @click="selectSwapModal()">Sim Swap</b-button>
                <b-button variant="link" id="bulkSimonTagsButton" :class="[(this.selectedTagsChange == true) ? 'active' : '' ]" @click="selectTags()">Tags</b-button>
                <b-button variant="link" id="bulkSimonDGOButton" :class="[(this.selectedDGO == true) ? 'active' : '' ]" @click="selectDGO()">Data guard override</b-button>
            </nav>
            <nav v-else-if="selectedCarrrier == 2" class="select-actions">
                <b-button variant="link" id="bulkTmobileActionsButton" :class="[(this.selectedActions == true) ? 'active' : '' ]" @click="selectActionsModal()">Actions</b-button>
                <b-button variant="link" id="bulkTmobileSimSwapButton" :class="[(this.selectedSimSwap == true) ? 'active' : '' ]" @click="selectSwapModal()">Sim Swap</b-button>
                <b-button variant="link" id="bulkTmobileTagsButton" :class="[(this.selectedTagsChange == true) ? 'active' : '' ]" @click="selectTags()">Tags</b-button>
            </nav>
            <nav v-else-if="selectedCarrrier == 3" class="select-actions">
                <b-button variant="link" id="bulkVodafoneChangeStateButton" :class="[(this.selectedChangeState == true) ? 'active' : '' ]" @click="selectChangStateModal()">Change State</b-button>
                <b-button variant="link" id="bulkVodafonePlanChangeButton" :class="[(this.selectedChangePlan == true) ? 'active' : '' ]" @click="selectPlanModal()">Plan Change</b-button>
                <b-button variant="link" id="bulkVodafoneTagsButton" :class="[(this.selectedTagsChange == true) ? 'active' : '' ]" @click="selectTags()">Tags</b-button>
            </nav>
            <nav v-else-if="selectedCarrrier == 4" class="select-actions">
                <b-button variant="link" id="bulkKoreActionsButton" :class="[(this.selectedActions == true) ? 'active' : '' ]" @click="selectActionsModal()">Actions</b-button>
                <b-button variant="link" id="bulkKoreTagsButton" :class="[(this.selectedTagsChange == true) ? 'active' : '' ]" @click="selectTags()">Tags</b-button>
            </nav>

            <div v-if="simSwapStep2 == false && selectedTagsChangeStep2 == false && selectedDGOStep2 == false" class="upload-sims-areas">
                <div class="input-sims-area">
                    <p>Scan the barcode of / or enter the SIM number you can find on the back of the SIM card</p>
                    <div class="sims-input">
                        <input @keyup="onEnterPress" type="text" class="add-sims-input" v-model="simsInput">
                        <button @click="addSimsFromBtn()" class="add-sims-btn">Apply</button>
                    </div>
                </div>
                <div class="dnd-area">
                    <div class="image">
                        <img src="../../assets/img/upload-sims.png" alt="">
                    </div>
                    <div class="text">
                        <h3>Drag and drop list of SIM's or Browse</h3>
                        <h4>The file selected needs to be CSV or XLSX file where the SIMs are seperated by commas.</h4>
                    </div>
                    <div class="mobile-text">
                        <p>OR</p>

                        <h3>Upload file</h3>
                        <h4>The file selected needs to be CSV or XLSX file where the SIMs are seperated by commas.</h4>
                    </div>
                    <div class="label">
                        <input type="file" id="file-bulk-modal" ref="importFile" v-on:change="readSimFileModal">
                        <label for="file-bulk-modal" class="btn btn-primary">Browse</label>
                    </div>
                </div>
            </div>

            <div v-if="selectedTagsChange" class="select-tags-areas">
                <div class="select-tags">
                    <div class="header-row">
                        <div class="left-side">
                            <h3>Remove Tags</h3>
                            <i class="fa fa-info"></i>
                            <span>Removing Tags only removes them from the selected SIM Cards. Tags will still be available in the Tag Database.</span>
                        </div>
                        <div class="right-side">
                            <a class="select-all-tags" @click="selectAllTagsRemove()"><span v-if="removeTagsList.length == (selectedRemoveTags.length + selectedAddTags.length)">Deselect All</span><span v-else>Select All</span></a>
                        </div>
                    </div>
                    <p class="info">Here you can see all the tags that are being used by the SIM cards you have selected for Tag Editing</p>
                    <div class="search-tags">
                        <input type="text" v-model="searchRemoveTag.phrase" @keyup="searchKeyUpTagsRemove()" @keydown="searchKeyDownTagsRemove()" placeholder="Search">
                    </div>
                    <a v-if="searchRemoveTag.desc" class="sorting" @click="setAlphaRemove">Z-A<i class="fa fa-sort-desc"></i></a>
                    <a v-else class="sorting" @click="setAlphaRemove">A-Z<i class="fa fa-sort-asc"></i></a>

                    <div class="tags-list">
                        <div v-for="tag of removeTagsList" :class="['tag', tag.selected ? 'selected' : '', checkIfTagSelected('REMOVE', tag.label) ? 'grey-out' : '']" @click="selectRemoveTag(tag)">{{tag.label}}</div>
                    </div>
                </div>
                <div class="select-tags">
                    <div class="header-row">
                        <div class="left-side">
                            <h3>Add Tags</h3>
                            <i class="fa fa-info"></i>
                            <span>If you cant find the Tags you are looking for, you will need to add them to the Tag Database by going to Settings/Tags or contacting your Supervisor.</span>
                        </div>
                        <div class="right-side">
                            <a class="select-all-tags" @click="selectAllTagsAdd()"><span v-if="addTagsList.length == (selectedAddTags.length + selectedRemoveTags.length)">Deselect All</span><span v-else>Select All</span></a>
                        </div>
                    </div>
                    <p class="info">Here you can see all the tags available to be added from the Tag Database.</p>
                    <div class="search-tags">
                        <input type="text" v-model="searchAddTag.phrase" @keyup="searchKeyUpTagsAdd()" @keydown="searchKeyDownTagsAdd()" placeholder="Search">
                    </div>
                    <a v-if="searchAddTag.desc" class="sorting" @click="setAlphaAdd">Z-A<i class="fa fa-sort-desc"></i></a>
                    <a v-else class="sorting" @click="setAlphaAdd">A-Z<i class="fa fa-sort-asc"></i></a>
                    <div class="tags-list">
                        <div v-for="tag of addTagsList" :class="['tag', tag.selected ? 'selected' : '', checkIfTagSelected('ADD', tag.label) ? 'grey-out' : '']" @click="selectAddTag(tag)">{{tag.label}}</div>
                    </div>
                </div>
            </div>

            <div v-if="selectedChangeState" class="instructions-box">
                <h3>Change State</h3>
                <div class="instructions">
                    <span class="step">1. Select the SIM Cards that will have their state changed.</span>
                    <span class="step">2. Select Destination State via dropdown</span>
                    <span class="step">3. Validate</span>
                </div>
            </div>

            <div v-if="selectedChangePlan" class="instructions-box">
                <h3>Selecting a Plan will sort the SIM card list to show only SIMs with that plan.</h3>
            </div>

            <div v-if="simsFailedValidationFromFile.length" class="sims-failed-validation-from-file">
                <h3>Uploaded list issues</h3>
                <h4>SIM cards that coundn't be processed from the uploaded list.</h4>
                <div v-for="item of simsFailedValidationFromFile" class="error-type">
                    <h6 class="name">{{item.groupName}}</h6>
                    <h6 class="desc">{{item.groupDescription}}</h6>
                    <div class="list-of-sims">
                        <div v-for="sim of item.iccids" class="sim"> <i class="fts-icon-sim"></i> {{sim}}</div>
                    </div>
                </div>
            </div>

            <div v-if="selectedChangePlan" class="migrate-plan">
                <div class="plan-selectors">
                    <div class="migrate-from-outer">
                        <h3>Plan you want to migrate from</h3>
                        <div class="migrate-from">
                    <div v-if="selectedPlanFrom.id == 0" class="inner-migrate">
                        <b-button id="bulkSelectPlanFromButton" variant="primary" @click="selectFromPlan()">Select Base Plan</b-button>
                        <p>Select a Plan you want to migrate your SIMs from </p>

<!--                        <label>-->
<!--                            <input type="checkbox" name="selectAllSims" v-model="selectAllSimsRatePlan">-->
<!--                            <span>Automaticly select all SIMs with the choosen plan</span>-->
<!--                        </label>-->
                    </div>
                    <div v-else-if="selectedPlanFrom.carrierId == 1" class="inner-migrate">
                        <div class="header-plan">
                            <div class="title">
                                <h3>{{ratePlanSelectedFrom.name}}</h3>

                                <div :class="['category', ratePlanSelectedFrom.categoryClass]">
                                    <h4>{{ratePlanSelectedFrom.category}}</h4>

                                    <em>{{ratePlanSelectedFrom.dataLimit}}</em>
                                </div>
                            </div>

                            <div class="button">
                                <b-button variant="primary" @click="selectFromPlan()">Select Base Plan</b-button>
                                <i class="fa fa-close remove-plan" @click="deselectPlanFrom()"></i>
                            </div>
                        </div>

                        <div class="body-plan">
                            <div v-if="selectedPlanFrom.carrierId == 1" class="right-col list-options">
                                <!-- <div :class="['item-options',  ratePlanSelectedFrom.planOptions.dataPooling == 'ON' ? 'true' : 'false']">
                                    <span>Pooling</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.dataPooling == 'ON'">ON</em> <em v-else>OFF</em>
                                </div> -->

                                <div :class="['item-options',  ratePlanSelectedFrom.planOptions.hasRoaming == 'ON' ? 'true' : 'false']">
                                    <span>Tier 1 International Roaming</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.hasRoaming == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.dataGuard.hasThrottle != 0 ? 'true' : 'false']">
                                    <span>Throttle {{ratePlanSelectedFrom.dataGuard.throttleAt}} {{ratePlanSelectedFrom.dataGuard.throttleAtUnit}} - {{ratePlanSelectedFrom.dataGuard.throttleSpeed}}</span>
                                    <em v-if="ratePlanSelectedFrom.dataGuard.hasThrottle == true">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.planOptions.roaming2 == 'ON' ? 'true' : 'false']">
                                    <span>Tier 2 International Roaming</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.hasRoaming2 == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.dataGuard.hasCap != 0 ? 'true' : 'false']">
                                    <span>Cap {{ratePlanSelectedFrom.dataGuard.capAt}} {{ratePlanSelectedFrom.dataGuard.capAtUnit}}</span>
                                    <em v-if="ratePlanSelectedFrom.dataGuard.hasCap != 0">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.planOptions.sms == 'ON' ? 'true' : 'false']">
                                    <span>SMS</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.sms == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.fistAlertAtMb && ratePlanSelectedFrom.fistAlertAtMb != 0 ? 'true' : 'false']">
                                    <span>Alert 1</span>
                                    <em v-if="ratePlanSelectedFrom.fistAlertAtMb"><span class="value-in-mb">{{ratePlanSelectedFrom.fistAlertAtMb}} -</span> ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.planOptions.staticIp == 'ON' ? 'true' : 'false']">
                                    <span>Static IP</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.staticIp == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.secondAlertAtMb && ratePlanSelectedFrom.secondAlertAtMb != 0 ? 'true' : 'false']">
                                    <span>Alert 2</span>
                                    <em v-if="ratePlanSelectedFrom.secondAlertAtMb"><span class="value-in-mb">{{ratePlanSelectedFrom.secondAlertAtMb}} -</span> ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.planOptions.hasVoice == 'ON' ? 'true' : 'false']">
                                    <span>Voice</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.hasVoice == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div v-if="hotSpotVisible" :class="['item-options',  ratePlanSelectedFrom.planOptions.hotSpot == 'ON' ? 'true' : 'false']">
                                    <span>Hot Spot</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.hotSpot == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>
                            </div>
                        </div>
                        <div class="plan-description">
                                {{ratePlanSelectedFrom.description}}
                            </div>
                    </div>
                    <div v-else-if="ratePlanSelectedFrom.carrierId == 2" class="inner-migrate">
                        <div class="header-plan">
                            <div class="title">
                                <h3>{{ratePlanSelectedFrom.planName}}</h3>

                                <div class="category magenta">
                                    <h4>Magenta</h4>
                                </div>
                            </div>

                            <div class="button">
                                <b-button variant="primary" @click="selectFromPlan()">Select Base Plan</b-button>
                            </div>
                        </div>

                        <div class="body-plan">
                            <div v-if="selectedPlanFrom.carrierId == 2" class="right-col list-options">
                                <div :class="['item-options',  ratePlanSelectedFrom.staticIp ? 'true' : 'false']">
                                    <span>Static IP</span>
                                    <em v-if="ratePlanSelectedFrom.staticIp == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>
                            </div>
                        </div>
                        <div class="plan-description">
                            {{ratePlanSelectedFrom.planDescription}}
                        </div>
                    </div>
                    <div v-else-if="ratePlanSelectedFrom.carrierId == 3" class="inner-migrate">
                        <div class="header-plan">
                            <div class="title">
                                <h3>{{ratePlanSelectedFrom.planName}}</h3>

                                <div class="category vodafone">
                                    <h4>Vodafone</h4>
                                </div>
                            </div>

                            <div class="button">
                                <b-button variant="primary" @click="selectFromPlan()">Select Base Plan</b-button>
                                <i class="fa fa-close remove-plan" @click="deselectPlanFrom()"></i>
                            </div>
                        </div>

                        <div class="body-plan">
                            <div v-if="selectedPlanFrom.carrierId == 3" class="right-col list-options">
                                <div class="item-options">
                                    <span>Data Limit</span>
                                    <em v-if="ratePlanSelectedFrom.dataLimit">{{ratePlanSelectedFrom.dataLimit.dataLimitName}}</em>
                                </div>
                                <div class="item-options">
                                    <span>APN</span>
                                    <em v-if="ratePlanSelectedFrom.provisioningProfile">{{ratePlanSelectedFrom.provisioningProfile.apnType}}</em>
                                </div>
                                <div class="item-options">
                                    <span>Provisioning profile</span>
                                    <em v-if="ratePlanSelectedFrom.provisioningProfile">{{ratePlanSelectedFrom.provisioningProfile.profileName}}</em>
                                </div>
                                <div :class="['item-options',  ratePlanSelectedFrom.imeiMatch ? 'true' : 'false']">
                                    <span>IMEI Match Rule</span>
                                    <em v-if="ratePlanSelectedFrom.imeiMatch">ON</em> <em v-else>OFF</em>
                                </div>
                            </div>
                        </div>
                        <div class="plan-description">
                            {{ratePlanSelectedFrom.planDescription}}
                        </div>
                    </div>
                    </div>
                    </div>
                    <div class="migrate-from-outer">
                        <h3>Plan you want to migrate to</h3>
                        <div class="migrate-to">
                        <div v-if="selectedPlanTo.id == 0" class="inner-migrate">
                            <b-button id="bulkSelectPlanToButton" variant="primary" @click="selectToPlan()">Select Destination Plan</b-button>
                            <p>Select a Plan you want to migrate your SIMs to </p>
                        </div>
                        <div v-else-if="selectedPlanTo.carrierId == 1" class="inner-migrate">
                            <div class="header-plan">
                                <div class="title">
                                    <h3>{{ratePlanSelectedTo.name}}</h3>

                                    <div :class="['category', ratePlanSelectedTo.categoryClass]">
                                        <h4>{{ratePlanSelectedTo.category}}</h4>

                                        <em>{{ratePlanSelectedTo.dataLimit}}</em>
                                    </div>
                                </div>

                                <div class="button">
                                    <b-button variant="primary" @click="selectToPlan()">Select Destination Plan</b-button>
                                    <i class="fa fa-close remove-plan" @click="deselectPlanTo()"></i>
                                </div>
                            </div>
                            <div class="body-plan">
                                <div v-if="selectedPlanTo.carrierId == 1" class="right-col list-options">
                                    <!-- <div :class="['item-options',  ratePlanSelectedTo.planOptions.dataPooling == 'ON' ? 'true' : 'false']">
                                        <span>Pooling</span>
                                        <em v-if="ratePlanSelectedTo.planOptions.dataPooling == 'ON'">ON</em> <em v-else>OFF</em>
                                    </div> -->

                                    <div :class="['item-options',  ratePlanSelectedTo.planOptions.hasRoaming == 'ON' ? 'true' : 'false']">
                                        <span>Tier 1 International Roaming</span>
                                        <em v-if="ratePlanSelectedTo.planOptions.hasRoaming == 'ON'">ON</em> <em v-else>OFF</em>
                                    </div>

                                    <div :class="['item-options',  ratePlanSelectedTo.dataGuard.hasThrottle != 0 ? 'true' : 'false']">
                                        <span>Throttle {{ratePlanSelectedTo.dataGuard.throttleAt}} {{ratePlanSelectedTo.dataGuard.throttleAtUnit}} - {{ratePlanSelectedTo.dataGuard.throttleSpeed}}</span>
                                        <em v-if="ratePlanSelectedTo.dataGuard.hasThrottle == true">ON</em> <em v-else>OFF</em>
                                    </div>

                                    <div :class="['item-options',  ratePlanSelectedTo.planOptions.roaming2 == 'ON' ? 'true' : 'false']">
                                        <span>Tier 2 International Roaming</span>
                                        <em v-if="ratePlanSelectedTo.planOptions.hasRoaming2 == 'ON'">ON</em> <em v-else>OFF</em>
                                    </div>

                                    <div :class="['item-options',  ratePlanSelectedTo.dataGuard.hasCap != 0 ? 'true' : 'false']">
                                        <span>Cap {{ratePlanSelectedTo.dataGuard.capAt}} {{ratePlanSelectedTo.dataGuard.capAtUnit}}</span>
                                        <em v-if="ratePlanSelectedTo.dataGuard.hasCap != 0">ON</em> <em v-else>OFF</em>
                                    </div>

                                    <div :class="['item-options',  ratePlanSelectedTo.planOptions.sms == 'ON' ? 'true' : 'false']">
                                        <span>SMS</span>
                                        <em v-if="ratePlanSelectedTo.planOptions.sms == 'ON'">ON</em> <em v-else>OFF</em>
                                    </div>

                                    <div :class="['item-options',  ratePlanSelectedTo.fistAlertAtMb && ratePlanSelectedTo.fistAlertAtMb != 0 ? 'true' : 'false']">
                                        <span>Alert 1</span>
                                        <em v-if="ratePlanSelectedTo.fistAlertAtMb"><span class="value-in-mb">{{ratePlanSelectedTo.fistAlertAtMb}} -</span> ON</em> <em v-else>OFF</em>
                                    </div>

                                    <div :class="['item-options',  ratePlanSelectedTo.planOptions.staticIp == 'ON' ? 'true' : 'false']">
                                        <span>Static IP</span>
                                        <em v-if="ratePlanSelectedTo.planOptions.staticIp == 'ON'">ON</em> <em v-else>OFF</em>
                                    </div>

                                    <div :class="['item-options',  ratePlanSelectedTo.secondAlertAtMb && ratePlanSelectedTo.secondAlertAtMb != 0 ? 'true' : 'false']">
                                        <span>Alert 2</span>
                                        <em v-if="ratePlanSelectedTo.secondAlertAtMb"><span class="value-in-mb">{{ratePlanSelectedTo.secondAlertAtMb}} -</span> ON</em> <em v-else>OFF</em>
                                    </div>

                                    <div :class="['item-options',  ratePlanSelectedTo.planOptions.hasVoice == 'ON' ? 'true' : 'false']">
                                        <span>Voice</span>
                                        <em v-if="ratePlanSelectedTo.planOptions.hasVoice == 'ON'">ON</em> <em v-else>OFF</em>
                                    </div>

                                    <div v-if="hotSpotVisible" :class="['item-options',  ratePlanSelectedTo.planOptions.hotSpot == 'ON' ? 'true' : 'false']">
                                        <span>Hot Spot</span>
                                        <em v-if="ratePlanSelectedTo.planOptions.hotSpot == 'ON'">ON</em> <em v-else>OFF</em>
                                    </div>
                                </div>
                            </div>
                            <div class="plan-description">
                                    {{ratePlanSelectedTo.description}}
                                </div>
                        </div>
                        <div v-else-if="ratePlanSelectedTo.carrierId == 2" class="inner-migrate">
                            <div class="header-plan">
                                <div class="title">
                                    <h3>{{ratePlanSelectedTo.planName}}</h3>

                                    <div class="category magenta">
                                        <h4>Magenta</h4>
                                    </div>
                                </div>

                                <div class="button">
                                    <b-button variant="primary" @click="selectToPlan()">Select Destination Plan</b-button>
                                </div>
                            </div>

                            <div class="body-plan">
                                <div v-if="selectedPlanTo.carrierId == 2" class="right-col list-options">
                                    <div :class="['item-options',  ratePlanSelectedTo.staticIp ? 'true' : 'false']">
                                        <span>Static IP</span>
                                        <em v-if="ratePlanSelectedTo.staticIp == 'ON'">ON</em> <em v-else>OFF</em>
                                    </div>
                                </div>
                            </div>
                            <div class="plan-description">
                                {{ratePlanSelectedTo.planDescription}}
                            </div>
                        </div>
                        <div v-else-if="ratePlanSelectedTo.carrierId == 3" class="inner-migrate">
                            <div class="header-plan">
                                <div class="title">
                                    <h3>{{ratePlanSelectedTo.planName}}</h3>

                                    <div class="category vodafone">
                                        <h4>Vodafone</h4>
                                    </div>
                                </div>

                                <div class="button">
                                    <b-button variant="primary" @click="selectToPlan()">Select Destination Plan</b-button>
                                    <i class="fa fa-close remove-plan" @click="deselectPlanTo()"></i>
                                </div>
                            </div>



                            <div class="body-plan">
                                <div v-if="selectedPlanFrom.carrierId == 3" class="right-col list-options">
                                    <div class="item-options">
                                        <span>Data Limit</span>
                                        <em v-if="ratePlanSelectedTo.dataLimit">{{ratePlanSelectedTo.dataLimit.dataLimitName}}</em>
                                    </div>
                                    <div class="item-options">
                                        <span>APN</span>
                                        <em v-if="ratePlanSelectedTo.provisioningProfile">{{ratePlanSelectedTo.provisioningProfile.apnType}}</em>
                                    </div>
                                    <div class="item-options">
                                        <span>Provisioning profile</span>
                                        <em v-if="ratePlanSelectedTo.provisioningProfile">{{ratePlanSelectedTo.provisioningProfile.profileName}}</em>
                                    </div>
                                    <div :class="['item-options',  ratePlanSelectedTo.imeiMatch ? 'true' : 'false']">
                                        <span>IMEI Match Rule</span>
                                        <em v-if="ratePlanSelectedTo.imeiMatch">ON</em> <em v-else>OFF</em>
                                    </div>
                                </div>
                            </div>
                            <div class="plan-description">
                                {{ratePlanSelectedTo.planDescription}}
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>

            <div v-if="selectedDGO" class="dgo-bulk">
                <div class="plan-selectors">
                    <div class="migrate-from-outer">
                        <div class="migrate-from">
                            <div v-if="selectedPlanFrom.id == 0" class="inner-migrate">
                                <b-button id="bulkSelectPlanDGOButton" variant="primary" @click="selectFromPlan()">Select Base Plan</b-button>
                                <p>Select a Plan you want to select SIMs to Data Guard Override.</p>
                            </div>
                            <div v-else-if="selectedPlanFrom.carrierId == 1" class="inner-migrate">
                                <div class="header-plan">
                                    <div class="title">
                                        <h3>{{ratePlanSelectedFrom.name}}</h3>

                                        <div :class="['category', ratePlanSelectedFrom.categoryClass]">
                                            <h4>{{ratePlanSelectedFrom.category}}</h4>

                                            <em>{{ratePlanSelectedFrom.dataLimit}}</em>
                                        </div>
                                    </div>

                                    <div class="button">
                                        <b-button variant="primary" @click="selectFromPlan()">Select Base Plan</b-button>
                                        <i class="fa fa-close remove-plan" @click="deselectPlanFrom()"></i>
                                    </div>
                                </div>

                                <div class="body-plan">
                                    <div v-if="selectedPlanFrom.carrierId == 1" class="right-col list-options">

                                        <div :class="['item-options',  ratePlanSelectedFrom.planOptions.hasRoaming == 'ON' ? 'true' : 'false']">
                                            <span>Tier 1 International Roaming</span>
                                            <em v-if="ratePlanSelectedFrom.planOptions.hasRoaming == 'ON'">ON</em> <em v-else>OFF</em>
                                        </div>

                                        <div :class="['item-options',  ratePlanSelectedFrom.dataGuard.hasThrottle != 0 ? 'true' : 'false']">
                                            <span>Throttle {{ratePlanSelectedFrom.dataGuard.throttleAt}} {{ratePlanSelectedFrom.dataGuard.throttleAtUnit}} - {{ratePlanSelectedFrom.dataGuard.throttleSpeed}}</span>
                                            <em v-if="ratePlanSelectedFrom.dataGuard.hasThrottle == true">ON</em> <em v-else>OFF</em>
                                        </div>

                                        <div :class="['item-options',  ratePlanSelectedFrom.planOptions.roaming2 == 'ON' ? 'true' : 'false']">
                                            <span>Tier 2 International Roaming</span>
                                            <em v-if="ratePlanSelectedFrom.planOptions.hasRoaming2 == 'ON'">ON</em> <em v-else>OFF</em>
                                        </div>

                                        <div :class="['item-options',  ratePlanSelectedFrom.dataGuard.hasCap != 0 ? 'true' : 'false']">
                                            <span>Cap {{ratePlanSelectedFrom.dataGuard.capAt}} {{ratePlanSelectedFrom.dataGuard.capAtUnit}}</span>
                                            <em v-if="ratePlanSelectedFrom.dataGuard.hasCap != 0">ON</em> <em v-else>OFF</em>
                                        </div>

                                        <div :class="['item-options',  ratePlanSelectedFrom.planOptions.sms == 'ON' ? 'true' : 'false']">
                                            <span>SMS</span>
                                            <em v-if="ratePlanSelectedFrom.planOptions.sms == 'ON'">ON</em> <em v-else>OFF</em>
                                        </div>

                                        <div :class="['item-options',  ratePlanSelectedFrom.fistAlertAtMb && ratePlanSelectedFrom.fistAlertAtMb != 0 ? 'true' : 'false']">
                                            <span>Alert 1</span>
                                            <em v-if="ratePlanSelectedFrom.fistAlertAtMb"><span class="value-in-mb">{{ratePlanSelectedFrom.fistAlertAtMb}} -</span> ON</em> <em v-else>OFF</em>
                                        </div>

                                        <div :class="['item-options',  ratePlanSelectedFrom.planOptions.staticIp == 'ON' ? 'true' : 'false']">
                                            <span>Static IP</span>
                                            <em v-if="ratePlanSelectedFrom.planOptions.staticIp == 'ON'">ON</em> <em v-else>OFF</em>
                                        </div>

                                        <div :class="['item-options',  ratePlanSelectedFrom.secondAlertAtMb && ratePlanSelectedFrom.secondAlertAtMb != 0 ? 'true' : 'false']">
                                            <span>Alert 2</span>
                                            <em v-if="ratePlanSelectedFrom.secondAlertAtMb"><span class="value-in-mb">{{ratePlanSelectedFrom.secondAlertAtMb}} -</span> ON</em> <em v-else>OFF</em>
                                        </div>

                                        <div :class="['item-options',  ratePlanSelectedFrom.planOptions.hasVoice == 'ON' ? 'true' : 'false']">
                                            <span>Voice</span>
                                            <em v-if="ratePlanSelectedFrom.planOptions.hasVoice == 'ON'">ON</em> <em v-else>OFF</em>
                                        </div>

                                        <div v-if="hotSpotVisible" :class="['item-options',  ratePlanSelectedFrom.planOptions.hotSpot == 'ON' ? 'true' : 'false']">
                                            <span>Hot Spot</span>
                                            <em v-if="ratePlanSelectedFrom.planOptions.hotSpot == 'ON'">ON</em> <em v-else>OFF</em>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan-description">
                                    {{ratePlanSelectedFrom.description}}
                                </div>
                            </div>
                            <div v-else-if="ratePlanSelectedFrom.carrierId == 2" class="inner-migrate">
                                <div class="header-plan">
                                    <div class="title">
                                        <h3>{{ratePlanSelectedFrom.planName}}</h3>

                                        <div class="category magenta">
                                            <h4>Magenta</h4>
                                        </div>
                                    </div>

                                    <div class="button">
                                        <b-button variant="primary" @click="selectFromPlan()">Select Base Plan</b-button>
                                    </div>
                                </div>

                                <div class="body-plan">
                                    <div v-if="selectedPlanFrom.carrierId == 2" class="right-col list-options">
                                        <div :class="['item-options',  ratePlanSelectedFrom.staticIp ? 'true' : 'false']">
                                            <span>Static IP</span>
                                            <em v-if="ratePlanSelectedFrom.staticIp == 'ON'">ON</em> <em v-else>OFF</em>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan-description">
                                    {{ratePlanSelectedFrom.planDescription}}
                                </div>
                            </div>
                            <div v-else-if="ratePlanSelectedFrom.carrierId == 3" class="inner-migrate">
                                <div class="header-plan">
                                    <div class="title">
                                        <h3>{{ratePlanSelectedFrom.planName}}</h3>

                                        <div class="category vodafone">
                                            <h4>Vodafone</h4>
                                        </div>
                                    </div>

                                    <div class="button">
                                        <b-button variant="primary" @click="selectFromPlan()">Select Base Plan</b-button>
                                        <i class="fa fa-close remove-plan" @click="deselectPlanFrom()"></i>
                                    </div>
                                </div>

                                <div class="body-plan">
                                    <div v-if="selectedPlanFrom.carrierId == 3" class="right-col list-options">
                                        <div class="item-options">
                                            <span>Data Limit</span>
                                            <em v-if="ratePlanSelectedFrom.dataLimit">{{ratePlanSelectedFrom.dataLimit.dataLimitName}}</em>
                                        </div>
                                        <div class="item-options">
                                            <span>APN</span>
                                            <em v-if="ratePlanSelectedFrom.provisioningProfile">{{ratePlanSelectedFrom.provisioningProfile.apnType}}</em>
                                        </div>
                                        <div class="item-options">
                                            <span>Provisioning profile</span>
                                            <em v-if="ratePlanSelectedFrom.provisioningProfile">{{ratePlanSelectedFrom.provisioningProfile.profileName}}</em>
                                        </div>
                                        <div :class="['item-options',  ratePlanSelectedFrom.imeiMatch ? 'true' : 'false']">
                                            <span>IMEI Match Rule</span>
                                            <em v-if="ratePlanSelectedFrom.imeiMatch">ON</em> <em v-else>OFF</em>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan-description">
                                    {{ratePlanSelectedFrom.planDescription}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dgo-settings-box">
                        <h3>Data Guard Override</h3>
                        <div class="dgo-settings">
                            <div class="column">
                                <div class="dgo-setting-field">
                                    <h3>Throttle</h3>
                                    <label for="">Set New Threshold</label>
                                    <div class="inputs-row">
                                        <input v-model="dgoData.throttle.value" :disabled="DGOunlimited" @input="validateThrottle()" class="form-control" type="number" min="0"/>
                                        <b-form-select v-model="dgoData.throttle.unit" :disabled="DGOunlimited" :options="[{value: 'MB', text: 'MB'}, {value: 'GB', text: 'GB'}]"></b-form-select>
                                    </div>
                                    <span :class="['dgo-warn', dgoData.throttle.value == 0 || DGOunlimited ? '' : 'hidden']">Leaving throttle value as 0 means it will be turned off.</span>
                                </div>
                                <div class="dgo-setting-field speed-box">
                                    <label for=""><strong>Speed</strong></label>
                                    <b-form-select :disabled="dgoData.throttle.value == 0 || DGOunlimited" v-model="dgoData.speed" :options="speedGuard"></b-form-select>
                                </div>
                                <div class="unlimited-row">
                                    <c-switch class="mx-1" v-model="DGOunlimited" @change.native="useUnlimitedDGO()" color="success" variant="pill" label dataOn="✓" dataOff="✕"/>
                                    <span class="unlimited-label">Use unlimited data</span>
                                </div>
                            </div>
                            <div class="column">
                                <div class="dgo-setting-field">
                                    <h3>Cap</h3>
                                    <label for="">Set New Threshold</label>
                                    <div class="inputs-row">
                                        <input v-model="dgoData.cap.value" :disabled="DGOunlimited" @input="validateCap()" class="form-control" type="number" min="0"/>
                                        <b-form-select v-model="dgoData.cap.unit" :disabled="DGOunlimited" name="" id="" :options="[{value: 'MB', text: 'MB'}, {value: 'GB', text: 'GB'}]"></b-form-select>
                                    </div>
                                    <span :class="['dgo-warn', dgoData.cap.value == 0 || DGOunlimited ? '' : 'hidden']">Leaving cap value as 0 means it will be turned off.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="simSwapStep2 == false && selectedTagsChangeStep2 == false && selectedDGOStep2 == false" class="sims-list-wrapper siot-table-wrapper">
                <div class="siot-table-header">
                    <div class="siot-table-header-left">
                        <div class="siot-table-search">
                            <div class="siot-table-search-field">
                                <input type="text" id="bulkSearch" v-model="filterModal" v-on:keyup="searchKeyUpModal" v-on:keydown="searchKeyDownModal" placeholder="Search">
                            </div>
                        </div>

                        <div class="siot-table-filter">
                            <button class="btn btn-primary filter-btn" id="bulkFilterButton" @click="clickFilters()"><i class="fa fa-filter"></i>Filter</button>
                            <button class="btn btn-primary mobile-sort-btn" @click="shwoHideSort()"><i class="fa fa-sort" aria-hidden="true"></i>Sort</button>
                        </div>

                        <div class="siot-table-toggle">
                            <FTScheckbox v-model="selectedCheckbox" @change.native="getSimsListModal(true)" :label="'Show selected only'"></FTScheckbox>
                        </div>
                    </div>

                    <div class="siot-table-header-right">
                        <div class="siot-table-size">
                            <label for="size-page">Display:</label>
                            <select v-on:change="sizePageModal" v-model="sortSettingsModal.size" id="size-page" class="form-control">
                                <option value="40">40</option>
                                <option value="60">60</option>
                                <option value="80">80</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-if="selectedSimSwap == true" class="siot-table-header-sim-swap">
                    <strong>Select SIM cards that will be swapped. </strong>
                    <p>After selecting SIM cards or drag and drop a list of  SIMs press next to select cold stock SIMs</p>
                </div>
                <div v-if="mobileVisible == true" class="list-mobile">
                    <div v-for="(item, index) in simsList" :data-iccid="item.iccid" v-bind:key="index" :class="['item-mobile', (isSelected(item.iccid)) ? 'selected' : '']" v-on:click="selectRowModal(item.iccid, item.status)">
                        <div class="item-header-mobile">
                            <div v-if="item.carrierId == 1" class="icon-mobile">
                                <img src="../../assets/img/carrier-simon.svg" alt="Simon Carrier Logo">
                            </div>
                            <div v-else-if="item.carrierId == 2" class="icon-mobile">
                                <img src="../../assets/img/carrier-tmobile.svg" alt="Tmobile Carrier Logo">
                            </div>
                            <div v-else-if="item.carrierId == 3" class="icon-mobile">
                                <img src="../../assets/img/carrier-vodafone.svg" alt="Vodafone Carrier Logo">
                            </div>
                            <div class="info-wrapper-mobile">
                                <div class="info-mobile">
                                    <strong>{{item.iccid}}</strong>
                                    <span>Status <em>{{item.status}}</em></span>
                                </div>
                                <div class="tags">
                                    <span class="tag-iterator" v-if="item.tags && item.tags.length == 1">{{item.tags.length}} tag</span>
                                    <span class="tag-iterator" v-else-if="item.tags && item.tags.length > 1">{{item.tags.length}} tags</span>
                                    <span class="tag-iterator" v-else>0 tags</span>
                                </div>
                            </div>
                        </div>
                        <div class="data-table-mobile">
                            <div class="row-mobile msisdn-mobile">
                                <div class="icon-mobile">
                                    <img src="../../assets/img/mobile-icons/mobile-icon14.svg" alt="">
                                </div>
                                <div class="info">
                                    <span class="value">{{item.msisdn}}</span>
                                </div>
                            </div>
                            <div class="row-mobile msisdn-mobile">
                                <div class="icon-mobile">
                                    <img src="../../assets/img/mobile-icons/mobile-icon4.svg" alt="">
                                </div>
                                <div class="info">
                                    <span class="value">{{item.ratePlanName}}</span>
                                </div>
                            </div>
                            <div class="row-mobile msisdn-mobile">
                                <div class="icon-mobile">
                                    <img src="../../assets/img/mobile-icons/mobile-icon11.svg" alt="">
                                </div>
                                <div class="info">
                                    <span class="value" v-if="item.customFields && item.customField1">{{item.customField1}}</span><span class="value" v-else>-</span>
                                </div>
                            </div>
                            <div class="row-mobile msisdn-mobile">
                                <div class="icon-mobile">
                                    <img src="../../assets/img/mobile-icons/mobile-icon11.svg" alt="">
                                </div>
                                <div class="info">
                                    <span class="value" v-if="item.customFields && item.customField2">{{item.customField2}}</span><span class="value" v-else>-</span>
                                </div>
                            </div>
                            <div class="row-mobile msisdn-mobile">
                                <div class="icon-mobile">
                                    <img src="../../assets/img/mobile-icons/mobile-icon9.svg" alt="">
                                </div>
                                <div class="info">
                                    <span class="value">{{item.lastActiveOn}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="siot-table-content mb-0 table-outline table-responsive-sm">
                    <div class="siot-table siot-table-managment-bulk">
                        <table v-if='simsList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi ">
                            <thead role="rowgroup">
                                <tr role="row" :aria-selected="selectedAllModal">
                                    <th role="columnheader" id="bulkSelectAllCheckbox" v-on:click="selectAllRowsModal()" class="small-coll" aria-colindex="0" aria-label="Checkbox"><span class="fts-checkbox"></span></th>
                                    <th v-on:click="changeSort(1)" :aria-sort="setAreaSort(1)">SIM</th>
                                    <th v-on:click="changeSort(2)" :aria-sort="setAreaSort(2)">MSISDN</th>
                                    <th v-on:click="changeSort(3)" :aria-sort="setAreaSort(3)">Status</th>
                                    <th v-if="custom1">{{custom1}}</th>
                                    <th v-if="custom2">{{custom2}}</th>
                                    <th v-on:click="changeSort(6)" :aria-sort="setAreaSort(6)">Carrier</th>
                                    <th role="columnheader" aria-label="Tags">Tags</th>
                                    <th v-on:click="changeSort(7)" :aria-sort="setAreaSort(7)">Last Active</th>
                                    <th v-on:click="changeSort(9)" :aria-sort="setAreaSort(9)">Plan</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) in simsList" :data-iccid="item.iccid" v-bind:key="index" :aria-selected="isSelected(item.iccid)">
                                    <td v-on:click="selectRowModal(item.iccid, item.status)" role="cell" aria-colindex="1" class="small-coll"><span class="fts-checkbox"></span></td>
                                    <td>{{item.iccid}}</td>
                                    <td>{{item.msisdn}}</td>
                                    <td>{{item.status}}</td>
                                    <td><span v-if="item.customFields && item.customField1">{{item.customField1}}</span><span v-else>-</span></td>
                                    <td v-if="custom2"><span v-if="item.customFields && item.customField2">{{item.customField2}}</span><span v-else>-</span></td>
                                    <td>
                                        <span class="carrier-cell" v-if="item.carrierId && item.carrierId == 1">SimonIoT
                                            <span :class="['plan-category-type', item.planCategoryType.categoryName]">{{item.planCategoryType.displayValue}}</span>
                                        </span>
                                        <span v-else-if="item.carrierId && item.carrierId == 2">T-Mobile</span>
                                        <span v-else-if="item.carrierId && item.carrierId == 3">Vodafone</span>
                                        <span v-else-if="item.carrierId && item.carrierId == 4">Kore</span>
                                        <span v-else>-</span>
                                    </td>
                                    <td class="tag-column">
                                        <span @mouseenter="showTags" @mouseleave="hideTags" class="tag-iterator" v-if="item.tags && item.tags.length == 1">{{item.tags.length}} tag</span>
                                        <span @mouseenter="showTags" @mouseleave="hideTags" class="tag-iterator" v-else-if="item.tags && item.tags.length > 1">{{item.tags.length}} tags</span>
                                        <span class="tag-iterator" v-else>0 tags</span>
                                        <p class="tagslist" v-if="item.tags">
                                            <span class="tag" v-for="(tag, key) in item.tags" v-bind:key="key">{{tag}}<em>,</em></span>
                                        </p>
                                    </td>
                                    <td>
                                        <span v-if="item.lastActiveOn">{{item.lastActiveOn}}</span>
                                        <span v-else>-</span>
                                    </td>
                                    <td>{{item.ratePlanName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="loader-sim-list" v-if="loadingSimListModal && noSimsModal == false">
                        <div class="sk-wave">
                            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                        </div>
                    </div>

                    <div class="no-sims upper-no-sims" v-if="loadingSimListModal == false && noSimsModal == true">
                        <h2 class="text">No SIMs are available for the selected plans</h2>
                    </div>
                </div>
                <div class="siot-table-footer">
                    <div class="siot-table-footer-left">
                        <div class="selected-sim">
                            SIMs selected: {{selectedRowsModal.length}}
                        </div>
                    </div>

                    <div class="siot-table-footer-center">
                        <nav v-if="paginationCountModal" aria-label="Page navigation example">
                            <Paginate :page-count="paginationCountModal" v-model="sortSettingsModal.page" :click-handler="paginationControllModal" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'" name="simSwapPaginate"></Paginate>
                        </nav>
                    </div>

                    <div class="siot-table-footer-right">
                        <div class="siot-table-footer-buttons">
                            <b-button v-if="selectedActions == true" class="restore action-element" id="bulkRestoreButton" :disabled="selectedRowsModal.length == 0" variant="success" v-on:click="actionSim('restore')">Restore</b-button>
                            <b-button v-if="selectedActions == true && selectedCarrrier == 1" class="restore action-element" id="bulkReactivationButton" :disabled="selectedRowsModal.length == 0" variant="success" v-on:click="actionSim('reactivate')">Reactivate</b-button>
                            <b-button v-if="selectedActions == true" class="suspend action-element" id="bulkSuspendButton" :disabled="selectedRowsModal.length == 0"  variant="danger" v-on:click="actionSim('suspend')">Suspend</b-button>
                            <b-button v-if="selectedActions == true && selectedCarrrier == 1" :disabled="selectedRowsModal.length == 0" id="bulkDeactiveButton" class="deactive-button action-element" variant="danger" @click="actionSim('deactive')">Deactivate</b-button>
                            <b-button v-if="selectedActions == true && selectedCarrrier == 4" :disabled="selectedRowsModal.length == 0" id="bulkTerminateButton" class="deactive-button action-element" variant="danger" @click="actionSim('terminate')">Terminate</b-button>
                            <b-button v-if="selectedActions == true && selectedCarrrier == 1" :disabled="selectedRowsModal.length == 0" id="bulkResetButton" class="reset-button action-element" variant="danger" v-b-tooltip.hover title="This will force device reconenection to network" v-on:click="actionSim('reset')">Reset SIM Connection</b-button>
                            <b-button v-if="selectedChangePlan == true && selectedCarrrier != 3" @click="actionSim('simonPlanChange')" id="bulkMigrateButton" class="migrate action-element" variant="success" :disabled="(this.selectedPlanTo.id == 0 || this.selectedPlanFrom.id == 0 || selectedRowsModal.length == 0)">Validate</b-button>
                            <b-button v-if="selectedChangePlan == true && selectedCarrrier == 3" @click="actionSim('vodafonePlanChange')" id="bulkMigrateVodafoneButton" class="migrate action-element" variant="success" :disabled="(this.selectedPlanTo.id == 0 || this.selectedPlanFrom.id == 0 || selectedRowsModal.length == 0)">Validate</b-button>
                            <b-button v-if="selectedSimSwap == true" @click="goToSwapSim()" :disabled="this.selectedRowsModal.length == 0" class="next action-element" id="bulkSimSwapNextButton" variant="success">Next</b-button>
                            <b-button v-if="simSwapStep2 == true" variant="success" :disabled="(this.selectedColdStockArr.length == 0)" class="action-element" id="bulkSwapButton" @click="swapColdSims()">Swap</b-button>
                            <b-button v-if="selectedTagsChange == true" variant="success" :disabled="selectedRowsModal.length == 0 || (selectedAddTags.length + selectedRemoveTags.length) == 0" class="action-element" id="bulkTagsButton" @click="bulkTagsChange()">Change Tags</b-button>
                            <b-button v-if="selectedDGO == true" variant="success" :disabled="selectedRowsModal.length == 0 || selectedPlanFrom.id == 0 || (dgoData.throttle.value != 0 && dgoData.speed == 0)" class="action-element" id="bulkDGOButton" @click="bulkDGOWarn()">Apply</b-button>
                            <div v-if="selectedDGO == true" class="hints">
                                <div v-if="dgoData.throttle.value != 0 && dgoData.speed == 0" class="hint">You need to select throttle speed</div>
                                <div v-else-if="selectedPlanFrom.id == 0" class="hint">You need to select plan</div>
                                <div v-else-if="selectedRowsModal.length == 0" class="hint">You need to select at least one SIM</div>
                            </div>
                            <div v-if="selectedCarrrier == 3 && selectedChangeState == true" class="vodafone-change-state-control-box migrate action-element">
                                <span>Select Destination State:</span>
                                <select class="form-control select-state" id="bulkDestinationStateSelect" v-model="selectedState">
                                    <option selected value="">None selected</option>
                                    <option value="ACTIVE_LIVE">Active - Live</option>
                                    <option value="ACTIVE_READY">Active - Ready</option>
                                    <option value="ACTIVE_STANDBY">Active - Standby</option>
                                    <option value="ACTIVE_SUSPEND">Active - Suspend</option>
                                    <option value="INACTIVE_STOPPED">Inactive - Stopped</option>
                                </select>
                                <b-button variant="primary" class="change-state-btn migrate action-element" id="bulkValidateButton" :disabled="selectedRowsModal.length == 0 || selectedState == ''" @click="actionSim(selectedState)">Validate</b-button>
                                <div v-if="selectedRowsModal.length != 0 && selectedState == ''" class="hint-box">
                                    <p>You must select target state from list on the left to change state of SIMs.</p>
                                </div>
                            </div>
                            <div v-if="(selectedPlanTo.id == 0 || selectedPlanFrom.id == 0) || selectedRowsModal.length == 0" class="hint-box">
                                <span v-if="selectedPlanTo.id == 0 || selectedPlanFrom.id == 0">You must select plan to migrate from and plan to migrate to.</span>
                                <span v-else-if="selectedRowsModal.length == 0">You must select SIMs to validate</span>
                            </div>
                        </div>
                        <div :class="['mobile-actions-wrapper', (visiblityActionsButtons == true) ? 'visible-action-buttons' : 'hidden-action-buttons', (selectedCarrrier == 3 && selectedChangeState == true) ? 'selected-vodafone' : '']">
                        <button @click="toggleBulkActions()" :class="['btn', 'btn-primary']">Actions</button>
                        <div v-if="visiblityActionsButtons" class="button-wrapper">
                            <b-button v-if="selectedActions == true" class="restore action-element" id="bulkRestoreButtonMobile" :disabled="selectedRowsModal.length == 0" variant="success" v-on:click="actionSim('restore')">Restore</b-button>
                            <b-button v-if="selectedActions == true && selectedCarrrier == 1" class="restore action-element" id="bulkReactivateButtonMobile" :disabled="selectedRowsModal.length == 0" variant="success" v-on:click="actionSim('reactivate')">Reactivate</b-button>
                            <b-button v-if="selectedActions == true" class="suspend action-element" id="bulkSuspendButtonMobile" :disabled="selectedRowsModal.length == 0"  variant="danger" v-on:click="actionSim('suspend')">Suspend</b-button>
                            <b-button v-if="selectedActions == true && selectedCarrrier == 1" :disabled="selectedRowsModal.length == 0" id="bulkDeactiveButtonMobile" class="deactive-button action-element" variant="danger" @click="actionSim('deactive')">Deactivate</b-button>
                            <b-button v-if="selectedActions == true && selectedCarrrier == 1" :disabled="selectedRowsModal.length == 0" id="bulkResetButtonMobile" class="reset-button action-element" variant="danger" v-b-tooltip.hover title="This will force device reconenection to network" v-on:click="actionSim('reset')">Reset SIM Connection</b-button>
                            <b-button v-if="selectedChangePlan == true && selectedCarrrier != 3" @click="actionSim('simonPlanChange')" id="bulkMigrateButtonMobile" class="migrate action-element" variant="success" :disabled="(this.selectedPlanTo.id == 0 || this.selectedPlanFrom.id == 0)">Validate</b-button>
                            <b-button v-if="selectedChangePlan == true && selectedCarrrier == 3" @click="actionSim('vodafonePlanChange')" id="bulkMigrateVodafoneButtonMobile" class="migrate action-element" variant="success" :disabled="(this.selectedPlanTo.id == 0 || this.selectedPlanFrom.id == 0)">Validate</b-button>
                            <b-button v-if="selectedSimSwap == true" @click="goToSwapSim()" :disabled="this.selectedRowsModal.length == 0" class="next action-element" id="bulkSimSwapNextButtonMobile" variant="success">Next</b-button>
                            <b-button v-if="simSwapStep2 == true" variant="success" :disabled="(this.selectedColdStockArr.length == 0)" class="action-element" id="bulkSwapButtonMobile" @click="swapColdSims()">Swap</b-button>
                            <b-button v-if="selectedTagsChange == true" variant="success" :disabled="selectedRowsModal.length == 0 || (selectedAddTags.length + selectedRemoveTags.length) == 0" class="action-element" id="bulkTagsButtonMobile" @click="bulkTagsChange()">Change Tags</b-button>
                            <b-button v-if="selectedDGO == true" variant="success" :disabled="selectedRowsModal.length == 0 || selectedPlanFrom.id == 0 || (dgoData.throttle.value != 0 && dgoData.speed == 0)" class="action-element" id="bulkDGOButton" @click="bulkDGOWarn()">Apply</b-button>
                        </div>
                        <div v-if="selectedCarrrier == 3 && selectedChangeState == true" class="vodafone-change-state-control-box">
                            <div class="select-wrapper">
                                <span>Select Destination State:</span>
                                <select class="form-control select-state action-element" id="bulkDestinationStateSelectMobile" @change="logIt()" v-model="selectedState">
                                    <option selected value="">None selected</option>
                                    <option value="ACTIVE_LIVE">Active - Live</option>
                                    <option value="ACTIVE_READY">Active - Ready</option>
                                    <option value="ACTIVE_STANDBY">Active - Standby</option>
                                    <option value="ACTIVE_SUSPEND">Active - Suspend</option>
                                    <option value="INACTIVE_STOPPED">Inactive - Stopped</option>
                                </select>
                            </div>
                            <b-button variant="primary" class="change-state-btn action-element" id="bulkValidateButtonMobile" :disabled="selectedRowsModal.length == 0 || selectedState == ''" @click="actionSim(selectedState)">Validate</b-button>
                            <div v-if="selectedRowsModal.length != 0 && selectedState == ''" class="hint-box">
                                <p>You must select target state from list on the left to change state of SIMs.</p>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

            </div>

            <div v-if="simSwapStep2 == true" class="cold-stock-list-wrapper">
                <div class="siot-table-wrapper">
                    <div class="siot-table-header">
                        <div class="siot-table-header-left">
                            <div class="siot-table-search">
                                <div class="siot-table-search-field">
                                    <input type="text" v-model="filterColdStock" v-on:keyup="searchKeyUpColdStock" v-on:keydown="searchKeyDownColdStock" placeholder="Search">
                                </div>
                            </div>
                        </div>

                        <div class="siot-table-header-right">
                            <div class="siot-table-size">
                                <label for="size-page">Display:</label>
                                <select v-on:change="sizePageColdStock" v-model="sortSettingsColdStock.size" id="size-page" class="form-control">
                                    <option value="40">40</option>
                                    <option value="60">60</option>
                                    <option value="80">80</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div v-if="mobileVisible == true" class="cold-stock-mobile">
                        <div class="list-mobile">
                            <div :class="['item-mobile', (isSelectedColdStock(item.iccid)) ? 'selected' : '']" v-for="(item, index) in coldStockList" v-on:click="selectRowColdStock(item.iccid)" :data-iccid="item.iccid" v-bind:key="index">
                                <div class="item-header-mobile">
                                    <div class="icon">
                                        <img v-if="item.carrierId == 1" src="../../assets/img/carrier-simon.svg"/>
                                        <img v-else-if="item.carrierId == 2" src="../../assets/img/carrier-tmobile.svg"/>
                                        <img v-else-if="item.carrierId == 3" src="../../assets/img/carrier-vodafone.svg"/>
                                        <img v-else src="../../assets/img/carrier-simon.svg"/>
                                    </div>

                                    <div class="info-wrapper-mobile">
                                        <div class="info-mobile">
                                            <strong>{{item.iccid}}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="siot-table-content">
                        <div class="siot-table table-coldstock">
                            <table  v-if='coldStockList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi">
                                <thead role="rowgroup">
                                    <tr role="row" :aria-selected="selectedAllColdStock">
                                        <th v-on:click="selectAllRowsColdStock" role="columnheader" class="small-coll" aria-colindex="0" aria-label="Checkbox">
                                            <span class="fts-checkbox"></span>
                                        </th>
                                        <th role="columnheader" aria-colindex="1" aria-label="SIM">SIM</th>
                                        <th role="columnheader" aria-colindex="2" aria-label="Carrier">Carrier</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, index) in coldStockList" :data-iccid="item.iccid" :aria-selected="isSelectedColdStock(item.iccid)" v-bind:key="index">
                                        <td v-on:click="selectRowColdStock(item.iccid)" role="cell" aria-colindex="1" class="small-coll"><span class="fts-checkbox"></span></td>
                                        <td>{{item.iccid}}</td>
                                        <td>
                                            <span v-if="item.carrierId == 1">SimonIoT</span>
                                            <span v-else-if="item.carrierId == 2">T-Mobile</span>
                                            <span v-else-if="item.carrierId == 3">Vodafone</span>
                                            <span v-else>--</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="loader-sim-list" v-if="loadingColdSims == true && noColdStock == false">
                            <div class="sk-wave">
                                <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                            </div>
                        </div>

                        <div class="no-sims" v-if="loadingColdSims == false && noColdStock == true">
                            <h2 class="text">You have no Cold SIMs</h2>
                        </div>
                    </div>
                    <div class="siot-table-footer">
                        <div class="siot-table-footer-left">
                            <div class="selected-sim">
                                SIMs selected: {{selectedColdStockArr.length}}
                            </div>
                        </div>

                        <div class="siot-table-footer-center">
                            <nav v-if="paginationCountColdStock" aria-label="Page navigation example">
                                <Paginate :page-count="paginationCountColdStock" :click-handler="paginationControllColdStock" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'" name="ColdStockPaginate"></Paginate>
                            </nav>
                        </div>

                        <div class="siot-table-footer-right">
                            <div class="siot-table-footer-buttons">
                                <b-button v-if="selectedActions == true" class="restore action-element" variant="success" v-on:click="actionSim('restore')">Restore</b-button>
                                <b-button v-if="selectedActions == true" class="suspend action-element"  variant="danger" v-on:click="actionSim('suspend')">Suspend</b-button>
                                <b-button v-if="selectedActions == true" class="reset-button action-element" variant="danger" v-b-tooltip.hover title="This will force device reconenection to network" v-on:click="actionSim('reset')">Reset</b-button>
                                <b-button v-if="selectedSimSwap == true && simSwapStep2 == true" class="cancel action-element" variant="light" v-on:click="backToSwapStep1()">Back</b-button>
                                <b-button v-if="selectedChangePlan == true" @click="changeRatePlan()" class="migrate action-element" variant="success" :disabled="(this.selectedPlanTo.id == 0 || this.selectedPlanFrom.id == 0)">Migrate</b-button>
                                <b-button v-if="selectedSimSwap == true && simSwapStep2 == false" @click="goToSwapSim()" :disabled="this.selectedRowsModal.length == 0" class="next action-element" variant="success">Next</b-button>
                                <b-button v-if="simSwapStep2 == true" variant="success" class="action-element" :disabled="(this.selectedColdStockArr.length == 0)" @click="swapColdSims()">Swap</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sim-action-validation" v-if="simActionValidation">
            <h3>Bulk operations</h3>
            <h4>Validation for: {{simAction.title}}</h4>
            <div class="validation-passed">
                <div class="validation-passed-header" @click="validationPassedExpand()">
                    <h3>Sim Cards that can be {{simAction.type}} ({{simsPassedValidation.iccids.length}}/{{selectedRowsModal.length}})</h3>
                    <i :class="['fa', validationPassedExpanded ? 'fa-angle-down' : 'fa-angle-left']"></i>
                </div>
                <div v-if="validationPassedExpanded" class="validation-passed-simlist">
                    <div v-for="sim of simsPassedValidation.iccids" class="sim">
                        <i class="fts-icon-sim"></i>
                        {{sim}}
                        <i class="fa fa-close remove-sim-icon" @click="removeSimFromValidList(sim)"></i>
                    </div>
                </div>
            </div>
            <div v-if="simsFailedValidationCount > 0" class="validation-failed">
                <div class="validation-failed-header" @click="validationFailedExpand()">
                    <h3>Sim Cards that can not be {{simAction.type}} ({{simsFailedValidationCount}}/{{selectedRowsModal.length}})</h3>
                    <i :class="['fa', validationFailedExpanded ? 'fa-angle-down' : 'fa-angle-left']"></i>
                </div>
                <div v-for="(failedSims, i) of simsFailedValidation" v-if="validationFailedExpanded" :class="['validation-failed-category', failedSims.iccids.length == 0 ? 'hidden-list' : '']">
                    <h3>{{failedSims.groupName}}</h3>
                    <h4>{{failedSims.groupDescription}}</h4>
                    <div class="validation-failed-simlist">
                        <div v-for="sim of failedSims.iccids" class="sim">
                            <i class="fts-icon-sim"></i>
                            {{sim}}
<!--                            <i class="fa fa-close remove-sim-icon"@click="removeSimFromInvalidList(sim, i)"></i>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="sim-action-control-bar">
                <button class="btn btn-light" @click="goBack()">Back</button>
                <button class="btn btn-primary" @click="showExportSelect()">Export list of SIMs</button>
                <button class="btn btn-success capitalize" :disabled="simsPassedValidation.iccids.length == 0" @click="confirmAction()">{{simAction.button}} ({{simsPassedValidation.iccids.length}})</button>
            </div>
            <div class="loader-sim-list" v-if="loadingValidation">
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>
            </div>
        </div>
        <div v-if="selectedTagsChangeStep2" class="change-tags-summary">
            <h1>Bulk Operations - Tags Summary</h1>
            <div class="summary-boxes">
                <div class="summary-box">
                    <h3>{{tagsResponse.totalSims}}</h3>
                    <h5>Total SIMs</h5>
                </div>
                <div class="summary-box">
                    <h3>{{tagsResponse.simsToUpdate}}</h3>
                    <h5>SIMs Will be updated</h5>
                </div>
                <div class="summary-box">
                    <h3>{{tagsResponse.tagsToBeAdded}}</h3>
                    <h5>Tags will be Added</h5>
                </div>
                <div class="summary-box">
                    <h3>{{tagsResponse.tagsToBeRemoved}}</h3>
                    <h5>Tags will be Removed</h5>
                </div>
                <div class="summary-box">
                    <h3>{{tagsResponse.notAffectedSims}}</h3>
                    <h5>SIMs not affected</h5>
                </div>
            </div>

            <div class="sims-list-wrapper siot-table-wrapper">
                <div v-if="mobileVisible == true" class="list-mobile">
                    <div v-for="(item, index) in tagsResponse.tagChangeItems" :data-iccid="item.iccid" v-bind:key="index" class="item-mobile">
                        <div class="item-header-mobile">
                            <div v-if="item.carrierId == 1" class="icon-mobile">
                                <img src="../../assets/img/carrier-simon.svg" alt="Simon Carrier Logo">
                            </div>
                            <div v-else-if="item.carrierId == 2" class="icon-mobile">
                                <img src="../../assets/img/carrier-tmobile.svg" alt="Tmobile Carrier Logo">
                            </div>
                            <div v-else-if="item.carrierId == 3" class="icon-mobile">
                                <img src="../../assets/img/carrier-vodafone.svg" alt="Vodafone Carrier Logo">
                            </div>
                            <div class="info-wrapper-mobile">
                                <div class="info-mobile">
                                    <strong>{{item.iccid}}</strong>
                                </div>
                            </div>
                            <div class="data-table-mobile">
                                <div class="row-mobile">
                                    <div class="icon-mobile">
                                        <img src="../../assets/img/bulk-plus-icon.svg" alt="">
                                    </div>
                                    <div class="info">
                                        <span class="name">Tags that will be added</span>
                                        <span class="value">{{item.tagsToBeAdded.length}}</span>
                                    </div>
                                </div>
                                <div class="row-mobile">
                                    <div class="icon-mobile">
                                        <img src="../../assets/img/bulk-minus-icon.svg" alt="">
                                    </div>
                                    <div class="info">
                                        <span class="name">Tags that will be removed</span>
                                        <span class="value">{{item.tagsToBeRemoved.length}}</span>
                                    </div>
                                </div>
                                <div class="row-mobile tags-list">
                                    <div class="icon-mobile">
                                        <img src="../../assets/img/bulk-added-icon.svg" alt="">
                                    </div>
                                    <div class="info">
                                        <span class="name">Tags before edit</span>
                                        <span class="value" v-if="item.tagsBefore.length">
                                            <span v-for="tag in item.tagsBefore">{{tag}}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="row-mobile tags-list">
                                    <div class="icon-mobile">
                                        <img src="../../assets/img/bulk-removed-icon.svg" alt="">
                                    </div>
                                    <div class="info">
                                        <span class="name">Tags after edit</span>
                                        <span class="value" v-if="item.tagsAfter.length">
                                            <span v-for="tag in item.tagsAfter">{{tag}}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="siot-table-content mb-0 table-outline table-responsive-sm">
                    <div class="siot-table">
                        <table v-if='tagsResponse.tagChangeItems.length > 0' class="table b-table table-striped table-hover table-tags">
                            <thead role="rowgroup">
                                <tr role="row">
                                    <th>SIM</th>
                                    <th>Tags that will be added</th>
                                    <th>Tags that will be removed</th>
                                    <th>Tags Before Edit</th>
                                    <th>Tags After Edit</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) in tagsResponse.tagChangeItems" :data-iccid="item.iccid" v-bind:key="index">
                                    <td>{{item.iccid}}</td>
                                    <td class="tags-added-removed"><span v-for="tag in item.tagsToBeAdded">{{tag}}</span></td>
                                    <td class="tags-added-removed"><span v-for="tag in item.tagsToBeRemoved">{{tag}}</span></td>
                                    <td class="tags-after-before">
                                        <span class="tags-label">
                                            {{item.tagsBefore.length}} tags
                                            <div v-if="item.tagsBefore.length" class="tags-hint">
                                                <span v-for="tag in item.tagsBefore">{{tag}}</span>
                                            </div>
                                        </span>
                                    </td>
                                    <td class="tags-after-before">
                                        <span class="tags-label">
                                            {{item.tagsAfter.length}} tags
                                            <div v-if="item.tagsAfter.length" class="tags-hint">
                                                <span v-for="tag in item.tagsAfter">{{tag}}</span>
                                            </div>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="siot-table-footer">
                <div class="siot-table-footer-right">
                    <button class="btn btn-light" @click="backToTagsStep1()">Back</button>
                    <button class="btn btn-primary" :disabled="tagsResponse.simsToUpdate == 0" @click="openTagsExportModal()">Export SIMs</button>
                    <button class="btn btn-primary action-element" :disabled="tagsResponse.simsToUpdate == 0" @click="applyTagsChange()">Apply</button>
                </div>
            </div>
        </div>
        <div v-if="selectedDGOStep2" class="dgo-summary sim-action-validation">
            <h1>Bulk Operations - Data Guard Override</h1>
            <div class="dgo-summary-box">
                <div v-if="simsPassedValidation.iccids.length > 0" class="validation-passed">
                    <div class="validation-passed-header" @click="validationPassedExpand()">
                        <h3>Ready for Data Guard Override</h3>
                        <i :class="['fa', validationPassedExpanded ? 'fa-angle-down' : 'fa-angle-left']"></i>
                    </div>
                    <div v-if="validationPassedExpanded" class="validation-passed-simlist">
                        <div v-for="sim of simsPassedValidation.iccids" class="sim">
                            <i class="fts-icon-sim"></i>
                            {{sim}}
                            <i class="fa fa-close remove-sim-icon" @click="removeSimFromValidList(sim)"></i>
                        </div>
                    </div>
                </div>
                <div v-if="simsWarningValidationCount > 0" class="validation-failed">
                    <div class="validation-failed-header" @click="validationWarningExpand()">
                        <h3>Conflicted SIMs ready for Data Guard Override</h3>
                        <i :class="['fa', validationWarningExpanded ? 'fa-angle-down' : 'fa-angle-left']"></i>
                    </div>
                    <div v-for="(warningSims, i) of simsWarningValidation" v-if="validationWarningExpanded" :class="['validation-failed-category', warningSims.iccids.length == 0 ? 'hidden-list' : '']">
                        <h3>{{warningSims.groupName}}</h3>
                        <h4>{{warningSims.groupDescription}}</h4>
                        <div class="validation-failed-simlist">
                            <div v-for="sim of warningSims.iccids" class="sim">
                                <i class="fts-icon-sim"></i>
                                {{sim}}
                                <i class="fa fa-close remove-sim-icon"@click="removeSimFromWarningList(sim, i)"></i>
                            </div>
                        </div>
                    </div>
                </div><div v-if="simsFailedValidationCount > 0" class="validation-failed">
                    <div class="validation-failed-header" @click="validationFailedExpand()">
                        <h3>Invalid SIMs</h3>
                        <i :class="['fa', validationFailedExpanded ? 'fa-angle-down' : 'fa-angle-left']"></i>
                    </div>
                    <div v-for="(failedSims, i) of simsFailedValidation" v-if="validationFailedExpanded" :class="['validation-failed-category', failedSims.iccids.length == 0 ? 'hidden-list' : '']">
                        <h3>{{failedSims.groupName}}</h3>
                        <h4>{{failedSims.groupDescription}}</h4>
                        <div class="validation-failed-simlist">
                            <div v-for="sim of failedSims.iccids" class="sim">
                                <i class="fts-icon-sim"></i>
                                {{sim}}
                                <!--                            <i class="fa fa-close remove-sim-icon"@click="removeSimFromInvalidList(sim, i)"></i>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sim-action-control-bar">
                <button class="btn btn-light" @click="goBackDGO()">Back</button>
                <button class="btn btn-primary" @click="showExportSelect()">Export list of SIMs</button>
                <button class="btn btn-success capitalize action-element" :disabled="simsPassedValidation.iccids.length == 0" @click="applyDGO()">Override</button>
            </div>
            <div class="loader-sim-list" v-if="loadingValidation">
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>
            </div>
        </div>

        <b-modal centered id="select-from-plan" ref="select-from-plan" size="xl" :title="selectedChangePlan ? 'Select Plan that you want to Migrate from' : 'Select Plan that you want to pick SIMs to Data Guard Override'" hide-footer>
            <div class="search-row">
                <div class="FTSsearch">
                    <i class="fa fa-search"></i>
                    <input type="text" v-model="searchPlanFrom" placeholder="Search"/>
                </div>
            </div>
            <div class="modal-content">
                <div v-if="((templateLists.length > 0 && selectedCarrrier == 1) || (selectedCarrrier == 2 && ratePlanAssigned.length > 0) || (selectedCarrrier == 3 && vodafoneRatePlanAssigned.length > 0)) && !loading" class="templates-wrap" id="templates-wrap">
                    <div v-if="selectedCarrrier == 1" class="simon-plans plans-list">
                        <div v-for="(templateItem, index) in templateLists" :key="templateItem.id" :id="'template-' + templateItem.id"
                            :class="[
                                'template-item',
                                'action-element',
                                templateItem.categoryClass,
                                (templateItem.categoryClass == 'nb-iot') ? 'plan-hidden' : '',
                                (templateItem.id == selectedPlanTo.id) ? 'plan-hidden' : '',
                                plansFiltered && templateItem.simsCount == false ? 'plan-filtered' : '',
                                searchPlanFrom != '' && filterPlansFrom(templateItem.name) ? 'plan-hidden' : '',
                                (selectedPlanTo.category && (templateItem.categoryClass != selectedPlanTo.category)) ? 'plan-hidden' : '',
                                selectedPlanFrom.id == templateItem.id ? 'plan-selected' : ''
                                ]" @click="selectPlanFrom(templateItem.id, 1, templateItem.simsCount, templateItem.simsInPlan, templateItem.name, templateItem.categoryClass)">
                            <div v-if="templateItem.simsCount" class="sims-available">
                                {{templateItem.simsCount}}/{{selectedRowsModal.length}} SIMs from the uploaded SIM list are available to be used with this plan
                            </div>
                            <div class="inner-template">
                                <div class="carrier-logo simon">
                                    <img v-if="templateItem.categoryClass == 'flex'" src="../../assets/img/simon-logo-flex.svg" alt="">
                                    <img v-else-if="templateItem.categoryClass == 'nb-iot'" src="../../assets/img/simon-logo-nb-iot.svg" alt="">
                                    <img v-else-if="templateItem.categoryClass == 'cat-m1'" src="../../assets/img/simon-logo-m1.svg" alt="">
                                    <img v-else src="../../assets/img/darklogo.svg" alt="">
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.name }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <span class="name">{{ templateItem.category }}</span>
                                            <span class="value">{{ templateItem.dataLimit }}</span>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">International Roaming</span>
                                                <span class="value" v-if="templateItem.planOptions.hasRoaming == 'ON' || templateItem.planOptions.hasRoaming2 == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Voice</span>
                                                <span class="value" v-if="templateItem.planOptions.hasVoice == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Data Pooling</span>
                                                <span class="value" v-if="templateItem.planOptions.dataPooling == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">SMS</span>
                                                <span class="value" v-if="templateItem.planOptions.sms == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.planOptions.staticIp == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div v-if="hotSpotVisible" class="option">
                                                <span class="name">Hot Spot</span>
                                                <span class="value" v-if="templateItem.planOptions.hotSpot == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Throttle</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleAt && templateItem.dataGuard.throttleAtUnit">{{templateItem.dataGuard.throttleAt}} {{templateItem.dataGuard.throttleAtUnit}}</span>
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleSpeed">{{templateItem.dataGuard.throttleSpeed}}</span>
                                                    <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>

                                            <div class="option">
                                                <span class="name">Cap</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap && templateItem.dataGuard.capAt && templateItem.dataGuard.capAtUnit">{{templateItem.dataGuard.capAt}} {{templateItem.dataGuard.capAtUnit}}</span>
                                                    <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                            <div class="option">
                                                <span class="name">Alert 1</span>
                                                <div class="wrap-value">
                                                    <span class="value" v-if="templateItem.fistAlertAtMb && templateItem.fistAlertAtMb != 0"><span class="value-in-mb">{{templateItem.fistAlertAtMb}}</span> ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                            <div class="option">
                                                <span class="name">Alert 2</span>
                                                <div class="wrap-value">
                                                    <span class="value" v-if="templateItem.secondAlertAtMb && templateItem.secondAlertAtMb != 0"><span class="value-in-mb">{{templateItem.secondAlertAtMb}}</span> ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="down">
                                            <div class="description">
                                                <span class="name">Plan Description</span>
                                                <span class="value">{{templateItem.description}}</span>
                                            </div>

                                            <div v-if="templateItem.planPrice" class="price-plan-wrapper">
                                                <div class="start-price">
                                                    <span>Start Price</span>
                                                    <em>${{templateItem.planPrice.basePrice.toFixed(2)}}</em>
                                                </div>

                                                <div class="static-ip">
                                                    <span>Static IP</span>
                                                    <em>${{templateItem.planPrice.staticIpCharge.toFixed(2)}}</em>
                                                </div>

                                                <div v-if="templateItem.planOptions.sms == 'ON'" class="sms-price">
                                                    <span>SMS Price</span>
                                                    <em>${{templateItem.planPrice.smsCharge.toFixed(2)}}</em>
                                                </div>

                                                <div class="overage-price">
                                                    <span>Overage</span>
                                                    <em>${{templateItem.planPrice.discountedRatePerOverageMb.toFixed(2)}}</em>
                                                </div>

                                                <div v-if="templateItem.planPrice.custom == false" class="discount">
                                                    <span>Discount</span>
                                                    <em>- {{templateItem.planPrice.companyDiscount*100}}%</em>
                                                </div>

                                                <div class="cost-per-sim">
                                                    <span>Cost per SIM</span>
                                                    <em>${{templateItem.planPrice.discountedBasePrice.toFixed(2)}}</em>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedCarrrier == 2" class="tmobile-plans plans-list">
                        <div v-for="(templateItem, index) in ratePlanAssigned" v-bind:key="index" :id="'template-' + templateItem.ratePlanId" :data-ratePlanId="templateItem.ratePlanId" :class="['template-item', 'action-element', 'flex', plansFiltered && templateItem.simsCount == false ? 'plan-filtered' : '', templateItem.ratePlanId == selectedPlanTo.id ? 'plan-hidden' : '', searchPlanFrom != '' && filterPlansFrom(templateItem.planName) ? 'plan-hidden' : '', selectedPlanFrom.id == templateItem.ratePlanId ? 'plan-selected' : '']" @click="selectPlanFrom(templateItem.ratePlanId, 2, false)">
                            <div v-if="templateItem.simsCount" class="sims-available">
                                {{templateItem.simsCount}}/{{selectedRowsModal.length}} SIMs from the uploaded SIM list are available to be used with this plan
                            </div>
                            <div class="inner-template">
                                <div class="carrier-logo tmobile">
                                    <img src="../../assets/img/magenta-logo.svg" alt="">
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.planName }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <div class="name">{{ templateItem.planCategory.category }}</div>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.staticIp">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="down">
                                        <div class="description">
                                            <span class="name">Plan Description</span>
                                            <span v-if="templateItem.planDescription" class="value">{{templateItem.planDescription}}</span>
                                            <span v-else class="value">--</span>
                                        </div>

                                        <div class="price">
                                            <span class="name">Cost Per Line</span>
                                            <span v-if="templateItem.customUnitPrice" class="value">{{templateItem.customUnitPrice}}</span>
                                            <span v-else class="value">--</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedCarrrier == 3" class="vodafone-plans plans-list">
                        <div v-for="(templateItem, index) in vodafoneRatePlanAssigned" v-bind:key="index" :id="'template-' + templateItem.ratePlanId" :data-ratePlanId="templateItem.ratePlanId" :class="['template-item', 'action-element', 'vodafone', plansFiltered && templateItem.simsCount == false ? 'plan-filtered' : '', templateItem.ratePlanId == selectedPlanTo.id ? 'plan-hidden' : '', searchPlanFrom != '' && filterPlansFrom(templateItem.planName) ? 'plan-hidden' : '', selectedPlanFrom.id == templateItem.ratePlanId ? 'plan-selected' : '']" @click="selectPlanFrom(templateItem.ratePlanId, 3, templateItem.simsCount, templateItem.simsInPlan, templateItem.planName, false)">
                            <div v-if="templateItem.simsCount" class="sims-available">
                                {{templateItem.simsCount}}/{{selectedRowsModal.length}} SIMs from the uploaded SIM list are available to be used with this plan
                            </div>
                            <div class="inner-template">
                                <div class="carrier-logo vodafone">
                                    <img src="../../assets/img/vodafone-logo-white.svg" alt="">
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.planName }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <div class="name">{{ templateItem.planCategory.planCategoryName }}</div>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">Data Limit</span>
                                                <span class="value" v-if="templateItem.dataLimit">{{templateItem.dataLimit.dataLimitName}}</span>
                                                <span class="value" v-else>--</span>
                                            </div>
                                            <div class="option">
                                                <span class="name">IMEI Match Rule</span>
                                                <span class="value" v-if="templateItem.imeiMatch">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>
                                            <div class="option">
                                                <span class="name">APN</span>
                                                <span class="value" v-if="templateItem.provisioningProfile">{{templateItem.provisioningProfile.apnType}}</span>
                                                <span class="value" v-else>--</span>
                                            </div>
                                            <div class="option">
                                                <span class="name">Provisioning Profile</span>
                                                <span class="value" v-if="templateItem.provisioningProfile">{{templateItem.provisioningProfile.profileName}}</span>
                                                <span class="value" v-else>--</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="down">
                                        <div class="description">
                                            <span class="name">Plan Description</span>
                                            <span v-if="templateItem.planDescription" class="value">{{templateItem.planDescription}}</span>
                                            <span v-else class="value">--</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="templates-wrap no-templates text-center">
                    <p>No plans have been made. Click here to here make a plan. </p>
                    <button class="btn btn-success" v-on:click="goToCreatePlan"><i class="fa fa-plus"></i>Add New Plan</button>
                </div>
            </div>
            <div class="loader-plans-list" v-if="loadingPlans">
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>
            </div>
        </b-modal>
        <b-modal centered id="select-to-plan" ref="select-to-plan" size="xl" title="Select Plan that you want to Migrate to" hide-footer>
            <div class="search-row">
                <div class="FTSsearch">
                    <i class="fa fa-search"></i>
                    <input type="text" v-model="searchPlanTo" placeholder="Search"/>
                </div>
            </div>
            <div class="modal-content">
                <div v-if="((templateLists.length > 0 && selectedCarrrier == 1) || (selectedCarrrier == 2 && ratePlanAssigned.length > 0) || (selectedCarrrier == 3 && vodafoneRatePlanAssigned.length > 0)) && !loading" class="templates-wrap" id="templates-wrap">
                    <div v-if="selectedCarrrier == 1" class="simon-plans">
                        <div v-for="(templateItem, index) in templateLists" :key="templateItem.id" :id="'template-' + templateItem.id"
                            :class="[
                                'template-item',
                                'action-element',
                                templateItem.categoryClass,
                                (templateItem.active == 1) ? 'plan-active' : 'plan-hidden',
                                (templateItem.categoryClass != 'flex' && selectedPlans == 3) ? 'plan-hidden' : '',
                                (templateItem.categoryClass != 'highbandwidth' && selectedPlans == 4) ? 'plan-hidden' : '',
                                (templateItem.categoryClass == 'nb-iot') ? 'plan-hidden' : '',
                                (templateItem.id == selectedPlanFrom.id) ? 'plan-hidden' : '',
                                (selectedPlanFrom.category && (templateItem.categoryClass != selectedPlanFrom.category)) ? 'plan-hidden' : '',
                                searchPlanTo != '' && filterPlansTo(templateItem.name) ? 'plan-hidden' : '',
                                selectedPlanTo.id == templateItem.id ? 'plan-selected' : ''
                                ]"  @click="selectPlanTo(templateItem.id, 1, templateItem.name, templateItem.categoryClass)">
                            <div class="inner-template">
                                <div class="carrier-logo simon">
                                    <img v-if="templateItem.categoryClass == 'flex'" src="../../assets/img/simon-logo-flex.svg" alt="">
                                    <img v-else-if="templateItem.categoryClass == 'nb-iot'" src="../../assets/img/simon-logo-nb-iot.svg" alt="">
                                    <img v-else-if="templateItem.categoryClass == 'cat-m1'" src="../../assets/img/simon-logo-m1.svg" alt="">
                                    <img v-else src="../../assets/img/darklogo.svg" alt="">
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.name }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <span class="name">{{ templateItem.category }}</span>
                                            <span class="value">{{ templateItem.dataLimit }}</span>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">International Roaming</span>
                                                <span class="value" v-if="templateItem.planOptions.hasRoaming == 'ON' || templateItem.planOptions.hasRoaming2 == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Voice</span>
                                                <span class="value" v-if="templateItem.planOptions.hasVoice == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Data Pooling</span>
                                                <span class="value" v-if="templateItem.planOptions.dataPooling == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">SMS</span>
                                                <span class="value" v-if="templateItem.planOptions.sms == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.planOptions.staticIp == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div v-if="hotSpotVisible" class="option">
                                                <span class="name">Hot Spot</span>
                                                <span class="value" v-if="templateItem.planOptions.hotSpot == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Throttle</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleAt && templateItem.dataGuard.throttleAtUnit">{{templateItem.dataGuard.throttleAt}} {{templateItem.dataGuard.throttleAtUnit}}</span>
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleSpeed">{{templateItem.dataGuard.throttleSpeed}}</span>
                                                    <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>

                                            <div class="option">
                                                <span class="name">Cap</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap && templateItem.dataGuard.capAt && templateItem.dataGuard.capAtUnit">{{templateItem.dataGuard.capAt}} {{templateItem.dataGuard.capAtUnit}}</span>
                                                    <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                            <div class="option">
                                                <span class="name">Alert 1</span>
                                                <div class="wrap-value">
                                                    <span class="value" v-if="templateItem.fistAlertAtMb && templateItem.fistAlertAtMb != 0"><span class="value-in-mb">{{templateItem.fistAlertAtMb}}</span> ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                            <div class="option">
                                                <span class="name">Alert 2</span>
                                                <div class="wrap-value">
                                                    <span class="value" v-if="templateItem.secondAlertAtMb && templateItem.secondAlertAtMb != 0"><span class="value-in-mb">{{templateItem.secondAlertAtMb}}</span> ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="down">
                                            <div class="description">
                                                <span class="name">Plan Description</span>
                                                <span class="value">{{templateItem.description}}</span>
                                            </div>

                                            <div v-if="templateItem.planPrice" class="price-plan-wrapper">
                                                <div class="start-price">
                                                    <span>Start Price</span>
                                                    <em>${{templateItem.planPrice.basePrice.toFixed(2)}}</em>
                                                </div>

                                                <div v-if="templateItem.planOptions.staticIp == 'ON'" class="static-ip">
                                                    <span>Static IP</span>
                                                    <em>${{templateItem.planPrice.staticIpCharge.toFixed(2)}}</em>
                                                </div>

                                                <div v-if="templateItem.planOptions.sms == 'ON'" class="sms-price">
                                                    <span>SMS Price</span>
                                                    <em>${{templateItem.planPrice.smsCharge.toFixed(2)}}</em>
                                                </div>

                                                <div class="overage-price">
                                                    <span>Overage</span>
                                                    <em>${{templateItem.planPrice.discountedRatePerOverageMb.toFixed(2)}}</em>
                                                </div>

                                                <div v-if="templateItem.planPrice.custom == false" class="discount">
                                                    <span>Discount</span>
                                                    <em>- {{templateItem.planPrice.companyDiscount*100}}%</em>
                                                </div>

                                                <div class="cost-per-sim">
                                                    <span>Cost per SIM</span>
                                                    <em>${{templateItem.planPrice.discountedBasePrice.toFixed(2)}}</em>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedCarrrier == 2" class="tmobile-plans plans-list">
                        <div v-for="(templateItem, index) in ratePlanAssigned" v-bind:key="index" :id="'template-' + templateItem.ratePlanId" :data-ratePlanId="templateItem.ratePlanId" :class="['template-item', 'action-element', 'flex', templateItem.ratePlanId == selectedPlanFrom.id ? 'plan-hidden' : '', searchPlanTo != '' && filterPlansTo(templateItem.name) ? 'plan-hidden' : '', selectedPlanTo.id == templateItem.ratePlanId ? 'plan-selected' : '']" @click="selectPlanTo(templateItem.ratePlanId, 2, false)">
                            <div class="inner-template">
                                <div class="carrier-logo tmobile">
                                    <img src="../../assets/img/magenta-logo.svg" alt="">
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.planName }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <div class="name">{{ templateItem.planCategory.category }}</div>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.staticIp">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="down">
                                        <div class="description">
                                            <span class="name">Plan Description</span>
                                            <span v-if="templateItem.planDescription" class="value">{{templateItem.planDescription}}</span>
                                            <span v-else class="value">--</span>
                                        </div>

                                        <div class="price">
                                            <span class="name">Cost Per Line</span>
                                            <span v-if="templateItem.customUnitPrice" class="value">{{templateItem.customUnitPrice}}</span>
                                            <span v-else class="value">--</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedCarrrier == 3" class="vodafone-plans plans-list">
                        <div v-for="(templateItem, index) in vodafoneRatePlanAssigned" v-bind:key="index" :id="'template-' + templateItem.ratePlanId" :data-ratePlanId="templateItem.ratePlanId" :class="['template-item', 'action-element', 'flex', templateItem.ratePlanId == selectedPlanFrom.id ? 'plan-hidden' : '', searchPlanTo != '' && filterPlansTo(templateItem.planName) ? 'plan-hidden' : '', ratePlanSelectedTo.ratePlanId == templateItem.ratePlanId ? 'plan-selected' : '']" @click="selectPlanTo(templateItem.ratePlanId, 3, templateItem.planName, false)">
                            <div class="inner-template">
                                <div class="carrier-logo vodafone">
                                    <img src="../../assets/img/vodafone-logo-white.svg" alt="">
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.planName }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <div class="name">{{ templateItem.planCategory.category }}</div>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.staticIp">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>
                                            <div class="option">
                                                <span class="name">IMEI Match Rule</span>
                                                <span class="value" v-if="templateItem.imeiMatch">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>
                                            <div class="option">
                                                <span class="name">APN</span>
                                                <span class="value" v-if="templateItem.provisioningProfile">{{templateItem.provisioningProfile.apnType}}</span>
                                                <span class="value" v-else>--</span>
                                            </div>
                                            <div class="option">
                                                <span class="name">Provisioning Profile</span>
                                                <span class="value" v-if="templateItem.provisioningProfile">{{templateItem.provisioningProfile.profileName}}</span>
                                                <span class="value" v-else>--</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="down">
                                        <div class="description">
                                            <span class="name">Plan Description</span>
                                            <span v-if="templateItem.planDescription" class="value">{{templateItem.planDescription}}</span>
                                            <span v-else class="value">--</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="templates-wrap no-templates text-center">
                    <p>No plans have been made. Click here to here make a plan. </p>
                    <button class="btn btn-success" v-on:click="goToCreatePlan"><i class="fa fa-plus"></i>Add New Plan</button>
                </div>
            </div>
        </b-modal>
        <b-modal centered ref="simActions" id="simActions" :class="['modal-actions-sim']" hide-footer>
            <img v-if="simAction.type == 'reset' || simAction.type == 'suspend' || simAction.type == 'deactive'" src="../../assets/img/sim-card.png" alt />
            <img v-if="simAction.type == 'active'" src="../../assets/img/sim-card2.png" alt />
            <img v-if="simAction.type == 'restore' || simAction.type == 'reactivated'" src="../../assets/img/sim-card4.png" alt />

            <h3>{{simAction.title}}</h3>
            <h4>{{simAction.subtitle}} <br/>Do you want to continue?</h4>

            <div class="button-wrapper">
                <b-button variant="danger" @click="$refs['simActions'].hide()">No</b-button>
                <b-button variant="success" class="action-element" @click="actionSimFromModal()">Continue</b-button>
            </div>
        </b-modal>
        <b-modal size="md" ref="fileFormatModal" id="fileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hideExportSelect()">Cancel</button>
            </div>
        </b-modal>
        <b-modal size="md" ref="fileFormatModalTags" id="fileFormatModalTags" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsvTags">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsxTags">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hideExportSelectTags()">Cancel</button>
            </div>
        </b-modal>
        <b-modal ref="filtersModal" id="filtersModal" size="xl" hide-footer hide-header centered>
            <div class="inner-modal">
                <img src="../../assets/img/Close.svg" @click="cancelFilters()" class="close-filters-icon light-mode" alt="">
                <img src="../../assets/img/Close-darkmode.svg" @click="cancelFilters()" class="close-filters-icon dark-mode" alt="">
                <div class="filters-search">
                    <div class="FTSsearch">
                        <i class="fa fa-search"></i>
                        <input type="text" v-model="filtersSearch" placeholder="Search"/>
                        <img src="../../assets/img/Clear-field.svg" class="clear-filters-icon light-mode" @click="clearFilters()" alt="">
                        <img src="../../assets/img/Clear-field-darkmode.svg" class="clear-filters-icon dark-mode" @click="clearFilters()" alt="">
                    </div>
                </div>
                <div class="comapnies-statuses-row">
                    <div v-if="selectedCarrrier == 1" class="company-statuses-box">
                        <div class="logo-switch-row">
                            <img src="../../assets/img/simon-carrier.svg" class="light-mode">
                            <img src="../../assets/img/simon-carrier-dark.svg" class="dark-mode">
                            <div class="select-all-row">
                                <a v-if="statuses.simon.active && statuses.simon.activeReady && statuses.simon.suspended && statuses.simon.simBank && statuses.simon.inactive" @click="unselectAllStatuses(1)">Unselect all</a>
                                <a v-else @click="selectAllStatuses(1)">Select all</a>
                            </div>
                        </div>
                        <h4>Simon IoT Statuses</h4>
                        <div class="statuses-list">
                            <FTScheckbox :class="filterStatuses('Active') ? '' : 'hidden'" v-model="statuses.simon.active" :label="'Active'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Active - Ready') ? '' : 'hidden'" v-model="statuses.simon.activeReady" :label="'Active - Ready'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Suspended') ? '' : 'hidden'" v-model="statuses.simon.suspended" :label="'Suspended'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('SIM Bank') ? '' : 'hidden'" v-model="statuses.simon.simBank" :label="'SIM Bank'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Deactivated') ? '' : 'hidden'" v-model="statuses.simon.inactive" :label="'Deactivated'"></FTScheckbox>
                        </div>
                    </div>
                    <div v-if="selectedCarrrier == 2" class="company-statuses-box">
                        <div class="logo-switch-row">
                            <img src="../../assets/img/t-mobile-carrier.svg">
                            <div class="select-all-row">
                                <a v-if="statuses.tmobile.active && statuses.tmobile.suspended && statuses.tmobile.inactive" @click="unselectAllStatuses(2)">Unselect all</a>
                                <a v-else @click="selectAllStatuses(2)">Select all</a>
                            </div>
                        </div>
                        <h4>T-Mobile Statuses</h4>
                        <div class="statuses-list">
                            <FTScheckbox :class="filterStatuses('Active') ? '' : 'hidden'" v-model="statuses.tmobile.active" :label="'Active '"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Suspended') ? '' : 'hidden'" v-model="statuses.tmobile.suspended" :label="'Suspended '"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Deactivated') ? '' : 'hidden'" v-model="statuses.tmobile.inactive" :label="'Deactivated '"></FTScheckbox>
                        </div>
                    </div>
                    <div v-if="selectedCarrrier == 3" class="company-statuses-box">
                        <div class="logo-switch-row">
                            <img src="../../assets/img/vodafone-logo.svg">
                            <div class="select-all-row">
                                <a v-if="statuses.vodafone.activeLive && statuses.vodafone.activeSleep && statuses.vodafone.activeReady && statuses.vodafone.activeSuspended && statuses.vodafone.activeTest && statuses.vodafone.activeStandby && statuses.vodafone.inactiveStopped && statuses.vodafone.inactive && statuses.vodafone.terminated" @click="unselectAllStatuses(3)">Unselect all</a>
                                <a v-else @click="selectAllStatuses(3)">Select all</a>
                            </div>
                        </div>
                        <h4>Vodafone Statuses</h4>
                        <div class="statuses-list">
                            <FTScheckbox :class="filterStatuses('Active - Live') ? '' : 'hidden'" v-model="statuses.vodafone.activeLive" :value="statuses.vodafone.activeLive" :label="'Active - Live'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Active - Sleep') ? '' : 'hidden'" v-model="statuses.vodafone.activeSleep" :label="'Active - Sleep'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Active - Ready ') ? '' : 'hidden'" v-model="statuses.vodafone.activeReady" :label="'Active - Ready '"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Active - Suspended') ? '' : 'hidden'" v-model="statuses.vodafone.activeSuspended" :label="'Active - Suspended'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Active - Test') ? '' : 'hidden'" v-model="statuses.vodafone.activeTest" :label="'Active - Test'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Active - Standby') ? '' : 'hidden'" v-model="statuses.vodafone.activeStandby" :label="'Active - Standby'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Inactive - Stopped') ? '' : 'hidden'" v-model="statuses.vodafone.inactiveStopped" :label="'Inactive - Stopped'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Inactive') ? '' : 'hidden'" v-model="statuses.vodafone.inactive" :label="'Inactive  '"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Terminated') ? '' : 'hidden'" v-model="statuses.vodafone.terminated" :label="'Terminated'"></FTScheckbox>
                        </div>
                    </div>
                    <div v-if="selectedCarrrier == 4" class="company-statuses-box">
                        <div class="logo-switch-row">
                            <img src="../../assets/img/kore-logo.svg">
                            <div class="select-all-row">
                                <a v-if="statuses.kore.active && statuses.kore.activeTest && statuses.kore.activeReady && statuses.kore.suspended && statuses.kore.suspendedWithCharge && statuses.kore.pendingScrap && statuses.kore.terminated && statuses.kore.deactivated" @click="unselectAllStatuses(4)">Unselect all</a>
                                <a v-else @click="selectAllStatuses(4)">Select all</a>
                            </div>
                        </div>
                        <h4>Kore Statuses</h4>
                        <div class="statuses-list">
                            <FTScheckbox :class="filterStatuses('Active') ? '' : 'hidden'" v-model="statuses.kore.active" :value="statuses.kore.active" :label="'Active'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Active Test') ? '' : 'hidden'" v-model="statuses.kore.activeTest" :label="'Active Test'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Active Ready  ') ? '' : 'hidden'" v-model="statuses.kore.activeReady" :label="'Active Ready  '"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Suspended') ? '' : 'hidden'" v-model="statuses.kore.suspended" :label="'Suspended'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Suspended with Charge') ? '' : 'hidden'" v-model="statuses.kore.suspendedWithCharge" :label="'Suspended with Charge'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Pending Termination') ? '' : 'hidden'" v-model="statuses.kore.pendingScrap" :label="'Pending Termination'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Terminated') ? '' : 'hidden'" v-model="statuses.kore.terminated" :label="'Terminated'"></FTScheckbox>
                            <FTScheckbox :class="filterStatuses('Deactivated') ? '' : 'hidden'" v-model="statuses.kore.deactivated" :label="'Deactivated'"></FTScheckbox>
                        </div>
                    </div>
                </div>
                <div class="tags-plans-row">
                    <div class="tags-box">
                        <h4 class="tags-title">Tags</h4>
                        <p v-if="selectedTags.length" class="selected-tags-count">{{selectedTagsCounter}}</p>
                        <div class="selected-tags-list">
                            <div v-for="tag in selectedTags" :class="['selected-tag', tag.selected ? '' : 'hidden']">{{tag.label}}<img @click="deselectTag(tag)" src="../../assets/img/deselct-tag-icon.svg" class="close-cross"/></div>
                        </div>

                        <div class="tag-list-sort">
                            <span>Sort by:</span>
                            <a v-if="(searchTag.sort == 1 && !searchTag.desc) || searchTag.sort == 2" :class="[searchTag.sort == 1 ? 'sorting' : '']" @click="setAlpha">A-Z<i :class="['fa', searchTag.sort == 1 ? 'fa-sort-asc' : 'fa-sort']"></i></a>
                            <a v-if="searchTag.sort == 1 && searchTag.desc" :class="[searchTag.sort == 1 ? 'sorting' : '']" @click="setAlpha">Z-A<i :class="['fa', 'fa-sort-desc']"></i></a>
                            <a v-if="(searchTag.sort == 2 && !searchTag.desc) || searchTag.sort == 1" :class="[searchTag.sort == 2 ? 'sorting' : '']" @click="setMostUsed">Unused<i :class="['fa', searchTag.sort == 2 ? 'fa-sort-desc' : 'fa-sort']"></i></a>
                            <a v-if="searchTag.sort == 2 && searchTag.desc" :class="[searchTag.sort == 2 ? 'sorting' : '']" @click="setMostUsed">Used<i class="fa fa-sort-asc"></i></a>
                        </div>
                        <h4 class="tags-list-header">Tags List</h4>
                        <div class="tags-list">
                            <div v-for="tag in tagsList" :class="['tag', tag.selected ? 'selected' : '', filtersSearch != '' && searchTags(tag) ? 'hidden' : '']" @click="selectTag(tag)">{{tag.label}}</div>
                        </div>
                    </div>
                    <div class="plans-box">
                        <h4 class="plans-title">Plans</h4>
                        <p v-if="selectedPlansFilter.length > 0" class="selected-plans-counter">{{selectedPlansFilterCounter}}</p>
                        <div v-if="selectedPlansFilter.length > 0" class="selected-plans-box">
                            <div v-for="plan in selectedPlansFilter" :class="['selected-plan', plan.carrierId == 1 ? 'simon-plan' : plan.carrierId == 2 ? 'tmobile-plan' : plan.carrierId == 3 ? 'vodafone-plan' : '']">
                                <img v-if="plan.carrierId == 1" src="../../assets/img/simon-plan-logo.svg" class="company-plan-logo">
                                <img v-else-if="plan.carrierId == 2"  src="../../assets/img/tmobile-plan-logo.svg" class="company-plan-logo">
                                <img v-else-if="plan.carrierId == 3"  src="../../assets/img/vodafone-plan-logo.svg" class="company-plan-logo">
                                <span>{{plan.name}}</span>
                                <img src="../../assets/img/deselct-tag-icon.svg" @click="deselectPlan(plan)" alt="" class="close-cross">
                            </div>
                        </div>

                        <div class="plans-filters-box">
                            <a :class="[plansFilterSelected == 0 ? 'active-filter' : '']" @click="setPlansFilter(0)">ALL</a>
                            <a v-if="selectedCarrrier == 1 || selectedCarrrier == 3" :class="[plansFilterSelected == 1 ? 'active-filter' : '']" @click="setPlansFilter(1)">MB</a>
                            <a v-if="selectedCarrrier == 1 || selectedCarrrier == 3" :class="[plansFilterSelected == 2 ? 'active-filter' : '']" @click="setPlansFilter(2)">GB</a>
                        </div>
                        <div class="plans-list">
                            <div :class="['plans-alpha-box', plansParsed.A.length == 0 || (searchThroughPlans(plansParsed.A)) ? 'hidden' : '' ]">
                                <h6>A</h6>
                                <FTScheckbox v-for="plan in plansParsed.A" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.B.length == 0 || (searchThroughPlans(plansParsed.B)) ? 'hidden' : '' ]">
                                <h6>B</h6>
                                <FTScheckbox v-for="plan in plansParsed.B" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.C.length == 0 || (searchThroughPlans(plansParsed.C)) ? 'hidden' : '' ]">
                                <h6>C</h6>
                                <FTScheckbox v-for="plan in plansParsed.C" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.D.length == 0 || (searchThroughPlans(plansParsed.D)) ? 'hidden' : '' ]">
                                <h6>D</h6>
                                <FTScheckbox v-for="plan in plansParsed.D" v-bind:key="plan.id" :checked="plan.selected" @change.native="selectPlan(plan)" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.E.length == 0 || (searchThroughPlans(plansParsed.E)) ? 'hidden' : '' ]">
                                <h6>E</h6>
                                <FTScheckbox v-for="plan in plansParsed.E" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.F.length == 0 || (searchThroughPlans(plansParsed.F)) ? 'hidden' : '' ]">
                                <h6>F</h6>
                                <FTScheckbox v-for="plan in plansParsed.F" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.G.length == 0 || (searchThroughPlans(plansParsed.G)) ? 'hidden' : '' ]">
                                <h6>G</h6>
                                <FTScheckbox v-for="plan in plansParsed.G" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.H.length == 0 || (searchThroughPlans(plansParsed.H)) ? 'hidden' : '' ]">
                                <h6>H</h6>
                                <FTScheckbox v-for="plan in plansParsed.H" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.I.length == 0 || (searchThroughPlans(plansParsed.I)) ? 'hidden' : '' ]">
                                <h6>I</h6>
                                <FTScheckbox v-for="plan in plansParsed.I" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.J.length == 0 || (searchThroughPlans(plansParsed.J)) ? 'hidden' : '' ]">
                                <h6>J</h6>
                                <FTScheckbox v-for="plan in plansParsed.J" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.K.length == 0 || (searchThroughPlans(plansParsed.K)) ? 'hidden' : '' ]">
                                <h6>K</h6>
                                <FTScheckbox v-for="plan in plansParsed.K" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.L.length == 0 || (searchThroughPlans(plansParsed.L)) ? 'hidden' : '' ]">
                                <h6>L</h6>
                                <FTScheckbox v-for="plan in plansParsed.L" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.M.length == 0 || (searchThroughPlans(plansParsed.M)) ? 'hidden' : '' ]">
                                <h6>M</h6>
                                <FTScheckbox v-for="plan in plansParsed.M" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.N.length == 0 || (searchThroughPlans(plansParsed.N)) ? 'hidden' : '' ]">
                                <h6>N</h6>
                                <FTScheckbox v-for="plan in plansParsed.N" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.O.length == 0 || (searchThroughPlans(plansParsed.O)) ? 'hidden' : '' ]">
                                <h6>O</h6>
                                <FTScheckbox v-for="plan in plansParsed.O" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.P.length == 0 || (searchThroughPlans(plansParsed.P)) ? 'hidden' : '' ]">
                                <h6>P</h6>
                                <FTScheckbox v-for="plan in plansParsed.P" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.Q.length == 0 || (searchThroughPlans(plansParsed.Q)) ? 'hidden' : '' ]">
                                <h6>Q</h6>
                                <FTScheckbox v-for="plan in plansParsed.Q" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.R.length == 0 || (searchThroughPlans(plansParsed.R)) ? 'hidden' : '' ]">
                                <h6>R</h6>
                                <FTScheckbox v-for="plan in plansParsed.R" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.S.length == 0 || (searchThroughPlans(plansParsed.S)) ? 'hidden' : '' ]">
                                <h6>S</h6>
                                <FTScheckbox v-for="plan in plansParsed.S" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.T.length == 0 || (searchThroughPlans(plansParsed.T)) ? 'hidden' : '' ]">
                                <h6>T</h6>
                                <FTScheckbox v-for="plan in plansParsed.T" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.U.length == 0 || (searchThroughPlans(plansParsed.U)) ? 'hidden' : '' ]">
                                <h6>U</h6>
                                <FTScheckbox v-for="plan in plansParsed.U" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.V.length == 0 || (searchThroughPlans(plansParsed.V)) ? 'hidden' : '' ]">
                                <h6>V</h6>
                                <FTScheckbox v-for="plan in plansParsed.V" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.W.length == 0 || (searchThroughPlans(plansParsed.W)) ? 'hidden' : '' ]">
                                <h6>W</h6>
                                <FTScheckbox v-for="plan in plansParsed.W" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.X.length == 0 || (searchThroughPlans(plansParsed.X)) ? 'hidden' : '' ]">
                                <h6>X</h6>
                                <FTScheckbox v-for="plan in plansParsed.X" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.Y.length == 0 || (searchThroughPlans(plansParsed.Y)) ? 'hidden' : '' ]">
                                <h6>Y</h6>
                                <FTScheckbox v-for="plan in plansParsed.Y" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.Z.length == 0 || (searchThroughPlans(plansParsed.Z)) ? 'hidden' : '' ]">
                                <h6>Z</h6>
                                <FTScheckbox v-for="plan in plansParsed.Z" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                            <div :class="['plans-alpha-box', plansParsed.misc.length == 0 || (searchThroughPlans(plansParsed.misc)) ? 'hidden' : '' ]">
                                <h6>Miscellaneous</h6>
                                <FTScheckbox v-for="plan in plansParsed.misc" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlansFilter(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="filters-control-bar">
                <div class="left-side">
                    <button class="btn btn-light" @click="setDefaultFilters()">Set default</button>
                </div>
                <div class="right-side">
                    <button class="btn btn-light" @click="cancelFilters()">Cancel</button>
                    <button class="btn btn-primary" @click="applyFilters()">Apply</button>
                </div>
            </div>
        </b-modal>
        <b-modal size="md" ref="DGOwarn" id="DGOwarn" hide-footer hide-header centered>
            <i @click="bulkDGOWarnHide()" class="fa fa-close"></i>
            <img  src="../../assets/img/unsaved-data.png" alt />
            <h3>Warning</h3>
            <p>Setting the Data Guard value below your current usage will result in the new throttle and/or cap taking immediate effect.</p>
            <button @click="bulkDGOChange()" class="btn btn-success action-element">OK</button>
        </b-modal>
        <FTSSort v-if="mobileSort.visible" :settingsSort="sortingSettings" :directionSort="sortSettingsModal.desc" :columnSort="sortSettingsModal.sort" v-on:hideSort="shwoHideSort" v-on:submitSort="submitSort"></FTSSort>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
import globalStore from '../../variables'
import Paginate from 'vuejs-paginate'
import XLSX from 'xlsx';
import FTScheckbox from "../../ftsComponents/FTScheckbox";
import FTSsearch from "../../ftsComponents/FTSsearch";
import VueCookies from 'vue-cookies';
import FTSSort from "../../ftsComponents/FTSSort";
import { Switch as cSwitch } from "@coreui/vue";
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

export default {
    name: 'BulkOperation',
    data() {
        return {
            sortingSettings: [
                {
                    label: 'SIM',
                    column: 1
                },
                {
                    label: 'MSISDN',
                    column: 2
                },
                {
                    label: 'Status',
                    column: 3
                },
                {
                    label: 'Carrier',
                    column: 6
                },
                {
                    label: 'Last Active',
                    column: 7
                },
                {
                    label: 'In Transaction',
                    column: 8
                },
                {
                    label: 'Plan',
                    column: 9
                },
            ],
            mobileSort: {
                column: 0,
                direction: 0,
                visible: false
            },
            mobileVisible: false,
            simFile: '',
            filterModal: '',
            filterTagsTable: '',
            sortSettingsModal: {
                page: 1,
                size: 40,
                sort: 1,
                desc: true,
                selectedRatePlan: ''
            },
            sortSettingsTagsTable: {
                page: 1,
                size: 40,
                sort: 1,
                desc: true
            },
            simsList: '',
            selectedAllModal: 'false',
            paginationCountModal: 0,
            loadingSimListModal: true,
            noSimsModal: false,
            typingTimer: '',
            selectedRowsModal: [],
            selectedRowsModalParsed: [],
            custom1: '',
            custom2: '',
            searchStringModal: '',
            simAction: {
                type: 'reset',
                title: 'Reset SIM connection',
                subtitle: 'Are you sure you want to do this?',
                button: ''
            },
            exportData: {
                call: '',
                ids: '',
                data: {}
            },
            selectAllSimsRatePlan: false,
            selectedActions: true,
            selectedChangePlan: false,
            selectedSimSwap: false,
            selectedTagsChange: false,
            selectedDGO: false,
            selectedDGOStep2: false,
            selectedTagsChangeStep2: false,
            tagsResponse: {},
            simSwapStep1: false,
            simSwapStep2: false,
            selectedChangeState: true,
            selectedState: '',
            filterColdStock: '',
            searchStringColdStock: '',
            sortSettingsColdStock: {
                page: 1,
                size: 40,
                sort: 1,
                desc: true,
            },
            coldStockList: [],
            loadingColdSims: true,
            noColdStock: false,
            selectedColdStockArr: [],
            selectedAllColdStock: 'false',
            paginationCountColdStock: 0,
            typingTimerColdStock: '',
            templateLists: [],
            selectedPlans: 1,
            ratePlanAssigned: [],
            vodafoneRatePlanAssigned: [],
            selectedPlansFrom: 3,
            selectedPlanFrom: {
                id: 0,
                carrierId: 0,
                planName: '',
                category: false
            },
            selectedPlansTo: 3,
            selectedPlanTo: {
                id: 0,
                carrierId: 0,
                planName: '',
                category: false
            },
            ratePlanSelectedDGO: [],
            ratePlanSelectedFrom: [],
            ratePlanSelectedTo: [],
            selectedCarrrier: 0,
            stateSelectedAll: false,
            selectedCarrierUrl: '',
            loading: false,
            showBulkChange: false,
            showOnlySelected: '',
            selectedCheckbox: false,
            simonCarrierAvailable: true,
            tmobileCarrierAvailable: true,
            vodafoneCarrierAvailable: true,
            step1: true,
            simActionValidation: false,
            loadingValidation: false,
            loadingPlans: false,
            plansFiltered: false,
            validationPassedExpanded: true,
            validationFailedExpanded: true,
            validationWarningExpanded: true,
            simsPassedValidation: {
                iccids: []
            },
            simsFailedValidation: [],
            simsWarningValidation: [],
            simsFailedValidationCount: 0,
            simsWarningValidationCount: 0,
            companyId: null,
            simsFailedValidationFromFile: [],
            addingFromFile: false,
            simsInput: '',
            simsInputParsed: [],
            filtersShown: false,
            initialFilters: {},
            filtersSearch: '',
            searchTag: {
                sort: 1,
                desc: false
            },
            searchAddTag: {
                sort: 1,
                desc: false,
                phrase: ''
            },
            searchRemoveTag: {
                sort: 1,
                desc: false,
                phrase: ''
            },
            removeTagsSearch: '',
            addTagsSearch: '',
            tagsList: [],
            removeTagsList: [],
            addTagsList: [],
            selectedTags: [],
            selectedAddTags: [],
            selectedRemoveTags: [],
            selectedTagsCounter: '',
            plansList: [],
            selectedPlansFilter: [],
            selectedPlansFilterCounter: '',
            simonFilter: true,
            vodafoneFilter: true,
            tmobileFilter: true,
            plansParsed: {
                A: [],
                B: [],
                C: [],
                D: [],
                E: [],
                F: [],
                G: [],
                H: [],
                I: [],
                J: [],
                K: [],
                L: [],
                M: [],
                N: [],
                O: [],
                P: [],
                Q: [],
                R: [],
                S: [],
                T: [],
                U: [],
                V: [],
                W: [],
                X: [],
                Y: [],
                Z: [],
                misc: []
            },
            plansFilterSelected: 0,
            statuses: {
                simon: {
                    all: false,
                    active: false,
                    activeReady: false,
                    suspended: false,
                    simBank: false,
                    inactive: false
                },
                tmobile: {
                    all: false,
                    active: false,
                    suspended: false,
                    inactive: false
                },
                vodafone: {
                    all: false,
                    activeLive: false,
                    activeSleep: false,
                    activeReady: false,
                    activeSuspended: false,
                    activeTest: false,
                    activeStandby: false,
                    inactiveStopped: false,
                    terminated: false,
                    inactive: false
                },
                kore: {
                    all: false,
                    active: false,
                    activeReady: false,
                    activeTest: false,
                    suspended: false,
                    suspendedWithCharge: false,
                    pendingScrap: false,
                    terminated: false,
                    deactivated: false
                }
            },
            plans: {
                simon: [],
                tmobile: [],
                vodafone: []
            },
            filters: '',
            ratePlansIds: '',
            searchPlanFrom: '',
            searchPlanTo: '',
            visiblityActionsButtons: false,
            hotSpotVisible: false,
            dgoData: {
                throttle: {
                    value: 0,
                    unit: 'MB'
                },
                cap: {
                    value: 0,
                    unit: 'MB'
                },
                speed: 0
            },
            DGOunlimited: false,
            speedGuard: [
                { value: 0, text: 'Select throttle speed' },
                { value: 1, text: '64 Kbps' },
                { value: 2, text: '128 Kbps' },
                { value: 3, text: '256 Kbps' },
                { value: 4, text: '512 Kbps' },
                { value: 5, text: '768 Kbps' },
                { value: 7, text: '1 Mbps' },
                { value: 8, text: '25 Mbps' }
            ]
        }
    },
    components: {
        Paginate: Paginate,
        FTScheckbox,
        FTSSort,
        cSwitch
    },
    methods: {
        submitSort(value) {
            this.sortSettingsModal.sort = value.column;
            this.sortSettingsModal.desc = value.direction;
            this.getSimsListModal(true);
        },
        shwoHideSort() {
            this.mobileSort.visible = (this.mobileSort.visible == true) ? false : true;
        },
        showMobileElements() {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            if (width < 992) {
                this.mobileVisible = true;
            } else {
                this.mobileVisible = false;
            }
        },
        toggleBulkActions() {
            this.visiblityActionsButtons = (this.visiblityActionsButtons == true) ? false : true;
        },
        swapColdSims() {
            if (this.selectedRowsModal.length == this.selectedColdStockArr.length) {
                let simsToSwap = []

                for (let i = 0; i < this.selectedRowsModal.length; i++) {
                    let item = {}
                    item.iccid = this.selectedRowsModal[i]
                    item.newIccid = this.selectedColdStockArr[i]

                    simsToSwap.push(item)
                }

                let dataToSwap = {
                    carrierId: this.selectedCarrrier,
                    items: simsToSwap
                }

                Axios.put(`${globalStore.data.restApiUrl}/sim-swap/bulk`, dataToSwap)
                    .then(response => {
                        if (response.status == '201') {
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Transaction in Progress',
                                text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                                duration: 5000,
                            });
                            this.unselectAllRowModal()
                            this.resetBulkOperationsScreen()
                        }
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Something was wrong with SIM SWAP',
                            text: 'Something was wrong on backend side. Please look into console.',
                            duration: 5000,
                        });
                        console.log(error)
                        return false;
                    })

            } else {
                if (this.selectedRowsModal.length > this.selectedColdStockArr.length) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Wrong number of selected SIMs',
                        text: 'You selected too many SIMs and not enough Cold SIMs',
                        duration: 5000,
                    });
                    return false;
                } else {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Wrong number of selected SIMs',
                        text: 'You selected too many Cold SIMs and not enough SIMs',
                        duration: 5000,
                    });
                    return false;
                }
            }
        },
        changeState() {
            let parsedData = {
                iccids: this.simsPassedValidation.iccids,
                targetStatus: this.selectedState
            }
            Axios.post( globalStore.data.restApiUrl + '/vodafone-transaction/change-state', parsedData)
                .then (response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Transaction in Progress',
                        text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.id + '">Click here</a>',
                        duration: 5000,
                    })
                    this.resetBulkOperationsScreen()
                })
                .catch(error => {
                    if (error.response.status == 400) {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Error during changing SIMs state',
                            text: 'Please, check if status you selected is correct and try again.',
                            duration: 5000,
                        });
                    } else {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Something went wrong',
                            text: 'Please, contact support.',
                            duration: 5000,
                        });
                    }
                    console.log(error)
                })
        },
        bulkTagsChange() {
            let parsedData = {
                iccids: this.selectedRowsModal,
                tags: []
            }
            for (let tag of this.selectedRemoveTags) {
                parsedData.tags.push(
                    {
                        tagName: tag.label,
                        action: 'remove'
                    }
                )
            }
            for (let tag of this.selectedAddTags) {
                parsedData.tags.push(
                    {
                        tagName: tag.label,
                        action: 'add'
                    }
                )
            }
            Axios.post(globalStore.data.restApiUrl + '/tags/change/summary?companyId=' + this.companyId, parsedData)
                .then(response => {
                    this.tagsResponse = response.data
                    this.selectedTagsChange = false
                    this.selectedTagsChangeStep2 = true
                    this.step1 = false
                })
        },
        useUnlimitedDGO() {
            if (this.DGOunlimited) {
                this.dgoData.throttle.value = 0
                this.dgoData.cap.value = 0
                this.dgoData.speed = 0
            }
        },
        bulkDGOWarn() {
            if (this.dgoData.throttle.value != 0 && this.dgoData.cap.value != 0) {
                let throttleMB = this.dgoData.throttle.unit == 'MB' ? this.dgoData.throttle.value : this.dgoData.throttle.value * 1024
                let capMB = this.dgoData.cap.unit == 'MB' ? this.dgoData.cap.value : this.dgoData.cap.value * 1024
                if (capMB <= throttleMB) {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Invalid cap value',
                        text: 'Cap value must be higher than throttle',
                        duration: 5000,
                    });
                    return false
                }
            }
            if (this.dgoData.throttle.value != 0 && this.dgoData.speed == 0) {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Throttle speed missing',
                    text: 'You need to select throttle speed.',
                    duration: 5000,
                });
                return false
            }
            if (this.DGOunlimited || (this.dgoData.throttle.value == 0 && this.dgoData.cap.value == 0)) {
                this.bulkDGOChange()
            } else {
                this.$refs['DGOwarn'].show();
            }
        },
        bulkDGOWarnHide() {
            this.$refs['DGOwarn'].hide();
        },
        bulkDGOChange() {
            this.$refs['DGOwarn'].hide();
            let parsedData = {
                iccid: this.selectedRowsModal,
                dataGuard: {}
            }
            if (this.dgoData.throttle.value != 0 && this.dgoData.throttle.value != '') {
                parsedData.dataGuard.hasThrottle = 1
                parsedData.dataGuard.throttleAt = this.dgoData.throttle.value
                parsedData.dataGuard.throttleAtUnit = this.dgoData.throttle.unit
                parsedData.dataGuard.throttleSpeedId = this.dgoData.speed
            } else {
                parsedData.dataGuard.hasThrottle = 0
            }
            if (this.dgoData.cap.value != 0 && this.dgoData.cap.value != '') {
                parsedData.dataGuard.hasCap = 1
                parsedData.dataGuard.capAt = this.dgoData.cap.value
                parsedData.dataGuard.capAtUnit = this.dgoData.cap.unit
            } else {
                parsedData.dataGuard.hasCap = 0
            }
            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/simon/dgo', parsedData)
                .then(response => {
                    this.parseDGOResponse(response.data)
                })
        },
        filterVodafone() {
            this.getSimsListModal(true);
        },
        goToSwapSim() {
            let testStatusSim = false;

            for (let j = 0; j < this.selectedRowsModalParsed.length; j++) {
                if (this.selectedRowsModalParsed[j]['status'] != 'Active' && this.selectedRowsModalParsed[j]['status'] != 'Active Ready') {
                    testStatusSim = true
                }
            }
            if (testStatusSim == true) {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Wrong selected SIMs',
                    text: 'You selected wrong SIMs to SWAP. Only Active and Active-ready SIMs can be SWAPED',
                    duration: 5000,
                });
                return false
            } else {
                this.simSwapStep2 = true
                this.getColdStocks(true)
                window.scrollTo(0,0);
            }
        },
        selectPlanFrom(planId, carrierId, simsCount, simsInPlan, planName, category) {
            this.selectedPlanFrom.id = planId;
            this.selectedPlanFrom.carrierId = carrierId;
            this.selectedPlanFrom.planName = planName;
            this.selectedPlanFrom.category = category;

            if (carrierId == 1) {
                this.ratePlanSelectedFrom = this.templateList.filter(item => {
                    return item.id == this.selectedPlanFrom.id
                })
            } else if (carrierId == 2) {
                this.ratePlanSelectedFrom = this.ratePlanAssigned.filter(item => {
                    return item.ratePlanId == this.selectedPlanFrom.id
                })
            } else if (carrierId == 3) {
                this.ratePlanSelectedFrom = this.vodafoneRatePlanAssigned.filter(item => {
                    return item.ratePlanId == this.selectedPlanFrom.id
                })
            }

            this.ratePlanSelectedFrom = this.ratePlanSelectedFrom[0]
            if (this.selectedPlanFrom.carrierId == 1){
                this.sortSettingsModal.selectedRatePlan = '&templateIds=' + planId;
            } else {
                this.sortSettingsModal.selectedRatePlan = '&ratePlanIds=' + planId
            }

            let simsToSelect = [];

            for (let buckSims in this.ratePlansIds) {
                if (this.ratePlansIds[buckSims]['id'] == planId) {
                    for (let iccid in this.ratePlansIds[buckSims]['iccids']) {
                        simsToSelect.push({
                            iccid: this.ratePlansIds[buckSims]['iccids'][iccid],
                            status: 1
                        })
                    }
                }
            }
            this.selectedAllModal = 'true';
            this.resetSimsSelected(simsToSelect);

            this.loadingSimListModal = true;

            this.$refs['select-from-plan'].hide()
        },
        selectSimsAfterRest(simsArr) {
            let dataToSend = {
                iccids: simsArr,
                forceOn: true
            }

            Axios.post(globalStore.data.restApiUrl + '/sims/mark', dataToSend)
                .then(() => {
                    if (this.addingFromFile) {
                        this.getSimsListModal()
                        this.addingFromFile = false
                    }
                    if (parsedData.iccids.length > 0) {
                        this.$cookies.set('simsMarked', true)
                    }
                })
                .catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Selected SIM failed',
                        text: 'Error Processing SIM Selection - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                });
        },
        selectPlanTo(planId, carrierId, planName, category) {
            this.selectedPlanTo.id = planId;
            this.selectedPlanTo.carrierId = carrierId;
            this.selectedPlanTo.planName = planName;
            this.selectedPlanTo.category = category;

            if (carrierId == 1) {
                this.ratePlanSelectedTo = this.templateList.filter(item => {
                    return item.id == this.selectedPlanTo.id
                })
            } else if (carrierId == 2) {
                this.ratePlanSelectedTo = this.ratePlanAssigned.filter(item => {
                    return item.ratePlanId == this.selectedPlanTo.id
                })
            } else if (carrierId == 3) {
                this.ratePlanSelectedTo = this.vodafoneRatePlanAssigned.filter(item => {
                    return item.ratePlanId == this.selectedPlanTo.id
                })
            }

            this.ratePlanSelectedTo = this.ratePlanSelectedTo[0]

            this.$refs['select-to-plan'].hide()
        },
        checkSelectedRow(iccid) {
            let checkSim = this.selectedRowsModal.filter(item => {
                return item.iccid == iccid
            })

            if (checkSim.length > 0) {
                return true
            } else {
                return false
            }
        },
        backToSwapStep1() {
            this.simSwapStep2 = false;
            this.simSwapStep1 = true;
        },
        showAllFrom(ev) {
            ev.preventDefault();

            this.selectedPlansFrom = 3;

            if (!ev.target.classList.contains("active")) {
                document.querySelector(".filters-plan span.active").classList.remove('active');
                ev.target.classList.add('active')
            }

            var planWrapper = document.getElementById("select-from-plan___BV_modal_body_");
            var planItems = planWrapper.getElementsByClassName("template-item");

            for (var k = 0; k < planItems.length; k++) {
                planItems[k].style.display = ''
            }
        },
        showFlexFrom(ev) {
            ev.preventDefault();

            this.selectedPlansFrom = 0;

            if (!ev.target.classList.contains("active")) {
                document.querySelector(".filters-plan span.active").classList.remove('active');
                ev.target.classList.add('active')
            }

            var planWrapper = document.getElementById("select-from-plan___BV_modal_body_");
            var planItems = planWrapper.getElementsByClassName("template-item");

            for (var j = 0; j < planItems.length; j++) {
                if (planItems[j].classList.contains('flex')) {
                    planItems[j].style.display = ''
                } else {
                    planItems[j].style.display = 'none'
                }
            }
        },
        showHighbandwidthFrom(ev) {
            ev.preventDefault();

            this.selectedPlansFrom = 0;

            if (!ev.target.classList.contains("active")) {
                document.querySelector(".filters-plan span.active").classList.remove('active');
                ev.target.classList.add('active')
            }

            var planWrapper = document.getElementById("select-from-plan___BV_modal_body_");
            var planItems = planWrapper.getElementsByClassName("template-item");

            for (var j = 0; j < planItems.length; j++) {
                if (planItems[j].classList.contains('highbandwidth')) {
                    planItems[j].style.display = ''
                } else {
                    planItems[j].style.display = 'none'
                }
            }
        },
        showSimonPlansFrom(ev) {
            this.selectedPlansFrom = 1
            document.querySelector("#select-from-plan___BV_modal_body_ span.active").classList.remove('active');
            ev.target.classList.add('active')
        },
        showTmobilePlansFrom(ev) {
            this.selectedPlansFrom = 2;
            document.querySelector("#select-from-plan___BV_modal_body_ span.active").classList.remove('active');
            ev.target.classList.add('active')
        },
        showAllTo() {

        },
        goToCreatePlan() {

        },
        showFlexTo() {

        },
        showHighbandwidthTo() {

        },
        showSimonPlansTo() {

        },
        showTmobilePlansTo() {

        },
        actionSimFromModal() {
            this.$refs['simActions'].hide()

            this.loadingSimListModal = true;

            if (this.simsPassedValidation.iccids.length == 0) {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'There is no SIMs which can be ' + this.simAction.type,
                    text: 'Please add valid SIMs for Bulk Operation',
                    duration: 5000,
                });
                return false;
                this.loadingSimListModal = false;
            }

            if (this.simAction.type == 'suspended') {
                Axios.post(globalStore.data.restApiUrl + "/subscriber/suspend", {iccids: this.simsPassedValidation.iccids})
                    .then(response => {
                        this.resetBulkOperationsScreen()
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Transaction in Progress',
                            text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                            duration: 5000,
                        })
                        this.loadingSimListModal = false;
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Something was wrong',
                            text: 'Error Processing Bulk Suspend - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                        this.loadingSimListModal = false;
                    });

            } else if (this.simAction.type == 'restored') {
                Axios.post(globalStore.data.restApiUrl + "/subscriber/restore", {iccids: this.simsPassedValidation.iccids})
                    .then(response => {
                        this.resetBulkOperationsScreen()
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Transaction in Progress',
                            text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                            duration: 5000,
                        });
                        this.loadingSimListModal = false;
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Something was wrong',
                            text: 'Error Processing Bulk Restore - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                        this.loadingSimListModal = false;
                    });

            } else if (this.simAction.type == 'deactived') {
                Axios.post(globalStore.data.restApiUrl + "/subscriber/deactivate?carrierId=" + this.selectedCarrrier, {iccids: this.simsPassedValidation.iccids})
                    .then(response => {
                        this.resetBulkOperationsScreen()
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Transaction in Progress',
                            text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                            duration: 5000,
                        });
                        this.loadingSimListModal = false;
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Something was wrong',
                            text: 'Error Processing Bulk SIM Deactivation - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                        this.loadingSimListModal = false;
                    });

            } else if (this.simAction.type == 'reset') {
                Axios.post(globalStore.data.restApiUrl + '/subscriber/cancel-device-location', {iccids: this.simsPassedValidation.iccids})
                    .then(response => {
                        this.resetBulkOperationsScreen()
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Transaction in Progress',
                            text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                            duration: 5000,
                        });
                        this.loadingSimListModal = false;
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Something was wrong',
                            text: 'Error Processing Bulk Reset Device Connection - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                        this.loadingSimListModal = false;
                    })
            } else if (this.simAction.type == 'reactivated') {
                Axios.post(globalStore.data.restApiUrl + '/subscriber/reactivate', {iccids: this.simsPassedValidation.iccids})
                    .then(response => {
                        this.resetBulkOperationsScreen()
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Transaction in Progress',
                            text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                            duration: 5000,
                        });
                        this.loadingSimListModal = false;
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Something was wrong',
                            text: 'Error Processing Bulk Reactivation - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                        this.loadingSimListModal = false;
                    })
            } else if (this.simAction.type == 'terminated') {
                Axios.post(globalStore.data.restApiUrl + '/subscriber/terminate', {iccids: this.simsPassedValidation.iccids})
                    .then(response => {
                        this.resetBulkOperationsScreen()
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Transaction in Progress',
                            text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                            duration: 5000,
                        });
                        this.loadingSimListModal = false;
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Something was wrong',
                            text: 'Error Processing Bulk Termination - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                        this.loadingSimListModal = false;
                    })
            } else if (this.simAction.type == 'migrated to Vodafone Plan') {
                this.bulkPlanChangeVodafone()
            } else if (this.simAction.type == 'migrated to Simon Plan') {
                this.bulkPlanChangeSimon()
            } else {
                this.changeState();
            }
        },
        resetBulkOperationsScreen() {
            this.unselectAllRowModal();
            this.step1 = true
            this.simsPassedValidation = {}
            this.simsWarningValidation = []
            this.simsFailedValidation = []
            this.simsWarningValidationCount = null
            this.simsFailedValidationCount = null
            this.simActionValidation = false
            this.loadingSimListModal = false
            this.simsFailedValidationFromFile = []
            this.selectedRowsModal = []
            this.selectedState = ''
            this.selectedPlanFrom.id = 0
            this.selectedPlanTo.id = 0
            this.ratePlanSelectedFrom = []
            this.ratePlanSelectedTo = []
            this.sortSettingsModal.selectedRatePlan = ''
            this.selectedTagsChange = false
            this.selectedTagsChangeStep2 = false
            this.selectedAddTags = []
            this.selectedRemoveTags = []
            this.selectedDGO = false;
            this.selectedDGOStep2 = false;
            this.selectedActions = true;
            this.dgoData = {
                throttle: {
                    value: 0,
                    unit: 'MB'
                },
                cap: {
                    value: 0,
                    unit: 'MB'
                },
                speed: 0
            }
            if (this.simSwapStep2 == true) {
                this.simSwapStep2 = false
                this.simSwapStep1 = true;
            }
            this.getSimsListModal(true)
        },
        getRatePlans() {
            Axios.get(globalStore.data.restApiUrl + "/account/rate-plans").then(result => {
                this.templateList = [];
                this.templateLists = [];
                const templateLists = result.data.response;

                if (templateLists.length) {
                    templateLists.map(item => {
                        var optionsSms = "OFF";
                        var optionsDataPooling = "OFF";
                        var roaming = "OFF";
                        var tier = null;
                        var roaming2 = "OFF";
                        var voice = "OFF";
                        var tier2 = null;
                        var staticIp = "OFF";
                        var hotSpot = item.hotSpotPlan ? "ON" : "OFF";

                        if (item.planOptions) {
                            item.planOptions.map(itemOptions => {
                                if (itemOptions.planOptionName == "SMS") {
                                    optionsSms = "ON";
                                }

                                if (itemOptions.planOptionName == "Data Pooling") {
                                    optionsDataPooling = "ON";
                                }

                                if  (itemOptions.planOptionName == "Tier 1 International Roaming") {
                                    roaming = "ON";
                                    tier = 'Tier 1';
                                }

                                if  (itemOptions.planOptionName == "Tier 2 International Roaming") {
                                    roaming2 = "ON";
                                    tier2 = 'Tier 2';
                                }

                                if (itemOptions.planOptionName == "Static IP") {
                                    staticIp = "ON";
                                }

                                if (itemOptions.planOptionName == "Voice") {
                                    voice = "ON";
                                }
                            });
                        }

                        var dataGuard = {
                            hasThrottle: 0,
                            throttleAt: 0,
                            throttleAtUnit: "",
                            throttleSpeed: 0,
                            hasCap: 0,
                            capAt: 0,
                            capAtUnit: ""
                        }

                        if (item.dataGuard && item.dataGuard.hasThrottle == 1) {
                            dataGuard.hasThrottle = 1;
                            if ((item.dataGuard.throttleAt >= 1024 && item.dataGuard.throttleAtUnit == 'mb')) {
                                dataGuard.throttleAt = (item.dataGuard.throttleAt / 1024).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2});
                                dataGuard.throttleAtUnit = 'GB';
                            } else if (item.dataGuard.throttleAtUnit == 'gb') {
                                dataGuard.throttleAt = item.dataGuard.throttleAt.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                                dataGuard.throttleAtUnit = 'GB';
                            } else if (item.dataGuard.throttleAtUnit == 'mb') {
                                dataGuard.throttleAt = item.dataGuard.throttleAt
                                dataGuard.throttleAtUnit = 'MB';
                            }


                            if (item.dataGuard.throttleSpeed && item.dataGuard.throttleSpeed.throttleSpeedId > 0) {
                                if (item.dataGuard.throttleSpeed.throttleSpeedName.indexOf('mbps') > -1) {
                                    dataGuard.throttleSpeed = item.dataGuard.throttleSpeed.throttleSpeedName.replace('mbps', 'Mbps');
                                } else {
                                    dataGuard.throttleSpeed = item.dataGuard.throttleSpeed.throttleSpeedName;
                                }

                            }
                        }

                        if (item.dataGuard && item.dataGuard.hasCap == 1) {
                            dataGuard.hasCap = 1;
                            if (item.dataGuard.capAt == undefined) {
                                dataGuard.capAt = 'OFF'
                                dataGuard.capAtUnit = ''
                            } else if ((item.dataGuard.capAt >= 1024 && item.dataGuard.capAtUnit == 'mb')) {
                                dataGuard.capAt = (item.dataGuard.capAt / 1024).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                                dataGuard.capAtUnit = 'GB';
                            } else if (item.dataGuard.capAtUnit == 'gb') {
                                dataGuard.capAt = item.dataGuard.capAt.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                                dataGuard.capAtUnit = 'GB';
                            } else if (item.dataGuard.capAtUnit == 'mb') {
                                dataGuard.capAt = item.dataGuard.capAt
                                dataGuard.capAtUnit = 'MB';
                            }
                        }

                        if (dataGuard.hasThrottle == 0) {
                            delete dataGuard.throttleAt
                            delete dataGuard.throttleAtUnit
                            delete dataGuard.throttleSpeed
                        }

                        if (dataGuard.hasCap == 0) {
                            delete dataGuard.capAt
                            delete dataGuard.capAtUnit
                        }

                        var categoryClass = item.planCategory.planCategoryName;
                        categoryClass = categoryClass.replace(/\s/g, "").toLowerCase();

                        let firstAlert = 0
                        if (item.fistAlertAtMb >= 1024) {
                            firstAlert = (item.fistAlertAtMb / 1024).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' GB'
                        } else if (item.fistAlertAtMb > 0) {
                            firstAlert = item.fistAlertAtMb + ' MB'
                        }
                        let secondAlert = 0
                        if (item.secondAlertAtMb >= 1024) {
                            secondAlert = (item.secondAlertAtMb / 1024).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' GB'
                        } else if (item.secondAlertAtMb > 0) {
                            secondAlert = item.secondAlertAtMb + ' MB'
                        }

                        var tempTemplateData = {
                            id: item.ratePlanId,
                            name: item.planName,
                            active: item.active,
                            description: item.planDescription,
                            category: item.planCategory.planCategoryName,
                            categoryClass: categoryClass,
                            dataLimit: item.dataLimit.dataLimitName,
                            planOptions: {
                                dataPooling: optionsSms,
                                sms: optionsSms,
                                hasRoaming: roaming,
                                hasVoice: voice,
                                hotSpot: hotSpot,
                                tier: tier,
                                staticIp: staticIp,
                                hasRoaming2: roaming2
                            },
                            dataGuard: dataGuard,
                            fistAlertAtMb: firstAlert,
                            secondAlertAtMb: secondAlert
                        };
                        this.templateLists.push(tempTemplateData);
                    });
                }

                this.templateList = this.templateLists;
            });
        },
        actionSim(typeAction) {
            this.showBulkChange = false;
            this.loadingValidation = true;
            if (typeAction == 'restore') {
                this.simAction.type = 'restored'
                this.simAction.title = 'Restore SIM'
                this.simAction.button = 'Restore'
                this.validateRestore()
            } else if (typeAction == 'reactivate') {
                this.simAction.type = 'reactivated'
                this.simAction.title = 'Reactivate SIM'
                this.simAction.button = 'Reactivate'
                this.validateReactivate()
            } else if (typeAction == 'deactive') {
                this.simAction.type = 'deactived'
                this.simAction.title = 'Deactivate SIM'
                this.simAction.button = 'Deactivate'
                this.validateDeactivate()
            } else if (typeAction == 'terminate') {
                this.simAction.type = 'terminated'
                this.simAction.title = 'Terminate SIM'
                this.simAction.button = 'Terminate'
                this.validateTerminate()
            } else if (typeAction == 'suspend') {
                this.simAction.type = 'suspended'
                this.simAction.title = 'Suspend SIM'
                this.simAction.button = 'Suspend'
                this.validateSuspend()
            } else if (typeAction == 'reset') {
                this.simAction.type = 'reset'
                this.simAction.title = 'Reset SIM connection'
                this.simAction.button = 'Reset'
                this.validateReset()
            } else if (typeAction == 'ACTIVE_LIVE') {
                this.simAction.type = 'changed to Active - Live'
                this.simAction.title = 'Change State to Active - Live'
                this.simAction.button = 'Change state'
                this.vodafoneChangeState(typeAction)
            } else if (typeAction == 'ACTIVE_READY') {
                this.simAction.type = 'changed to Active - Ready'
                this.simAction.title = 'Change State to Active - Ready'
                this.simAction.button = 'Change state'
                this.vodafoneChangeState(typeAction)
            } else if (typeAction == 'ACTIVE_STANDBY') {
                this.simAction.type = 'changed to Active - Standby'
                this.simAction.title = 'Change State to Active - Standby'
                this.simAction.button = 'Change state'
                this.vodafoneChangeState(typeAction)
            } else if (typeAction == 'ACTIVE_SUSPEND') {
                this.simAction.type = 'changed to Active - Suspend'
                this.simAction.title = 'Change State to Active - Suspend'
                this.simAction.button = 'Change state'
                this.vodafoneChangeState(typeAction)
            } else if (typeAction == 'INACTIVE_STOPPED') {
                this.simAction.type = 'changed to Inactive - Stopped'
                this.simAction.title = 'Change State to Inactive - Stopped'
                this.simAction.button = 'Change state'
                this.vodafoneChangeState(typeAction)
            } else if (typeAction == 'simonPlanChange') {
                this.simAction.type = 'migrated to Simon Plan'
                this.simAction.title = 'Migrate from plan ' + this.selectedPlanFrom.planName + ' to plan ' + this.selectedPlanTo.planName
                this.simAction.button = 'Migrate'
                this.validateSimonPlanChange()
            } else if (typeAction == 'vodafonePlanChange') {
                this.simAction.type = 'migrated to Vodafone Plan'
                this.simAction.title = 'Migrate from plan ' + this.selectedPlanFrom.planName + ' to plan ' + this.selectedPlanTo.planName
                this.simAction.button = 'Migrate'
                this.validateVodafonePlanChange()
            }
        },
        backToTagsStep1() {
            this.step1 = true
            this.selectedTagsChange = true
            this.selectedTagsChangeStep2 = false
        },
        showExportSelect() {
            this.$refs['fileFormatModal'].show();
        },
        hideExportSelect() {
            this.$refs['fileFormatModal'].hide();
        },
        exportCsv() {
            Axios.post( globalStore.data.restApiUrl + this.exportData.call + '/csv' + this.exportData.ids, this.exportData.data)
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', 'SIM list.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.$refs['fileFormatModal'].hide();
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportXlsx() {
            Axios.post( globalStore.data.restApiUrl + this.exportData.call + '/xlsx' + this.exportData.ids, this.exportData.data, {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', 'SIM list.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    this.$refs['fileFormatModal'].hide();
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Something went wrong during SIMs export. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });

        },
        goBack() {
            this.step1 = true
            this.simActionValidation = false;
        },
        goBackDGO() {
            this.step1 = true
            this.selectedDGO = true;
            this.selectedDGOStep2 = false;
        },
        confirmAction() {
            this.simAction.subtitle = this.simsPassedValidation.iccids.length + ' SIMs will be ' + this.simAction.type + '.';
            this.$refs['simActions'].show();
        },
        sendActionSimsToValidation() {
            setTimeout(() => {
                this.loadingValidation = false;
            }, 3000)
        },
        validateSimList(simsList) {
            let parsedData = {
                iccids: simsList
            }

            if (simsList.length == 0) {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'No correct SIMs',
                    text: 'You uploaded list with no correct SIM number. Please check your list.',
                    duration: 5000,
                });
                return false
            }

            let carrierId = '?carrierId=' + this.selectedCarrrier
            let companyId = ''
            if (this.companyId != null) {
                companyId = '&companyId=' + this.companyId
            }
            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/basic' + carrierId + companyId,  parsedData)
                .then(response => {
                    let resp = response.data.validationGroups
                    let validIndex = null
                    let valid = null
                    for (let i = 0; i < resp.length; i++) {
                        if (resp[i].groupName == 'Valid') {
                            validIndex = i
                        }
                    }
                    if (validIndex != null) {
                        valid = resp[validIndex]
                        resp.splice(validIndex, 1)
                    }
                    if (valid != null) {
                        this.paginationCountModal = Math.round(valid.iccids.length / this.sortSettingsModal.size)
                        this.addSimArrayCheckedModal(valid.iccids)
                    }
                    this.simsFailedValidationFromFile = resp
                    if (this.simsInputParsed.length > 0) {
                        this.simsInputParsed = []
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        validateRestore() {
            let parsedData = {
                iccids: this.selectedRowsModal
            }
            let companyCarrierId = ''
            if (this.companyId != null) {
                companyCarrierId = '?companyId=' + this.companyId + '&carrierId=' + this.selectedCarrrier
            } else {
                companyCarrierId = '?carrierId=' + this.selectedCarrrier
            }

            this.exportData.call = '/bulk/validation/restore'
            this.exportData.ids =  companyCarrierId
            this.exportData.data = parsedData

            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/restore' + companyCarrierId,  parsedData)
                .then(response => {
                    this.parseValidationResponse(response.data)
                })
                .catch(error => {
                    console.log(error)
                    this.loadingValidation = false;
                })
        },
        validateSuspend() {
            let parsedData = {
                iccids: this.selectedRowsModal
            }
            let companyCarrierId = ''
            if (this.companyId != null) {
                companyCarrierId = '?companyId=' + this.companyId + '&carrierId=' + this.selectedCarrrier
            } else {
                companyCarrierId = '?carrierId=' + this.selectedCarrrier
            }

            this.exportData.call = '/bulk/validation/suspend'
            this.exportData.ids =  companyCarrierId
            this.exportData.data = parsedData

            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/suspend' + companyCarrierId,  parsedData)
                .then(response => {
                    this.parseValidationResponse(response.data)
                })
                .catch(error => {
                    console.log(error)
                    this.loadingValidation = false;
                })
        },
        validateReset() {
            let parsedData = {
                iccids: this.selectedRowsModal
            }
            let companyId = ''
            if (this.companyId != null) {
                companyId = '?companyId=' + this.companyId
            }

            this.exportData.call = '/bulk/validation/simon/reset-connection'
            this.exportData.ids =  companyId
            this.exportData.data = parsedData

            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/simon/reset-connection' + companyId,  parsedData)
                .then(response => {
                    this.parseValidationResponse(response.data)
                })
                .catch(error => {
                    console.log(error)
                    this.loadingValidation = false;
                })
        },
        validateDeactivate() {
            let parsedData = {
                iccids: this.selectedRowsModal
            }
            let companyId = ''
            if (this.companyId != null) {
                companyId = '?companyId=' + this.companyId
            }

            this.exportData.call = '/bulk/validation/simon/deactivate'
            this.exportData.ids =  companyId
            this.exportData.data = parsedData

            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/simon/deactivate' + companyId,  parsedData)
                .then(response => {
                    this.parseValidationResponse(response.data)
                })
                .catch(error => {
                    console.log(error)
                    this.loadingValidation = false;
                })
        },
        validateTerminate() {
            let parsedData = {
                iccids: this.selectedRowsModal
            }
            let companyId = ''
            if (this.companyId != null) {
                companyId = '?companyId=' + this.companyId
            }

            this.exportData.call = '/bulk/validation/kore/terminate'
            this.exportData.ids =  companyId
            this.exportData.data = parsedData

            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/kore/terminate' + companyId,  parsedData)
                .then(response => {
                    this.parseValidationResponse(response.data)
                })
                .catch(error => {
                    console.log(error)
                    this.loadingValidation = false;
                })
        },
        validateReactivate() {
            let parsedData =  this.selectedRowsModal
            let companyId = ''
            if (this.companyId != null) {
                companyId = '?companyId=' + this.companyId
            }

            this.exportData.call = '/bulk/validation/simon/reactivation'
            this.exportData.ids =  companyId
            this.exportData.data = parsedData

            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/simon/reactivation' + companyId,  parsedData)
                .then(response => {
                    this.parseValidationResponse(response.data)
                })
                .catch(error => {
                    console.log(error)
                    this.loadingValidation = false;
                })
        },
        vodafoneChangeState(state) {
            let parsedData = {
                iccids: this.selectedRowsModal,
                targetStatus: state
            }
            let companyId = ''
            if (this.companyId != null) {
                companyId = '?companyId=' + this.companyId
            }

            this.exportData.call = '/bulk/validation/vodafone/change-state'
            this.exportData.ids =  companyId
            this.exportData.data = parsedData

            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/vodafone/change-state' + companyId,  parsedData)
                .then(response => {
                    this.parseValidationResponse(response.data)
                })
                .catch(error => {
                    console.log(error)
                    this.loadingValidation = false;
                })
        },
        validateSimonPlanChange() {
            let parsedData = {
                targetPlanId: this.selectedPlanTo.id,
                iccids: this.selectedRowsModal
            }

            this.exportData.call = '/bulk/validation/simon/change-plan'
            this.exportData.ids =  ''
            this.exportData.data = parsedData

            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/simon/change-plan',  parsedData)
                .then(response => {
                    this.parseValidationResponse(response.data)
                })
                .catch(error => {
                    console.log(error)
                    this.loadingValidation = false;
                })
        },
        validateVodafonePlanChange() {
            let parsedData = {
                targetRatePlanId: this.selectedPlanTo.id,
                iccids: this.selectedRowsModal
            }

            this.exportData.call = '/bulk/validation/vodafone/change-plan'
            this.exportData.ids =  ''
            this.exportData.data = parsedData

            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/vodafone/change-plan',  parsedData)
                .then(response => {
                    this.parseValidationResponse(response.data)
                })
                .catch(error => {
                    console.log(error)
                    this.loadingValidation = false;
                })
        },
        parseValidationResponse(result) {
            let resp = result.validationGroups
            if (result.nonSimErrors.length) {
               for (let error of result.nonSimErrors) {
                   this.$notify({
                       type: 'error',
                       group: 'notification',
                       title: error.errorName,
                       text: error.errorDescription,
                       duration: 5000,
                   });
               }
                this.step1 = false
                this.simActionValidation = true;
                return false;
            }
            let validIndex = null
            let valid
            for (let i = 0; i < resp.length; i++) {
                if (resp[i].groupName == 'Valid') {
                    validIndex = i
                }
            }
            if (validIndex != null) {
                valid = resp[validIndex]
                resp.splice(validIndex, 1)
            }
            this.simsFailedValidation = resp
            this.simsPassedValidation = valid

            if (this.simsPassedValidation == undefined) {
                for (let invalid of this.simsFailedValidation) {
                    if (invalid.groupName == 'Uncompleted plan change') {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Some SIMs are already during change plan process.',
                            text: 'Please, wait until its transaction will be complete.',
                            duration: 5000,
                        });
                        return false;
                    }
                }
                this.simsPassedValidation = {
                    iccids: []
                }
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'None of selected SIMs cannot be ' + this.simAction.type,
                    text: 'Please, try another SIMs.',
                    duration: 5000,
                });
                return false;
            } else {
                this.simsFailedValidationCount = this.selectedRowsModal.length - this.simsPassedValidation.iccids.length
                this.step1 = false
                this.simActionValidation = true;
            }
            this.loadingValidation = false;
        },
        parseDGOResponse(resp) {
            let validIndex = null
            let valid = null
            for (let i = 0; i < resp.validationGroups.length; i++) {
                if (resp.validationGroups[i].valid) {
                    validIndex = i
                }
            }
            if (validIndex != null) {
                valid = resp.validationGroups[validIndex]
                resp.validationGroups.splice(validIndex, 1)
                this.simsPassedValidation = valid
            } else {
                this.simsPassedValidation = {
                    iccids: []
                }
            }

            this.simsFailedValidation = resp.validationGroups
            this.simsWarningValidation = resp.warningGroups
            this.simsWarningValidationCount = 0
            for (let warning of resp.warningGroups) {
                this.simsWarningValidationCount = this.simsWarningValidationCount + warning.iccids.length
            }

            this.simsFailedValidationCount = 0
            for (let invalid of resp.validationGroups) {
                this.simsFailedValidationCount = this.simsFailedValidationCount + invalid.iccids.length
            }

            for(let err of resp.nonSimErrors) {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: err.errorName,
                    text: err.errorDescription,
                    duration: 5000,
                });
            }

            this.step1 = false
            this.selectedDGO = false
            this.selectedDGOStep2 = true
        },
        validateCap() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                if (this.dgoData.cap.value < 0) {
                    this.dgoData.cap.value = 0
                } else if (this.dgoData.cap.value % 1 != 0) {
                    this.dgoData.cap.value = Math.floor(this.dgoData.cap.value)
                }
            }, 500)
        },
        validateThrottle() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                if (this.dgoData.throttle.value < 0) {
                    this.dgoData.throttle.value = 0
                } else if (this.dgoData.throttle.value % 1 != 0) {
                    this.dgoData.throttle.value = Math.floor(this.dgoData.throttle.value)
                }
            }, 500)
        },
        applyDGO() {
            let parsedData = {
                iccid: [],
                dataGuard: {}
            }
            if (this.dgoData.throttle.value != 0 && this.dgoData.throttle.value != '') {
                parsedData.dataGuard.hasThrottle = 1
                parsedData.dataGuard.throttleAt = this.dgoData.throttle.value
                parsedData.dataGuard.throttleAtUnit = this.dgoData.throttle.unit
                parsedData.dataGuard.throttleSpeedId = this.dgoData.speed
            } else {
                parsedData.dataGuard.hasThrottle = 0
            }
            if (this.dgoData.cap.value != 0 && this.dgoData.cap.value != '') {
                parsedData.dataGuard.hasCap = 1
                parsedData.dataGuard.capAt = this.dgoData.cap.value
                parsedData.dataGuard.capAtUnit = this.dgoData.cap.unit
            } else {
                parsedData.dataGuard.hasCap = 0
            }

            for (let sim of this.simsPassedValidation.iccids) {
                parsedData.iccid.push(sim)
            }

            if(this.simsWarningValidation.length > 0) {
                for (let cat of this.simsWarningValidation) {
                    for (let sim of cat.iccids) {
                        parsedData.iccid.push(sim)
                    }
                }
            }
            Axios.post(globalStore.data.restApiUrl + '/subscriber/data-guard-override', parsedData)
                .then(response => {
                    this.resetBulkOperationsScreen()
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Bulk Data Guard Override applied',
                        text: 'SIMs you selected have assigned new values of Data Guard Override. To see transaction details <a href="/?#/transaction/' + response.data + '">Click here</a>',
                        duration: 5000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Bulk Data Guard Override error',
                        text: 'An error has occured during overrinding Data Guard Override.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        removeSimFromValidList(sim) {
            for (let i = 0; i < this.simsPassedValidation.iccids.length; i++) {
                if (this.simsPassedValidation.iccids[i] == sim) {
                    this.simsPassedValidation.iccids.splice(i,1)
                    i = this.simsPassedValidation.iccids.length
                }
            }
            this.selectRowModal(sim);
        },
        removeSimFromWarningList(sim) {
            for (let i = 0; i < this.simsWarningValidation.iccids.length; i++) {
                if (this.simsWarningValidation.iccids[i] == sim) {
                    this.simsWarningValidation.iccids.splice(i,1)
                    i = this.simsWarningValidation.iccids.length
                }
            }
            this.selectRowModal(sim);
        },
        onEnterPress(ev) {
            ev.keyCode === 13 ? this.addSimsFromBtn() : null;
        },
        addSimsFromBtn() {
            this.unselectAllRowModal();
            this.setDefaultFilters();
            this.setFilters();
            this.setInitialFilters()
            let simsArray = this.simsInput
            if (simsArray.indexOf(',') > -1) {
                simsArray = this.simsInput.split(',')
            }

            if (typeof simsArray == 'object') {
                for (let item of simsArray) {
                    if (item.indexOf(' ') > -1) {
                        let arrItem = item.split(' ')
                        for (let sim of arrItem) {
                            sim = sim.replace(/f/g, '');
                            sim = sim.replace(/F/g, '');
                            if (sim != "") {
                                this.simsInputParsed.push(sim)
                            }
                        }
                    } else {
                        item = item.replace(/f/g, '');
                        item = item.replace(/F/g, '');
                        this.simsInputParsed.push(item)
                    }
                }
            } else {
                if (simsArray.indexOf(' ') > -1) {
                    let arrItem = this.simsInput.split(' ')
                    for (let sim of arrItem) {
                        sim = sim.replace(/f/g, '');
                        sim = sim.replace(/F/g, '');
                        this.simsInputParsed.push(sim)
                    }
                } else {
                    let arrItem = [this.simsInput]
                    for (let sim of arrItem) {
                        sim = sim.replace(/f/g, '');
                        sim = sim.replace(/F/g, '');
                        this.simsInputParsed.push(sim)
                    }
                }
            }
            this.simsInput = ''
            this.validateSimList(this.simsInputParsed)
        },
        addSimsFromBtnColdstock() {
            this.unselectAllRowModal();
            let simsArray = this.simsInput
            if (simsArray.indexOf(',') > -1) {
                simsArray = this.simsInput.split(',')
            }

            if (typeof simsArray == 'object') {
                for (let item of simsArray) {
                    if (item.indexOf(' ') > -1) {
                        let arrItem = item.split(' ')
                        for (let sim of arrItem) {
                            sim = sim.replace(/f/g, '');
                            sim = sim.replace(/F/g, '');
                            if (sim != "") {
                                this.simsInputParsed.push(sim)
                            }
                        }
                    } else {
                        item = item.replace(/f/g, '');
                        item = item.replace(/F/g, '');
                        this.simsInputParsed.push(item)
                    }
                }
            } else {
                if (simsArray.indexOf(' ') > -1) {
                    this.simsInputParsed = this.simsInput.split(' ')
                }
            }
            this.simsInput = ''
            this.validateSimList(this.simsInputParsed)
        },
        validationPassedExpand() {
            this.validationPassedExpanded = !this.validationPassedExpanded;
        },
        validationFailedExpand() {
            this.validationFailedExpanded = !this.validationFailedExpanded;
        },
        validationWarningExpand() {
            this.validationWarningExpanded = !this.validationWarningExpanded;
        },
        selectRowModal(id, status) {
            if (typeof id == "string") {
                let parsedData = {
                    iccids: [],
                    forceOff: null
                };
                if (this.selectedRowsModal.indexOf(id) != -1) {
                    this.selectedRowsModal.splice(this.selectedRowsModal.indexOf(id), 1);
                    for (let i = 0 ; i < this.selectedRowsModalParsed.length ; i++) {
                        if (this.selectedRowsModalParsed[i].iccid == id) {
                            this.selectedRowsModalParsed.splice(i, 1);
                        }
                    }
                    parsedData = {
                        iccids: [id],
                        forceOff: true
                    };
                } else {
                    this.selectedRowsModal.push(id)
                    this.selectedRowsModalParsed.push({iccid: id, status: status})
                    parsedData = {
                        iccids: [id],
                        forceOn: true
                    };
                }
                Axios.post(globalStore.data.restApiUrl + '/sims/mark', parsedData)
                    .then(() => {
                        if (this.addingFromFile) {
                            this.getSimsListModal()
                            this.addingFromFile = false
                        }
                        if (parsedData.iccids.length > 0) {
                            this.$cookies.set('simsMarked', true)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Selected SIM failed',
                            text: 'Error Processing SIM Selection - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    });
            } else if (typeof id == "object") {

                let parsedData = {
                    iccids: null,
                    forceOn: null
                };

                if (this.selectedAllModal == 'true') {

                    let newId = []

                    for (let singleIccid in id) {
                        newId.push(id[singleIccid]['iccid'])
                    }

                    parsedData = {
                        iccids: newId,
                        forceOn: true
                    };

                    id.map(sim => {
                        this.selectedRowsModal.push(sim.iccid)
                        this.selectedRowsModalParsed.push({iccid: sim.iccid, status: sim.status})
                    })

                } else {

                    let newId = []

                    for (let singleIccid in id) {
                        newId.push(id[singleIccid]['iccid'])
                    }

                    parsedData = {
                        iccids: newId,
                        forceOff: true
                    };

                    id.map(sim => {
                        this.selectedRowsModal.splice(this.selectedRowsModal.indexOf(sim.iccid), 1);
                        this.selectedRowsModalParsed.filter((row, key) => {
                            if (row.iccid == sim.iccid){
                                this.selectedRowsModalParsed.splice(key, 1);
                            }
                        })
                    })
                }

                Axios.post(globalStore.data.restApiUrl + '/sims/mark', parsedData)
                    .then(() => {
                        if (this.addingFromFile) {
                            setTimeout(() => {
                                this.getSimsListModal()
                                this.addingFromFile = false
                            }, 500)
                        }
                        if (parsedData.iccids.length > 0) {
                            this.$cookies.set('simsMarked', true)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Selected SIM failed',
                            text: 'Error Processing SIM Selection - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    });
                this.setSelectAllModal();
            }
        },
        clearPlansSelected() {
            this.selectedPlansFrom = 3
            this.selectedPlansTo = 3
            this.selectedPlanFrom.id = 0;
            this.selectedPlanFrom.carrierId = 0
            this.selectedPlanTo.id = 0;
            this.selectedPlanTo.carrierId = 0
            this.sortSettingsModal.selectedRatePlan = ''
        },
        unselectAllRowModal() {
            this.simsFailedValidationFromFile = []
            this.selectedRowsModalParsed = []
            this.selectedColdStockArr = [];
            Axios.delete(globalStore.data.restApiUrl + "/sims/mark")
                .then(response => {
                    this.selectedRowsModal = []
                    if(this.$cookies.get('simsMarked') == 'true') {
                        this.$cookies.remove('simsMarked')
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Unselecting SIM cards on the server side failed.',
                        text: 'Error Processing SIM Selection - Contact Support',
                        duration: 3000,
                    });
                    console.log(error);
                });
        },
        changeRatePlan() {
            let parsedData = {
                targetPlanId: this.selectedPlanTo.id,
                iccids: this.simsPassedValidation.iccids
            }

            Axios.post(globalStore.data.restApiUrl + '/bulk/validation/simon/change-plan', parsedData)
                .then(response => {
                    let resp = response.data
                    let validIndex = null
                    let valid = null
                    for (let i = 0; i < resp.length; i++) {
                        if (resp[i].groupName == 'Valid') {
                            validIndex = i
                        }
                    }
                    if (validIndex != null) {
                        valid = resp[validIndex]
                        resp.splice(validIndex, 1)
                    }
                    if (valid != null) {
                        this.addSimArrayCheckedModal(valid.iccids)
                    }
                    this.simsFailedValidationFromFile = resp
                    if (this.simsInputParsed.length > 0) {
                        this.simsInputParsed = []
                    }
                }).catch(error => {
                    if (error.response.data.errors.length > 0) {
                        const errors = error.response.data.errors;
                        errors.map(item => {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Unable to complete the bulk plan change.',
                                text: 'Error Processing Bulk Rate Plan Change - Contact Support',
                                duration: 5000,
                            });
                        })
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Unable to complete the bulk plan change.',
                            text: 'Error Processing Bulk Rate Plan Change - Contact Support',
                            duration: 5000,
                        });
                    }
                    console.log(error)
                })
        },
        bulkPlanChangeSimon() {
            let parsedData = {
                iccids: this.simsPassedValidation.iccids,
                targetPlanId: this.ratePlanSelectedTo.id
            }
            Axios.post( globalStore.data.restApiUrl + '/sim-plan/bulk-change', parsedData)
                .then(response => {
                    this.resetBulkOperationsScreen();
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Changing mass rate plan success.',
                        text: 'Mass change rate plan was scheduling with success. To see transaction details <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                        duration: 5000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Unable to complete the bulk plan change.',
                        text: 'Error Processing Bulk Rate Plan Change - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        bulkPlanChangeVodafone() {
            let parsedData = {
                iccids: this.simsPassedValidation.iccids,
                targetRatePlanId: this.ratePlanSelectedTo.ratePlanId
            }
            Axios.post( globalStore.data.restApiUrl + '/vodafone-transaction/change-plan', parsedData)
                .then(response => {
                    this.resetBulkOperationsScreen();
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Changing mass rate plan success.',
                        text: 'Mass change rate plan was scheduling with success. To see transaction details <a href="/?#/transaction/' + response.data.id + '">Click here</a>',
                        duration: 5000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Unable to complete the bulk plan change.',
                        text: 'Error Processing Bulk Rate Plan Change - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        selectAllRowsModal() {
            let selected = false;

            if (this.selectedAllModal == 'true') {
                this.selectedAllModal = 'false';
            } else {
                this.selectedAllModal = 'true'
                selected = true;
            }
            let prepareIccids = [];

            if (selected) {
                for (let i = 0 ; i < this.simsList.length ; i++) {
                    if (this.selectedRowsModal.indexOf(this.simsList[i].iccid) == -1) {
                        prepareIccids.push({'iccid': this.simsList[i].iccid, 'status': this.simsList[i].status});
                    }
                }
            } else {
                for (let i = 0 ; i < this.simsList.length ; i++) {
                    if (this.selectedRowsModal.indexOf(this.simsList[i].iccid) != -1) {
                        prepareIccids.push({'iccid': this.simsList[i].iccid, 'status': this.simsList[i].status});
                    }
                }
            }
            this.selectRowModal(prepareIccids);
        },
        changeSort(sortId) {
            if (sortId == this.sortSettingsModal.sort) {
                this.sortSettingsModal.desc = !this.sortSettingsModal.desc
            }
            this.sortSettingsModal.sort = sortId
            this.getSimsListModal(false)
        },
        setAreaSort(sortId) {
            if (sortId != this.sortSettingsModal.sort) {
                return 'none'
            } else if (sortId == this.sortSettingsModal.sort && this.sortSettingsModal.desc) {
                return 'descending'
            } else if (sortId == this.sortSettingsModal.sort && this.sortSettingsModal.desc == false) {
                return 'ascending'
            }
        },
        searchKeyUpModal() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                this.searchRowModal()
            }, 500)
        },
        searchKeyDownModal() {
            clearTimeout(this.typingTimer)
        },
        searchRowModal() {
            this.loadingSimListModal = true;
            if (this.filterModal.length > 0) {
                this.searchStringModal = '&search=' + escape(this.filterModal);
            } else {
                this.searchStringModal = '';
            }

            this.getSimsListModal(true)
        },
        readSimFileModal(ev) {
            if (ev.target) {
                var f = ev.target.files[0];
            } else {
                var f = ev[0];
            }
            this.clearPlansSelected();
            this.unselectAllRowModal();
            this.setDefaultFilters();
            this.setFilters();
            this.setInitialFilters()

            var ext = f.name.slice(f.name.lastIndexOf("."));

            if (ext === ".csv") {

                var ret = [];
                var r = new FileReader();
                var tempThis = this;
                r.onload = function(e) {
                    var ct = r.result;
                    var words;

                    ct.indexOf("\n") > -1 ? words = ct.split("\n") : null;

                    if (typeof(words) == 'object') {
                        let tempArr = [];

                        for (let i = 0; i < words.length; i++) {
                            if (words[i].indexOf(",") > -1) {
                                let temptempArr = words[i].split(",");
                                for (let item in temptempArr) {
                                    if (temptempArr[item].length > 0) {
                                        tempArr.push(temptempArr[item])
                                    }
                                }
                            } else {
                                tempArr.push(words[i]);
                            }
                        }

                        words = tempArr
                    } else {
                        (ct.indexOf(",") > -1) ? words = ct.split(",") : null;
                    }

                    var len = words.length;
                    for (let i = 0 ; i < len ; i++){
                        words[i] = words[i].replace(/\D/g,'');
                        words[i] != "" ? ret.push(words[i]) : null;
                    }
                    tempThis.validateSimList(ret);
                }
                r.readAsText(f);
                this.$refs.importFile.value = null
            } else if (ext === '.txt') {

                var ret = [];
                if (ev.target) {
                    var f = ev.target.files[0];
                } else {
                    var f = ev[0];
                }

                if (f) {
                    var r = new FileReader();
                    var tempThis = this;
                    r.onload = function(e) {
                        var ct = r.result;

                        ct.indexOf("\n") > -1 ? ct = ct.split("\n") : null;

                        if (typeof(ct) == 'object') {
                            let tempArr = [];

                            for (let i = 0; i < ct.length; i++) {
                                if (ct[i].indexOf(",") > -1) {
                                    let temptempArr = ct[i].split(",");
                                    for (let item in temptempArr) {
                                        if (temptempArr[item].length > 0) {
                                            tempArr.push(temptempArr[item])
                                        }
                                    }
                                } else {
                                    tempArr.push(ct[i]);
                                }
                            }

                            ct = tempArr
                        } else {
                            ct.indexOf(",") > -1 ? ct = ct.split(",") : null;
                        }

                        var len = ct.length;
                        for (var i = 0 ; i < len ; i++) {
                            ct[i] = ct[i].replace(/\D/g,'');
                        }
                        let parsedTxtArray = [];
                        for (let item of ct) {
                            if (item != "") {
                                parsedTxtArray.push(item);
                            }
                        }

                        tempThis.validateSimList(parsedTxtArray)
                    }
                    r.readAsText(f);
                    this.$refs.importFile.value = null
                } else {
                    alert("Failed to load file");
                }
            } else if ( ext== '.xls' || ext === ".xlsx" ) {
                var tempThis = this;

                let formData = new FormData();
                formData.append('file', f);
                Axios.post(`${globalStore.data.restApiUrl}/sims/parse/xlsx`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then(response => {
                        let simsNumber = response.data
                        tempThis.validateSimList(simsNumber)
                        this.$refs.importFile.value = null
                    }).catch(error => {
                        console.log(error)
                    })

            }
        },
        readDraggedList(simList) {
            var words;
            var ret = [];

            simList.indexOf("\n") > -1 ? words = simList.split("\n") : null;
            if (typeof(words) == 'object') {
                let tempArr = [];

                for (let i = 0; i < words.length; i++) {
                    if (words[i].indexOf(",") > -1) {
                        let temptempArr = words[i].split(",");
                        for (let item in temptempArr) {
                            if (temptempArr[item].length > 0) {
                                tempArr.push(temptempArr[item])
                            }
                        }
                    } else {
                        tempArr.push(words[i]);
                    }
                }

                words = tempArr
            } else {
                simList.indexOf(",") > -1 ? words = simList.split(",") : null;
                if (words == undefined) {
                    simList.indexOf(" ") > -1 ? words = simList.split(" ") : null;
                }
                if (words == undefined) {
                    words = [simList]
                }
            }

            var len = words.length;

            for (let i = 0 ; i < len ; i++){
                words[i] = words[i].replace(/\D/g,'');
                words[i] != ""  ? ret.push(words[i]) : null;
            }
            this.validateSimList(ret);
        },
        addSimCheckedModal(sims) {
            let tempThis = this;
            sims.map(sim => {
                Axios.get(globalStore.data.restApiUrl + '/sims/' + sim)
                    .then(response => {
                        if (response.status == 200 && response['data']['count'] > 0) {
                            tempThis.selectRowModal(response.data.response[0]['iccid'], response.data.response[0]['status']);
                        } else {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Sim number not exist in base',
                                text: 'Invalid SIM Present During Upload - Not Found - Contact Support',
                                duration: 5000,
                            });
                        }

                    }).catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting sim details error',
                            text: 'We have error with get status of sims from file, please check if this sim number is right.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            })
        },
        addSimArrayCheckedModal(sims) {
            Axios.post(globalStore.data.restApiUrl + '/sims/info', sims)
                .then(response => {
                    let objWithSimsToSelect = [];

                    for (let item of response.data) {
                        let itemSimsToSelct = {
                            iccid: item.iccid,
                            status: item.status
                        };
                        objWithSimsToSelect.push(itemSimsToSelct);
                    }

                    this.selectedAllModal = 'true';
                    this.addingFromFile = true;
                    this.selectedCheckbox = true;
                    this.selectRowModal(objWithSimsToSelect);
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting sim details error',
                        text: 'We have error with get status of sims from file, please check if this sim number is right.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        resetSimsSelected(simsToSelect) {
            this.simsPassedValidation = {}
            this.simsFailedValidation = []
            this.simsFailedValidationCount = null
            this.simActionValidation = false
            this.simsFailedValidationFromFile = []
            this.selectedRowsModal = []
            this.selectedState = ''
            Axios.delete(globalStore.data.restApiUrl + "/sims/mark")
                .then(response => {
                    this.selectedRowsModal = []
                    if (simsToSelect && simsToSelect.length) {
                        this.selectRowModal(simsToSelect);
                    }
                    if(this.$cookies.get('simsMarked') == 'true') {
                        this.$cookies.remove('simsMarked')
                    }
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Unselecting SIM cards on the server side failed.',
                    text: 'Error Processing SIM Selection - Contact Support',
                    duration: 3000,
                });
                console.log(error);
            });
            this.selectedCheckbox = false
            this.getSimsListModal(true)
        },
        selectActionsModal() {
            this.adjustFilters(null);
            this.selectedPlanFrom.id = 0;
            this.selectedPlanFrom.carrierId = 0;
            this.sortSettingsModal.selectedRatePlan = '';
            this.simSwapStep2 = false;
            this.selectedActions = true
            this.selectedChangePlan = false
            this.selectedSimSwap = false
            this.selectedChangeState = false
            this.selectedTagsChange = false
            this.selectedTagsChangeStep2 = false
            this.selectedDGO = false
            this.selectedDGOStep2 = false
            this.resetSimsSelected();
        },
        selectPlanModal() {
            this.adjustFilters("PLANCHANGE");
            this.selectedPlanFrom.id = 0;
            this.selectedPlanFrom.carrierId = 0;
            this.sortSettingsModal.selectedRatePlan = '';
            this.simSwapStep2 = false;
            this.selectedActions = false
            this.selectedChangePlan = true
            this.selectedSimSwap = false
            this.selectedChangeState = false
            this.selectedState = ''
            this.selectedTagsChange = false
            this.selectedTagsChangeStep2 = false
            this.selectedDGO = false
            this.selectedDGOStep2 = false
            this.resetSimsSelected();
        },
        selectSwapModal() {
            this.adjustFilters("SIMSWAP");
            this.selectedPlanFrom.id = 0;
            this.selectedPlanFrom.carrierId = 0;
            this.sortSettingsModal.selectedRatePlan = '';
            this.simSwapStep2 = false;
            this.selectedActions = false
            this.selectedChangePlan = false
            this.selectedSimSwap = true
            this.simSwapStep1 = true
            this.selectedChangeState = false
            this.selectedTagsChange = false
            this.selectedTagsChangeStep2 = false
            this.selectedDGO = false
            this.selectedDGOStep2 = false
            this.resetSimsSelected();
        },
        selectTags() {
            this.adjustFilters(null);
            this.selectedPlanFrom.id = 0;
            this.selectedPlanFrom.carrierId = 0;
            this.sortSettingsModal.selectedRatePlan = '';
            this.simSwapStep2 = false;
            this.selectedActions = false
            this.selectedChangePlan = false
            this.selectedSimSwap = false
            this.simSwapStep1 = false
            this.selectedChangeState = false
            this.selectedTagsChange = true
            this.selectedTagsChangeStep2 = false
            this.selectedDGO = false
            this.selectedDGOStep2 = false
            this.resetSimsSelected();
        },
        selectDGO() {
            this.adjustFilters(null);
            this.selectedPlanFrom.id = 0;
            this.selectedPlanFrom.carrierId = 0;
            this.sortSettingsModal.selectedRatePlan = '';
            this.simSwapStep2 = false;
            this.selectedActions = false
            this.selectedChangePlan = false
            this.selectedSimSwap = false
            this.simSwapStep1 = false
            this.selectedChangeState = false
            this.selectedTagsChange = false
            this.selectedTagsChangeStep2 = false
            this.selectedDGO = true
            this.selectedDGOStep2 = false
            this.resetSimsSelected();
        },
        selectChangStateModal() {
            this.adjustFilters(null);
            this.selectedPlanFrom.id = 0;
            this.selectedPlanFrom.carrierId = 0;
            this.sortSettingsModal.selectedRatePlan = '';
            this.simSwapStep2 = false;
            this.selectedActions = false
            this.selectedChangePlan = false
            this.selectedSimSwap = false
            this.simSwapStep1 = false
            this.selectedChangeState = true
            this.selectedTagsChange = false
            this.selectedTagsChangeStep2 = false
            this.selectedDGO = false
            this.selectedDGOStep2 = false
            this.resetSimsSelected();
        },
        adjustFilters(code) {
            if (code == 'SIMSWAP') {
                if (this.selectedCarrrier == 1) {
                    this.statuses.simon.active = true
                    this.statuses.simon.activeReady = true
                    this.statuses.simon.suspended = false
                    this.statuses.simon.simBank = false
                    this.statuses.simon.inactive = false
                } else if (this.selectedCarrrier == 2) {
                    this.statuses.tmobile.active = true
                    this.statuses.tmobile.suspended = false
                    this.statuses.tmobile.inactive = false
                }
            } else if (code == 'PLANCHANGE') {
                if (this.selectedCarrrier == 1) {
                    this.statuses.simon.active = true
                    this.statuses.simon.activeReady = true
                    this.statuses.simon.suspended = false
                    this.statuses.simon.simBank = false
                    this.statuses.simon.inactive = false
                } else if (this.selectedCarrrier == 2) {
                    this.statuses.tmobile.active = true
                    this.statuses.tmobile.suspended = false
                    this.statuses.tmobile.inactive = false
                } else if (this.selectedCarrrier == 3) {
                    this.statuses.vodafone.activeLive = true
                    this.statuses.vodafone.activeSleep = true
                    this.statuses.vodafone.activeReady = true
                    this.statuses.vodafone.activeSuspended = true
                    this.statuses.vodafone.activeTest = true
                    this.statuses.vodafone.activeStandby = true
                    this.statuses.vodafone.inactiveStopped = false
                    this.statuses.vodafone.terminated = false
                    this.statuses.vodafone.inactive = false
                } else if (this.selectedCarrrier == 4) {
                    this.statuses.kore.active = true
                    this.statuses.kore.activeReady = true
                    this.statuses.kore.activeTest = true
                    this.statuses.kore.suspended = true
                    this.statuses.kore.suspendedWithCharge = true
                    this.statuses.kore.pendingScrap = true
                    this.statuses.kore.terminated = true
                    this.statuses.kore.deactivated = true
                }
            } else {
                if (this.selectedCarrrier == 1) {
                    this.statuses.simon.active = true
                    this.statuses.simon.activeReady = true
                    this.statuses.simon.suspended = true
                    this.statuses.simon.simBank = true
                    this.statuses.simon.inactive = true
                } else if (this.selectedCarrrier == 2) {
                    this.statuses.tmobile.active = true
                    this.statuses.tmobile.suspended = true
                    this.statuses.tmobile.inactive = true
                } else if (this.selectedCarrrier == 3) {
                    this.statuses.vodafone.activeLive = true
                    this.statuses.vodafone.activeSleep = true
                    this.statuses.vodafone.activeReady = true
                    this.statuses.vodafone.activeSuspended = true
                    this.statuses.vodafone.activeTest = true
                    this.statuses.vodafone.activeStandby = true
                    this.statuses.vodafone.inactiveStopped = true
                    this.statuses.vodafone.terminated = true
                    this.statuses.vodafone.inactive = true
                } else if (this.selectedCarrrier == 4) {
                    this.statuses.kore.active = true
                    this.statuses.kore.activeReady = true
                    this.statuses.kore.activeTest = true
                    this.statuses.kore.suspended = true
                    this.statuses.kore.suspendedWithCharge = true
                    this.statuses.kore.pendingScrap = true
                    this.statuses.kore.terminated = true
                    this.statuses.kore.deactivated = true
                }
            }
            this.setFilters()
            this.setInitialFilters();
        },
        sizePageModal() {
            this.loadingSimListModal = true;
            this.getSimsListModal(true)
        },
        getSimsListModal(notPagination) {
            this.simsList = []
            this.loadingSimListModal = true;
            if (notPagination){
                this.sortSettingsModal.page = 1;
                this.getPaginationModal();
            }
            if (this.selectedCheckbox == true) {
                this.showOnlySelected = '&selectedOnly=true'
            } else {
                this.showOnlySelected = ''
            }
            let noNBIoT = ''
            if (this.selectedChangePlan && this.selectedCarrrier == 1) {
                noNBIoT = '&excludeNbIotPlans=true'
            }
            let stateParam = '';
            if (this.selectedState.length > 0) {
                stateParam = '&requestedState=' + this.selectedState
            }
            Axios.get(globalStore.data.restApiUrl + "/sims" + '?page=' + this.sortSettingsModal.page + '&size=' + this.sortSettingsModal.size + '&sort=' + this.sortSettingsModal.sort + '&desc=' + this.sortSettingsModal.desc + stateParam + noNBIoT + this.searchStringModal + this.showOnlySelected + this.sortSettingsModal.selectedRatePlan + this.selectedCarrierUrl + this.filters)
                .then(response => {
                    if (response.status == 200) {

                        if (response.data.response.length > 0) {
                            this.noSimsModal = false;
                            let simList = response.data.response;
                            let selectedCount = 0;

                            simList.map(simRow => {
                                if (simRow.customFields) {
                                    simRow.customFields.map(customField => {
                                        if (customField.customFieldId == 1) {
                                            simRow.customField1 = customField.customFieldName
                                        }

                                        if (customField.customFieldId == 2) {
                                            simRow.customField2 = customField.customFieldName
                                        }
                                    })
                                }

                                let checkedSimModal = this.selectedRowsModal.filter(item => {
                                    return item.iccid == simRow.iccid
                                })

                                if (checkedSimModal.length > 0) {
                                    selectedCount++
                                }
                            })

                            this.simsList = simList;
                            this.loadingSimListModal = false;
                            this.setSelectAllModal()

                            if (document.querySelector('#bulk-modal___BV_modal_body_ .table-managment thead tr')) {
                                if (selectedCount == this.sortSettingsModal.size) {
                                    document.querySelector('#bulk-modal___BV_modal_body_ .table-managment thead tr').setAttribute('aria-selected', 'true')
                                } else {
                                    document.querySelector('#bulk-modal___BV_modal_body_ .table-managment thead tr').setAttribute('aria-selected', 'false')
                                }
                            }
                        } else {
                            this.loadingSimListModal = false;
                            this.noSimsModal = true;
                            this.simsList = [];
                        }
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                            duration: 5000,
                        });
                        this.loadingSimListModal = false;

                        return false;
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                    this.loadingSimListModal = false;

                    return false;
                });
        },
        getPaginationModal() {
            if (this.selectedCheckbox == true) {
                this.showOnlySelected = '&selectedOnly=true'
            } else {
                this.showOnlySelected = ''
            }
            let stateParam = '';
            if (this.selectedState.length > 0) {
                stateParam = '&requestedState=' + this.selectedState
            }
            let noNBIoT = ''
            if (this.selectedChangePlan && this.selectedCarrrier == 1) {
                noNBIoT = '&excludeNbIotPlans=true'
            }
            Axios.get(globalStore.data.restApiUrl + "/sim-page-count?size=" + this.sortSettingsModal.size + stateParam + noNBIoT + this.searchStringModal + this.showOnlySelected + this.sortSettingsModal.selectedRatePlan + this.selectedCarrierUrl + this.filters)
                .then(response => {
                    if (response.status == 200) {
                        this.paginationCountModal = Number (response.data);
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                            duration: 5000,
                        });

                        return false;
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)

                    return false;
                })
        },
        paginationControllModal(ev) {
            this.loadingSimListModal = true;
            this.sortSettingsModal.page = ev;
            this.getSimsListModal(false);
        },
        getCustomFields() {
            Axios.get(globalStore.data.restApiUrl + '/custom-fields')
                .then( response => {
                    this.customFields = response.data.hidden;
                    if (!this.customFields) {
                        response.data.fields.forEach(field => {
                            if (field.index == 1) {
                                this.custom1 = field.label;
                            } else if (field.index == 2) {
                                this.custom2 = field.label;
                            }
                        })
                    }
                })
        },
        selectFromPlan() {
            if (this.selectedRowsModal.length > 0) {
                this.loadingPlans = true
                this.plansFiltered = true
                this.filterPlans()
            } else {
                this.clearPlanFilters();
                this.plansFiltered = false
            }
            this.searchPlanFrom = ''
            this.$refs['select-from-plan'].show()
        },
        selectToPlan() {
            this.searchPlanTo = ''
            this.$refs['select-to-plan'].show()
        },
        deselectPlanFrom() {
            this.ratePlanSelectedFrom = []
            this.selectedPlanFrom = {
                id: 0,
                carrierId: 0,
                planName: '',
                category: false
            }
            this.sortSettingsModal.selectedRatePlan = ''
            this.getSimsListModal(true)
        },
        deselectPlanTo() {
            this.ratePlanSelectedTo = []
            this.selectedPlanTo = {
                id: 0,
                carrierId: 0,
                planName: '',
                category: false
            }
        },
        filterPlans() {
            let companyId = ''
            if (this.companyId != null) {
                companyId = '?companyId=' + this.companyId
            }
            Axios.post(globalStore.data.restApiUrl + '/sims/rate-plans' + companyId, {iccids: this.selectedRowsModal})
                .then(response => {
                    let ratePlansIds = []
                    for (let plan of response.data) {
                        ratePlansIds.push({
                            id: plan.ratePlanId,
                            iccidsCount: plan.iccids.length,
                            iccids: plan.iccids
                        })
                    }
                    this.ratePlansIds = ratePlansIds;
                    if (this.selectedCarrrier == 1) {
                        for (let plan of this.templateList) {
                            for (let i = 0; i < ratePlansIds.length; i++) {
                                if (ratePlansIds[i].id == plan.id) {
                                    plan.simsCount = ratePlansIds[i].iccidsCount
                                    plan.simsInPlan = ratePlansIds[i].iccids
                                    i = ratePlansIds.length
                                } else {
                                    plan.simsCount = false
                                }
                            }
                        }
                        this.loadingPlans = false
                    } else if (this.selectedCarrrier == 2) {
                        for (let plan of this.ratePlanAssigned) {
                            for (let i = 0; i < ratePlansIds.length; i++) {
                                if (ratePlansIds[i].id == plan.ratePlanId) {
                                    plan.simsCount = ratePlansIds[i].iccidsCount
                                    plan.simsInPlan = ratePlansIds[i].iccids
                                    i = ratePlansIds.length
                                } else {
                                    plan.simsCount = false
                                }
                            }
                        }
                        this.loadingPlans = false
                    } else if (this.selectedCarrrier == 3) {
                        for (let plan of this.vodafoneRatePlanAssigned) {
                            for (let i = 0; i < ratePlansIds.length; i++) {
                                if (ratePlansIds[i].id == plan.ratePlanId) {
                                    plan.simsCount = ratePlansIds[i].iccidsCount
                                    plan.simsInPlan = ratePlansIds[i].iccids
                                    i = ratePlansIds.length
                                } else {
                                    plan.simsCount = false
                                }
                            }
                        }
                        this.loadingPlans = false
                    }
                })
                .catch(error => {
                    this.loadingPlans = false
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Filtering plans error',
                        text: 'Something went wrong during filtering plans - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        clearPlanFilters() {
            if (this.selectedCarrrier == 1) {
                for (let plan of this.templateList) {
                    if (plan.simsCount) {
                        delete plan.simsCount
                        delete plan.simsInPlan
                    }
                }
            } else if (this.selectedCarrrier == 2) {
                for (let plan of this.ratePlanAssigned) {
                    if (plan.simsCount) {
                        delete plan.simsCount
                        delete plan.simsInPlan
                    }
                }
            } else if (this.selectedCarrrier == 3) {
                for (let plan of this.vodafoneRatePlanAssigned) {
                    if (plan.simsCount) {
                        delete plan.simsCount
                        delete plan.simsInPlan
                    }
                }
            }
        },
        searchKeyUpColdStock() {
            clearTimeout(this.typingTimerColdStock)
            this.typingTimerColdStock = setTimeout(() => {
                this.searchRowColdStock()
            }, 500)
        },
        searchKeyDownColdStock() {
            clearTimeout(this.typingTimerColdStock)
        },
        searchRowColdStock() {
            if (this.filterColdStock.length > 0) {
                this.searchStringColdStock = '&search=' + escape(this.filterColdStock);
            } else {
                this.searchStringColdStock = ''
            }
            this.getColdStocks(true)
        },
        selectRowColdStock(id) {
            if (this.selectedColdStockArr.indexOf(id) != -1) {
                this.selectedColdStockArr.splice(this.selectedColdStockArr.indexOf(id), 1);
            } else {
                this.selectedColdStockArr.push(id)
            }
        },
        sizePageColdStock() {
            this.loadingColdSims = true;
            this.getColdStocks(true)
        },
        selectAllRowsColdStock() {
            let selected = false;

            if (this.selectedAllColdStock == 'true') {
                this.selectedAllColdStock = 'false';
            } else {
                this.selectedAllColdStock = 'true'
                selected = true;
            }
            this.coldStockList.map(item => {
                if (selected) {
                    if (this.selectedColdStockArr.indexOf(item.iccid) == -1) {
                        this.selectRowColdStock(item.iccid);
                    }
                } else {
                    if (this.selectedColdStockArr.indexOf(item.iccid) != -1) {
                        this.selectRowColdStock(item.iccid);
                    }
                }
            })
        },
        paginationControllColdStock(ev) {
            this.loadingColdSims = true;
            this.sortSettingsColdStock.page = ev;
            this.getColdStocks(false);
        },
        getPaginationColdStock() {
            Axios.get(globalStore.data.restApiUrl + "/cold-stock/page-count?size=" + this.sortSettingsColdStock.size + '&carrierId=' + this.selectedCarrrier + this.searchStringColdStock)
                .then(response => {
                    if (response.status == 200) {
                        this.paginationCountColdStock = Number (response.data);
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                            duration: 5000,
                        });

                        return false;
                    }
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                    duration: 5000,
                });
                console.log(error)

                return false;
            })
        },
        getColdStocks(notPagination) {
            if (notPagination){
                this.sortSettingsColdStock.page = 1;
            }
            this.getPaginationColdStock()
            Axios.get(`${globalStore.data.restApiUrl}/cold-stock?page=${this.sortSettingsColdStock.page}&size=${this.sortSettingsColdStock.size}&sort=${this.sortSettingsColdStock.sort}&desc=${this.sortSettingsColdStock.desc}&carrierId=${this.selectedCarrrier}${this.searchStringColdStock}`)
                .then(response => {
                    this.coldStockList = response.data
                    this.loadingColdSims = false
                }).catch(error => {
                    this.loadingColdSims = false
                     this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Something was wrong',
                        text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                        duration: 5000,
                    });
                    return false;
                })
        },
        getTmobileRatePlan() {
            Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=2`)
                .then(response => {
                    this.ratePlanAssigned = response.data.response
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Retrieving Rate Plan Details for Bulk Operations - Contact Support',
                    duration: 5000,
                });
                console.log(error)
            })
        },
        getVodafoneRatePlan() {
            Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=3`)
                .then(response => {
                    this.vodafoneRatePlanAssigned = response.data.response
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Retrieving Rate Plan Details for Bulk Operations - Contact Support',
                    duration: 5000,
                });
                console.log(error)
            })
        },
        startModalApp() {
            if (this.selectedCarrrier == 1) {
                this.getRatePlans()
            } else if (this.selectedCarrrier == 2) {
                this.getTmobileRatePlan()
            } else if (this.selectedCarrrier == 3) {
                this.getVodafoneRatePlan()
            }
            this.setFilters();
            this.setInitialFilters();
            this.getCustomFields()
            if (this.selectedCarrrier != 3) {
                this.selectActionsModal()
            } else {
                this.selectChangStateModal();
            }
        },
        isSelectedColdStock(id) {
            let isSelected = false;
            if (this.selectedColdStockArr.indexOf(id) != -1) {
                isSelected = true;
            }
            return isSelected;
        },
        setSelectAllModal() {
            let isAllSelected = 0;
            for (let i = 0 ; i < this.simsList.length ; i++) {
                if (this.selectedRowsModal.indexOf(this.simsList[i].iccid) != -1) {
                    isAllSelected++;
                }
            }
            if ((this.simsList.length > 0) && (isAllSelected == this.simsList.length)) {
                this.selectedAllModal = 'true';
            } else {
                this.selectedAllModal = 'false';
            }
        },
        isSelected(id) {
            let isSelected = false;
            if (this.selectedRowsModal.indexOf(id) != -1) {
                isSelected = true;
            }
            return isSelected;
        },
        clickFilters() {
            this.$refs['filtersModal'].show()
            this.setInitialFilters()
        },
        selectAllStatuses(carrierId) {
            if (carrierId == 1) {
                this.statuses.simon.active = true
                this.statuses.simon.activeReady = true
                this.statuses.simon.suspended = true
                this.statuses.simon.simBank = true
                this.statuses.simon.inactive = true
            } else if (carrierId == 2) {
                this.statuses.tmobile.active = true
                this.statuses.tmobile.suspended = true
                this.statuses.tmobile.inactive = true
            } else if (carrierId == 3) {
                this.statuses.vodafone.activeSuspended = true
                this.statuses.vodafone.activeTest = true
                this.statuses.vodafone.activeStandby = true
                this.statuses.vodafone.inactiveStopped = true
                this.statuses.vodafone.inactive = true
                this.statuses.vodafone.terminated = true
                this.statuses.vodafone.activeReady = true
                this.statuses.vodafone.activeSleep = true
                this.statuses.vodafone.activeLive = true
            } else if (carrierId == 4) {
                this.statuses.kore.active = true
                this.statuses.kore.activeTest = true
                this.statuses.kore.activeReady = true
                this.statuses.kore.suspended = true
                this.statuses.kore.suspendedWithCharge = true
                this.statuses.kore.terminated = true
                this.statuses.kore.deactivated = true
                this.statuses.kore.pendingScrap = true
            }
        },
        unselectAllStatuses(carrierId) {
            if (carrierId == 1) {
                let initialSimon = this.simonFilter;
                this.simonFilter = false

                this.statuses.simon.active = false
                this.statuses.simon.activeReady = false
                this.statuses.simon.suspended = false
                this.statuses.simon.simBank = false
                this.statuses.simon.inactive = false

                if (initialSimon == true) {
                    this.countPlans();
                    this.getPlansList();
                }
            } else if (carrierId == 2) {
                let initialTmobile = this.tmobileFilter;
                this.tmobileFilter = false

                this.statuses.tmobile.active = false
                this.statuses.tmobile.suspended = false
                this.statuses.tmobile.inactive = false

                if (initialTmobile == true) {
                    this.countPlans();
                    this.getPlansList();
                }
            } else if (carrierId == 3) {
                let initialVodafone = this.vodafoneFilter;
                this.vodafoneFilter = false

                this.statuses.vodafone.activeSuspended = false
                this.statuses.vodafone.activeTest = false
                this.statuses.vodafone.activeStandby = false
                this.statuses.vodafone.inactiveStopped = false
                this.statuses.vodafone.inactive = false
                this.statuses.vodafone.terminated = false
                this.statuses.vodafone.activeReady = false
                this.statuses.vodafone.activeSleep = false
                this.statuses.vodafone.activeLive = false

                if (initialVodafone == true) {
                    this.countPlans();
                    this.getPlansList();
                }
            } else if (carrierId == 4) {
                let initialKore = this.koreFilter;
                this.koreFilter = false

                this.statuses.kore.active = false
                this.statuses.kore.activeTest = false
                this.statuses.kore.activeReady = false
                this.statuses.kore.suspended = false
                this.statuses.kore.suspendedWithCharge = false
                this.statuses.kore.terminated = false
                this.statuses.kore.deactivated = false
                this.statuses.kore.pendingScrap = false

                if (initialKore == true) {
                    this.countPlans();
                    this.getPlansList();
                }
            }
        },
        applyFilters() {
            this.runFilters();
            this.$refs['filtersModal'].hide();
        },
        runFilters() {
            this.setFilters();
            this.getSimsListModal(true)
            this.setInitialFilters()
        },
        getTagsAddListBulk() {Axios.get(globalStore.data.restApiUrl + "/tags?sort=" + this.searchAddTag.sort + "&desc=" + this.searchAddTag.desc + this.addTagsSearch)
            .then(response => {
                let tags = response.data
                this.addTagsList = []
                if (this.selectedAddTags.length > 0) {
                    for (let tag of tags) {
                        let selected = false
                        for(let item of this.selectedAddTags) {
                            if (item.id == tag.id) {
                                selected = true
                            }
                        }
                        let template = {
                            id: tag.id,
                            label: tag.label,
                            selected: selected
                        }
                        this.addTagsList.push(template)
                    }
                } else {
                    for (let tag of tags) {
                        let template = {
                            id: tag.id,
                            label: tag.label,
                            selected: false
                        }
                        this.addTagsList.push(template)
                    }
                }
            })
            .catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Getting tags failed.',
                    text: 'Error has occured during getting tags, please contact support.',
                    duration: 3000,
                });
                console.log(error)
            })
        },
        checkIfTagSelected(list, label) {
            let result = false
            if (list == 'ADD') {
                for (let item of this.removeTagsList) {
                    if (label == item.label && item.selected) {
                        return true
                    }
                }
            } else {
                for (let item of this.addTagsList) {
                    if (label == item.label && item.selected) {
                        return true
                    }
                }
            }
            return result
        },
        selectAllTagsRemove() {
            if (this.removeTagsList.length == (this.selectedRemoveTags.length + this.selectedAddTags.length)) {
                for (let tag of this.removeTagsList) {
                    tag.selected = false
                }
                this.selectedRemoveTags = []
            } else {
                for (let tag of this.removeTagsList) {
                    if(tag.selected == false && !this.checkIfTagSelected('REMOVE', tag.label)) {
                        this.selectRemoveTag(tag)
                    }
                }
            }
        },
        selectAllTagsAdd() {
            if (this.addTagsList.length == (this.selectedAddTags.length + this.selectedRemoveTags.length)) {
                for (let tag of this.addTagsList) {
                    tag.selected = false
                }
                this.selectedAddTags = []
            } else {
                for (let tag of this.addTagsList) {
                    if(tag.selected == false && !this.checkIfTagSelected('ADD', tag.label)) {
                        this.selectAddTag(tag)
                    }
                }
            }
        },
        searchKeyUpTagsAdd() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                this.searchAddTags()
            }, 500)
        },
        searchKeyDownTagsAdd() {
            clearTimeout(this.typingTimer)
        },
        searchKeyUpTagsRemove() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                this.searchRemoveTags()
            }, 500)
        },
        searchKeyDownTagsRemove() {
            clearTimeout(this.typingTimer)
        },
        getTagsRemoveListBulk() {
            Axios.get(globalStore.data.restApiUrl + "/tags?sort=" + this.searchRemoveTag.sort + "&desc=" + this.searchRemoveTag.desc + this.removeTagsSearch)
                .then(response => {
                    let tags = response.data
                    this.removeTagsList = []
                    if (this.selectedRemoveTags.length > 0) {
                        for (let tag of tags) {
                            let selected = false
                            for(let item of this.selectedRemoveTags) {
                                if (item.id == tag.id) {
                                    selected = true
                                }
                            }
                            let template = {
                                id: tag.id,
                                label: tag.label,
                                selected: selected
                            }
                            this.removeTagsList.push(template)
                        }
                    } else {
                        for (let tag of tags) {
                            let template = {
                                id: tag.id,
                                label: tag.label,
                                selected: false
                            }
                            this.removeTagsList.push(template)
                        }
                    }
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Getting tags failed.',
                        text: 'Error has occured during getting tags, please contact support.',
                        duration: 3000,
                    });
                    console.log(error)
                })
        },
        getTagsList() {
            Axios.get(globalStore.data.restApiUrl + "/tags?sort=" + this.searchTag.sort + "&desc=" + this.searchTag.desc)
                .then(response => {
                    let tags = response.data
                    this.tagsList = []
                    if (this.selectedTags.length > 0) {
                        for (let tag of tags) {
                            let selected = false
                            for(let item of this.selectedTags) {
                                if (item.id == tag.id) {
                                    selected = true
                                }
                            }
                            let template = {
                                id: tag.id,
                                label: tag.label,
                                selected: selected
                            }
                            this.tagsList.push(template)
                        }
                    } else {
                        for (let tag of tags) {
                            let template = {
                                id: tag.id,
                                label: tag.label,
                                selected: false
                            }
                            this.tagsList.push(template)
                        }
                    }
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Getting tags failed.',
                        text: 'Error has occured during getting tags, please contact support.',
                        duration: 3000,
                    });
                    console.log(error)
                })
        },
        showExportSelectTags() {
            this.$refs['fileFormatModalTags'].show();
        },
        hideExportSelectTags() {
            this.$refs['fileFormatModalTags'].hide();
        },
        openTagsExportModal() {
            this.showExportSelectTags();
        },
        exportCsvTags() {
            Axios.post( globalStore.data.restApiUrl + '/tags/change/summary/csv', this.tagsResponse.tagChangeItems)
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', 'SIM list - tags change.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.$refs['fileFormatModalTags'].hide();
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportXlsxTags() {
            Axios.post( globalStore.data.restApiUrl + '/tags/change/summary/xlsx', this.tagsResponse.tagChangeItems, {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', 'SIM list - tags change.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    this.$refs['fileFormatModalTags'].hide();
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });

        },
        applyTagsChange() {
            Axios.post(globalStore.data.restApiUrl + '/tags/change/execute?companyId=' + this.companyId, this.tagsResponse.tagChangeItems)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Bulk tags change made successfully.',
                        text: 'All tags changes has been saved in database.',
                        duration: 3000,
                    });
                    this.step1 = true
                    this.resetBulkOperationsScreen()
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Bulk changing tags failed.',
                        text: 'Error has occured during saving bulk tags changes, please contact support.',
                        duration: 3000,
                    });
                    console.log(error)
                })
        },
        selectTag(tag) {
            tag.selected = true
            this.selectedTags.push({
                id: tag.id,
                label: tag.label,
                selected: true
            })
            if (this.selectedTags.length  == 0) {
                this.selectedTagsCounter = ''
            } else if (this.selectedTags.length == 1) {
                this.selectedTagsCounter = this.selectedTags.length + ' tag selected'
            } else if (this.selectedTags.length > 1) {
                this.selectedTagsCounter =  this.selectedTags.length + ' tags selected'
            }
        },
        deselectTag(tag) {
            for (let item of this.tagsList) {
                if (item.id == tag.id) {
                    item.selected = false
                }
            }

            for (let i = 0; i < this.selectedTags.length; i ++) {
                if (tag.id ==  this.selectedTags[i].id) {
                    this.selectedTags.splice(i, 1);
                }
            }

            if (this.selectedTags.length  == 0) {
                this.selectedTagsCounter = ''
            } else if (this.selectedTags.length == 1) {
                this.selectedTagsCounter = this.selectedTags.length + ' tag selected'
            } else if (this.selectedTags.length > 1) {
                this.selectedTagsCounter =  this.selectedTags.length + ' tags selected'
            }
        },
        searchTags(tag) {
            if (tag.label.toLowerCase().indexOf(this.filtersSearch.toLowerCase()) < 0) {
                return true
            } else {
                return false
            }
        },
        setMostUsed() {
            if (this.searchTag.sort == 2){
                this.searchTag.desc = !this.searchTag.desc;
            } else {
                this.searchTag.sort = 2;
                this.searchTag.desc = false;
            }
            this.getTagsList();
        },
        setAlpha(){
            if (this.searchTag.sort == 1) {
                this.searchTag.desc = !this.searchTag.desc;
            } else {
                this.searchTag.sort = 1;
                this.searchTag.desc = false;
            }
            this.getTagsList();
        },
        selectAddTag(tag) {
            if (tag.selected) {
                this.deselectAddTag(tag)
            } else {
                tag.selected = true
                this.selectedAddTags.push({
                    id: tag.id,
                    label: tag.label,
                    selected: true
                })
            }
        },
        deselectAddTag(tag) {
            for (let item of this.addTagsList) {
                if (item.id == tag.id) {
                    item.selected = false
                }
            }

            for (let i = 0; i < this.selectedAddTags.length; i ++) {
                if (tag.id ==  this.selectedAddTags[i].id) {
                    this.selectedAddTags.splice(i, 1);
                }
            }
        },
        searchAddTags() {
            this.addTagsSearch = '&search=' + this.searchAddTag.phrase
            this.getTagsAddListBulk()
        },
        searchRemoveTags() {
            this.removeTagsSearch = '&search=' + this.searchRemoveTag.phrase
            this.getTagsRemoveListBulk()
        },
        setAlphaAdd() {
            this.searchAddTag.desc = !this.searchAddTag.desc;
            this.getTagsAddListBulk();
        },
        selectRemoveTag(tag) {
            if (tag.selected) {
                this.deselectRemoveTag(tag)
            } else {
                tag.selected = true
                this.selectedRemoveTags.push({
                    id: tag.id,
                    label: tag.label,
                    selected: true
                })
            }
        },
        deselectRemoveTag(tag) {
            for (let item of this.removeTagsList) {
                if (item.id == tag.id) {
                    item.selected = false
                }
            }

            for (let i = 0; i < this.selectedRemoveTags.length; i ++) {
                if (tag.id ==  this.selectedRemoveTags[i].id) {
                    this.selectedRemoveTags.splice(i, 1);
                }
            }
        },
        setAlphaRemove() {
            this.searchRemoveTag.desc = !this.searchRemoveTag.desc;
            this.getTagsRemoveListBulk();
        },
        getPlansList() {
            this.plansList = [];

            this.plansParsed = {
                A: [],
                B: [],
                C: [],
                D: [],
                E: [],
                F: [],
                G: [],
                H: [],
                I: [],
                J: [],
                K: [],
                L: [],
                M: [],
                N: [],
                O: [],
                P: [],
                Q: [],
                R: [],
                S: [],
                T: [],
                U: [],
                V: [],
                W: [],
                X: [],
                Y: [],
                Z: [],
                misc: []
            }

            if (this.selectedCarrrier == 1) {
                Axios.get(globalStore.data.restApiUrl + "/account/rate-plans")
                    .then(response => {
                        for (let plan of response.data.response) {
                            let template = {
                                id: plan.ratePlanId,
                                name: plan.planName,
                                carrierId: plan.carrierId,
                                selected: false,
                                dataLimit: plan.dataLimit.mbLimit
                            }
                            this.assignAlpha(template)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting Simon IoT plans failed.',
                            text: 'Error has occured during getting Simon IoT plans, please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            }
            if (this.selectedCarrrier == 2) {
                Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=2`)
                    .then(response => {
                        for (let plan of response.data.response) {
                            let template = {
                                id: plan.ratePlanId,
                                name: plan.planName,
                                carrierId: plan.carrierId,
                                selected: false,
                                dataLimit: null
                            }
                            this.assignAlpha(template)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting T-Mobile plans failed.',
                            text: 'Error has occured during getting T-Mobile plans, please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            }
            if (this.selectedCarrrier == 3) {
                Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=3`)
                    .then(response => {
                        for (let plan of response.data.response) {
                            let template = {
                                id: plan.ratePlanId,
                                name: plan.planName,
                                carrierId: plan.carrierId,
                                selected: false,
                                dataLimit: plan.dataLimit.mbLimit
                            }
                            this.assignAlpha(template)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting Simon IoT plans failed.',
                            text: 'Error has occured during getting Vodafone plans, please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            }
            if (this.selectedCarrrier == 4) {
                Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=4`)
                    .then(response => {
                        for (let plan of response.data.response) {
                            let template = {
                                id: plan.ratePlanId,
                                name: plan.planName,
                                carrierId: plan.carrierId,
                                selected: false,
                                dataLimit: (plan.planCategory && plan.planCategory.planCategoryId && plan.planCategory.planCategoryId == 14) ? 500 : null
                            }
                            this.assignAlpha(template)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting Simon IoT plans failed.',
                            text: 'Error has occured during getting Vodafone plans, please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            }
        },
        assignAlpha(plan) {
            if (plan.name.charAt(0).toLowerCase() == 'a') {
                this.plansParsed.A.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'b') {
                this.plansParsed.B.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'c') {
                this.plansParsed.C.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'd') {
                this.plansParsed.D.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'e') {
                this.plansParsed.E.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'f') {
                this.plansParsed.F.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'g') {
                this.plansParsed.G.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'h') {
                this.plansParsed.H.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'i') {
                this.plansParsed.I.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'j') {
                this.plansParsed.J.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'k') {
                this.plansParsed.K.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'l') {
                this.plansParsed.L.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'm') {
                this.plansParsed.M.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'n') {
                this.plansParsed.N.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'o') {
                this.plansParsed.O.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'p') {
                this.plansParsed.P.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'q') {
                this.plansParsed.Q.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'r') {
                this.plansParsed.R.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 's') {
                this.plansParsed.S.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 't') {
                this.plansParsed.T.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'u') {
                this.plansParsed.U.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'v') {
                this.plansParsed.V.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'w') {
                this.plansParsed.W.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'x') {
                this.plansParsed.X.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'y') {
                this.plansParsed.Y.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'z') {
                this.plansParsed.Z.push(plan)
            } else {
                this.plansParsed.misc.push(plan)
            }
        },
        filterStatuses(status) {
            if (this.filtersSearch != '') {
                if (status.toLowerCase().indexOf(this.filtersSearch.toLowerCase()) < 0) {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        },
        searchPlans(plan) {
            if (this.filtersSearch != '') {
                if (plan.name.toLowerCase().indexOf(this.filtersSearch.toLowerCase()) > -1) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },
        searchThroughPlans(plans) {
            let counter = 0;
            if (plans.length) {
                for (let plan of plans) {
                    if (this.searchPlans(plan)) {
                        counter++;
                    }
                }
                if (counter == 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        setDefaultFilters() {
            if (this.selectedCarrrier == 1) {
                this.statuses.simon = {
                    active: true,
                    suspended: true,
                    simBank: true,
                    inactive: true
                }
            }

            if (this.selectedCarrrier == 2) {
                this.statuses.tmobile = {
                    active: true,
                    suspended: true,
                    inactive: true
                }
            }

            if (this.selectedCarrrier == 3) {
                this.statuses.vodafone = {
                    activeLive: true,
                    activeSleep: true,
                    activeReady: true,
                    activeSuspended: true,
                    activeTest: true,
                    activeStandby: true,
                    inactiveStopped: true,
                    terminated: true,
                    inactive: true
                }
            }

            if (this.selectedCarrrier == 4) {
                this.statuses.kore = {
                    active: true,
                    activeTest: true,
                    activeReady: true,
                    suspended: true,
                    suspendedWithCharge: true,
                    pendingScrap: true,
                    terminated: true,
                    deactivated: true
                }
            }

            for (let plans in this.plansParsed) {
                for (let plan of this.plansParsed[plans]) {
                    plan.selected = false;
                }
            }
            this.selectedPlans = [];

            this.selectedPlansFilter = []

            this.selectedPlansFilterCounter = 0;

            for (let tag of this.tagsList) {
                tag.selected = false
            }
            this.selectedTags = []
        },
        setFilters() {
            this.filters = '&applyStatusesFiltering=true';

            if (this.selectedCarrrier == 1) {
                if (this.statuses.simon.active || this.statuses.simon.activeReady || this.statuses.simon.suspended || this.statuses.simon.simBank || this.statuses.simon.inactive) {
                    if (this.statuses.simon.active) {
                        this.filters = this.filters + '&genesisStatuses=ACTIVE'
                    }
                    if (this.statuses.simon.activeReady) {
                        this.filters = this.filters + '&genesisStatuses=ACTIVE_READY'
                    }
                    if (this.statuses.simon.suspended) {
                        this.filters = this.filters + '&genesisStatuses=SUSPENDED'
                    }
                    if (this.statuses.simon.simBank) {
                        this.filters = this.filters + '&genesisStatuses=SIM_BANK'
                    }
                    if (this.statuses.simon.inactive) {
                        this.filters = this.filters + '&genesisStatuses=INACTIVE'
                    }
                }
            }

            if (this.selectedCarrrier == 2) {
                if (this.statuses.tmobile.active || this.statuses.tmobile.suspended || this.statuses.tmobile.inactive) {
                    if (this.statuses.tmobile.active) {
                        this.filters = this.filters + '&magentaStatuses=ACTIVE'
                    }
                    if (this.statuses.tmobile.suspended) {
                        this.filters = this.filters + '&magentaStatuses=SUSPENDED'
                    }
                    if (this.statuses.tmobile.inactive) {
                        this.filters = this.filters + '&magentaStatuses=INACTIVE'
                    }
                }
            }
            if (this.selectedCarrrier == 3) {
                if (this.statuses.vodafone.activeLive || this.statuses.vodafone.activeSleep || this.statuses.vodafone.activeReady || this.statuses.vodafone.activeSuspended || this.statuses.vodafone.activeTest || this.statuses.vodafone.activeStandby || this.statuses.vodafone.inactiveStopped || this.statuses.vodafone.inactive || this.statuses.vodafone.terminated) {
                    if (this.statuses.vodafone.activeLive) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_LIVE'
                    }
                    if (this.statuses.vodafone.activeSleep) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_SLEEP'
                    }
                    if (this.statuses.vodafone.activeReady) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_READY'
                    }
                    if (this.statuses.vodafone.activeSuspended) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_SUSPEND'
                    }
                    if (this.statuses.vodafone.activeTest) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_TEST'
                    }
                    if (this.statuses.vodafone.activeStandby) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_STANDBY'
                    }
                    if (this.statuses.vodafone.inactiveStopped) {
                        this.filters = this.filters + '&vodafoneStatuses=INACTIVE_STOPPED'
                    }
                    if (this.statuses.vodafone.inactive) {
                        this.filters = this.filters + '&vodafoneStatuses=INACTIVE'
                    }
                    if (this.statuses.vodafone.terminated) {
                        this.filters = this.filters + '&vodafoneStatuses=TERMINATED'
                    }
                }
            } else {
                if (this.statuses.kore.active || this.statuses.kore.activeReady || this.statuses.kore.activeTest || this.statuses.kore.suspended || this.statuses.kore.suspendedWithCharge || this.statuses.kore.pendingScrap || this.statuses.kore.terminated || this.statuses.kore.deactivated) {
                    if (this.statuses.kore.active) {
                        this.filters = this.filters + '&koreStatuses=ACTIVE'
                    }
                    if (this.statuses.kore.activeReady) {
                        this.filters = this.filters + '&koreStatuses=ACTIVE_READY'
                    }
                    if (this.statuses.kore.activeTest) {
                        this.filters = this.filters + '&koreStatuses=ACTIVE_TEST'
                    }
                    if (this.statuses.kore.suspended) {
                        this.filters = this.filters + '&koreStatuses=SUSPENDED'
                    }
                    if (this.statuses.kore.suspendedWithCharge) {
                        this.filters = this.filters + '&koreStatuses=SUSPEND_WITH_CHARGE'
                    }
                    if (this.statuses.kore.pendingScrap) {
                        this.filters = this.filters + '&koreStatuses=PENDING_SCRAP'
                    }
                    if (this.statuses.kore.deactivated) {
                        this.filters = this.filters + '&koreStatuses=DEACTIVATED'
                    }
                    if (this.statuses.kore.terminated) {
                        this.filters = this.filters + '&koreStatuses=TERMINATED'
                    }
                }
            }

            if (this.selectedTags.length > 0) {
                for (let tag of this.selectedTags) {
                    this.filters = this.filters + '&tagIds=' + tag.id
                }
            }

            for (let plans in this.plansParsed) {
                for (let plan of this.plansParsed[plans]) {
                    if (plan.selected) {
                        if (plan.carrierId == 1) {
                            this.filters = this.filters + '&templateIds=' + plan.id
                        } else {
                            this.filters = this.filters + '&ratePlanIds=' + plan.id
                        }
                    }
                }
            }
        },
        selectPlan(plan) {
            if (plan.selected) {
                this.selectedPlansFilter.push(plan)
                this.countPlans()
            } else {
                for (let i = 0; i < this.selectedPlansFilter.length ; i++) {
                    if (this.selectedPlansFilter[i].id == plan.id) {
                        this.selectedPlansFilter.splice(i, 1);
                        this.countPlans()
                        return false
                    }
                }
            }
        },
        filterPlansFrom(planName) {
            if (planName.toLowerCase().indexOf(this.searchPlanFrom.toLowerCase()) == -1) {
                return true
            } else {
                return false
            }
        },
        filterPlansTo(planName) {
            if (planName.toLowerCase().indexOf(this.searchPlanTo.toLowerCase()) == -1) {
                return true
            } else {
                return false
            }
        },
        countPlans() {
            if (this.selectedPlansFilter.length == 0) {
                this.selectedPlansFilterCounter = ''
            } else if (this.selectedPlansFilter.length == 1) {
                this.selectedPlansFilterCounter = '1 plan selected'
            } else {
                this.selectedPlansFilterCounter = this.selectedPlansFilter.length + ' plans selected'
            }
        },
        deselectPlan(plan) {
            for (let i = 0; i < this.selectedPlansFilter.length ; i++) {
                if (this.selectedPlansFilter[i].id == plan.id) {
                    this.selectedPlansFilter.splice(i, 1);
                    this.countPlans()
                }
            }

            for (let plans in this.plansParsed) {
                for (let item of this.plansParsed[plans]) {
                    if (item.id == plan.id) {
                        item.selected = false;
                        return false;
                    }
                }
            }
        },
        setInitialFilters() {
            this.initialFilters = {
                selectedTags: [],
                selectedPlansFilter: [],
                statuses: {
                    simon: {
                        active: this.statuses.simon.active,
                        activeReady: this.statuses.simon.activeReady,
                        suspended: this.statuses.simon.suspended,
                        simBank: this.statuses.simon.simBank,
                        inactive: this.statuses.simon.inactive
                    },
                    tmobile: {
                        active: this.statuses.tmobile.active,
                        suspended: this.statuses.tmobile.suspended,
                        inactive: this.statuses.tmobile.inactive
                    },
                    vodafone: {
                        activeLive: this.statuses.vodafone.activeLive,
                        activeSleep: this.statuses.vodafone.activeSleep,
                        activeReady: this.statuses.vodafone.activeReady,
                        activeSuspended: this.statuses.vodafone.activeSuspended,
                        activeTest: this.statuses.vodafone.activeTest,
                        activeStandby: this.statuses.vodafone.activeStandby,
                        inactiveStopped: this.statuses.vodafone.inactiveStopped,
                        terminated: this.statuses.vodafone.terminated,
                        inactive: this.statuses.vodafone.inactive
                    },
                    kore: {
                        active: this.statuses.kore.active,
                        activeTest: this.statuses.kore.activeTest,
                        activeReady: this.statuses.kore.activeReady,
                        suspended: this.statuses.kore.suspended,
                        suspendedWithCharge: this.statuses.kore.suspendedWithCharge,
                        pendingScrap: this.statuses.kore.pendingScrap,
                        terminated: this.statuses.kore.terminated,
                        deactivated: this.statuses.kore.deactivated
                    }
                }
            }

            for (let tag in this.selectedTags) {
                this.initialFilters.selectedTags.push(tag.id)
            }

            for (let plan in this.selectedPlansFilter) {
                this.initialFilters.selectedPlansFilter.push(plan.id)
            }
        },
        clearFilters() {
            this.filtersSearch = ''
        },
        cancelFilters() {
            this.$refs['filtersModal'].hide()

            this.statuses = {
                simon: {
                    active: this.initialFilters.statuses.simon.active,
                    activeReady: this.initialFilters.statuses.simon.activeReady,
                    suspended: this.initialFilters.statuses.simon.suspended,
                    simBank: this.initialFilters.statuses.simon.simBank,
                    inactive: this.initialFilters.statuses.simon.inactive
                },
                tmobile: {
                    active: this.initialFilters.statuses.tmobile.active,
                    suspended: this.initialFilters.statuses.tmobile.suspended,
                    inactive: this.initialFilters.statuses.tmobile.inactive
                },
                vodafone: {
                    activeLive: this.initialFilters.statuses.vodafone.activeLive,
                    activeSleep: this.initialFilters.statuses.vodafone.activeSleep,
                    activeReady: this.initialFilters.statuses.vodafone.activeReady,
                    activeSuspended: this.initialFilters.statuses.vodafone.activeSuspended,
                    activeTest: this.initialFilters.statuses.vodafone.activeTest,
                    activeStandby: this.initialFilters.statuses.vodafone.activeStandby,
                    inactiveStopped: this.initialFilters.statuses.vodafone.inactiveStopped,
                    terminated: this.initialFilters.statuses.vodafone.terminated,
                    inactive: this.initialFilters.statuses.vodafone.inactive
                },
                kore: {
                    active: this.initialFilters.statuses.kore.active,
                    activeTest: this.initialFilters.statuses.kore.activeTest,
                    activeReady: this.initialFilters.statuses.kore.activeReady,
                    suspended: this.initialFilters.statuses.kore.suspended,
                    suspendedWithCharge: this.initialFilters.statuses.kore.suspendedWithCharge,
                    pendingScrap: this.initialFilters.statuses.kore.pendingScrap,
                    terminated: this.initialFilters.statuses.kore.terminated,
                    deactivated: this.initialFilters.statuses.kore.deactivated
                }
            }

            this.selectedTags = []
            for (let tag of this.tagsList) {
                if (this.initialFilters.selectedTags.indexOf(tag.id) > -1) {
                    tag.selected = true
                    this.selectedTags.push(tag)
                } else {
                    tag.selected = false
                }
            }

            this.selectedPlansFilter = []
            for (let plans in this.plansParsed) {
                for (let plan of this.plansParsed[plans]) {
                    if (this.initialFilters.selectedPlansFilter.indexOf(plan.id) > -1) {
                        plan.selected = true
                        this.selectedPlansFilter.push(plan)
                    } else {
                        plan.selected = false
                    }
                }
            }
        },
        setPlansFilter(filter) {
            this.plansFilterSelected = filter;
        },
        filterPlansFilter(plan) {
            if (this.plansFilterSelected == 0) {
                return true
            } else if (this.plansFilterSelected == 1) {
                if (plan.dataLimit != null && plan.dataLimit < 1024) {
                    return true
                } else {
                    return false
                }
            } else if (this.plansFilterSelected == 2) {
                if (plan.dataLimit != null && plan.dataLimit >= 1024) {
                    return true
                } else {
                    return false
                }
            } else if (this.plansFilterSelected == 3) {
                if (plan.carrierId == 1) {
                    return true
                } else {
                    return false
                }
            } else if (this.plansFilterSelected == 4) {
                if (plan.carrierId == 2) {
                    return true
                } else {
                    return false
                }
            } else if (this.plansFilterSelected == 5) {
                if (plan.carrierId == 3) {
                    return true
                } else {
                    return false
                }
            }
        },
        setInitialStatusesForFilter() {
            if (this.selectedCarrrier == 1) {
                this.statuses.simon.active = true;
                this.statuses.simon.activeReady = true;
                this.statuses.simon.simBank = true;
                this.statuses.simon.suspended = true;
                this.statuses.simon.inactive = true;
            } else if (this.selectedCarrrier == 2) {
                this.statuses.tmobile.active = true;
                this.statuses.tmobile.suspended = true;
                this.statuses.tmobile.inactive = true;
            } else if (this.selectedCarrrier == 3) {
                this.statuses.vodafone.activeLive = true;
                this.statuses.vodafone.activeSleep = true;
                this.statuses.vodafone.activeReady = true;
                this.statuses.vodafone.activeSuspended = true;
                this.statuses.vodafone.activeTest = true;
                this.statuses.vodafone.activeStandby = true;
                this.statuses.vodafone.inactiveStopped = true;
                this.statuses.vodafone.terminated = true;
                this.statuses.vodafone.inactive = true;
            }
        },
        showTags(ev) {
            let tagColumn = ev.target.parentElement
            let tagsList = tagColumn.querySelector('.tagslist')
            tagsList.classList.add('fixed-tagslist')
            tagsList.classList.add('tags-tooltip')
            let rect = ev.target.getBoundingClientRect()
            tagsList.style.top = rect.top + 20 + 'px'
            tagsList.style.left = rect.right + 20 + 'px'
            tagsList.style.maxWidth = '250px'
        },
        hideTags(ev) {
            let tagColumn = ev.target.parentElement
            let tagsList = tagColumn.querySelector('.tagslist')
            tagsList.classList.remove('fixed-tagslist')
            tagsList.classList.remove('tags-tooltip')
            tagsList.style.top = null
            tagsList.style.left = null
            tagsList.style.maxWidth = null
        }
    },
    created() {
        this.showMobileElements();
        this.selectedCarrierUrl = '&carrierId=' + this.$route.params.carrierId;
        this.selectedCarrrier = this.$route.params.carrierId;
        if (this.$cookies.get('companyId')) {
            this.companyId = this.$cookies.get('companyId')
        } else {
            this.companyId = this.$session.get('companyId')
        }
        this.setInitialStatusesForFilter();
        this.getTagsList();
        this.getTagsRemoveListBulk();
        this.getTagsAddListBulk();
        this.getPlansList();
        this.startModalApp();
    },
    mounted() {
        let self = this;
        document.addEventListener("dragenter", function (e) {
            e.preventDefault();

            if (document.querySelector(".dnd-area") && !document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                document.querySelector(".dnd-area").classList.add('dragged-fiel');
            }

            e.dataTransfer.setData("text/plain", e.target.id);
            e.dataTransfer.setData("text", e.target.id);
        });

        document.addEventListener("dragleave", function (e) {
            e.preventDefault();

            if (document.querySelector(".dnd-area") && !document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                document.querySelector(".dnd-area").classList.add('dragged-fiel');
            }
        });

        document.addEventListener("dragover", function (e) {
            e.preventDefault();
        });

        let dndArea = document.querySelector(".dnd-area");

        dndArea.addEventListener("drop", function (e) {
            e.preventDefault();

            if (document.querySelector(".dnd-area") && document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                document.querySelector(".dnd-area").classList.remove('dragged-fiel');
            }

            var files = e.dataTransfer.files;

            if (files && files.length > 0) {
                self.readSimFileModal(files);
            } else if (e.dataTransfer.getData("text").length > 0) {
                self.readDraggedList(e.dataTransfer.getData("text"))
            } else {
                self.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Wrong item dropped',
                    text: 'Item you dropped has not been recognized as a file or a list.',
                    duration: 5000,
                })
            }
        });

        document.addEventListener("drop", function (e) {
            e.preventDefault();

            if (document.querySelector(".dnd-area") && document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                document.querySelector(".dnd-area").classList.remove('dragged-fiel');
            }
        });

        if (this.$cookies.get('hotSpotAccess') == 'true') {
            this.hotSpotVisible = true
        } else if (this.$session.get('hotSpotAccess') == true) {
            this.hotSpotVisible = true
        } else {
            this.hotSpotVisible = false
        }
    },
    beforeDestroy() {
        if (!this.$cookies.get('logoutInProgress') == 'true')
        this.unselectAllRowModal()
    }
}
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
#bulk-modal___BV_modal_outer_ {
    z-index: 3030 !important;

    .modal-body {
        display: flex;
        flex-direction: column;

        > * {
            height: 100%;

            &.select-actions {
                max-height: 23px;
            }

            &.dnd-area {
                max-height: 80px;
            }


        }
    }
}
#select-from-plan___BV_modal_outer_,
#select-to-plan___BV_modal_outer_  {
    z-index: 3040 !important;
    overflow-y: scroll;
    .modal-dialog-centered {
        &:before {
            display: none;
        }
    }
}
#bulk-change {
    padding: 20px 0 15px;
    margin-bottom: 20px;
    z-index: 3020;
    border-radius: 5px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    height: 100%;
    overflow-y: auto;
    background-color: #fff;

    .select-actions {
        padding: 0 20px;
        margin-bottom: 20px;

        button {
            padding: 0;
            margin-right: 30px;
            text-transform: uppercase;
            font-size: 15px;
            line-height: 20px;
            color: #000000;
            text-decoration: none;

            &.active {
                font-weight: 700;
                color: #0088FF;
            }
        }
    }

    .upload-sims-areas {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        margin-bottom: 20px;
        padding: 0 20px;
        .input-sims-area {
            flex-grow: 1;
            width: calc(50% - 10px);
            margin-right: 20px;
            padding: 20px;
            border: 1px solid #C9CFD4;
            border-radius: 5px;
            .sims-input {
                display: flex;

                .add-sims-input {
                    flex-grow: 1;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    border: 1px solid #C9CFD4;
                    border-right: 0;
                    &:focus {
                        outline: none;
                    }
                }
                .add-sims-btn {
                    padding: 7px 20px;
                    background-color: #55cd6c;
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                    border: 1px solid #C9CFD4;
                    border-left: 0;
                    color: #fff;
                    font-weight: 700;
                }
            }
        }

        .dnd-area {
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            flex-grow: 1;
            width: calc(50% - 10px);
            padding: 20px;

            border: 2px dotted #2F353A;
            border-radius: 5px;

            &.dragged-fiel {
                background-color: #b2dbff;
            }

            .image {
                margin-right: 20px;

                img {
                    max-width: 60px;
                }
            }

            .text {
                margin-right: 25px;

                h3 {
                    margin: 0;
                    font-size: 12px;
                    line-height: 24px;
                    color: #2F353A;
                }

                h4 {
                    margin: 0;
                    font-size: 12px;
                    line-height: 16px;
                    color: #979A9C;
                }
            }

            .label {
                input {
                    display: none;
                }

                label {
                    margin: 0;
                }
            }
        }
    }

    .select-tags-areas {
        display: flex;
        width: 100%;
        padding: 0 20px 20px;
        .select-tags {
            width: calc(50% - 10px);
            padding: 20px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            border: 1px solid #C9CFD4;
            &:first-child {
                margin-right: 20px;
            }

            .header-row {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .left-side {
                    display: flex;
                    align-items: center;
                    h3 {
                        font-size: 15px;
                        margin: 0;
                    }
                    span {
                        position: absolute;
                        bottom: calc(100% + 10px);
                        display: none;
                        max-width: 300px;
                        padding: 6px 12px;
                        background-color: #f0f3f5;
                        border: 1px solid #c9cfd4;
                        -webkit-border-radius: 5px;
                        -moz-border-radius: 5px;
                        border-radius: 5px;
                    }
                    .fa-info {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 16px;
                        height: 16px;
                        margin-left: 10px;
                        font-size: 10px;
                        color: #C9CFD4;
                        border: 2px solid #C9CFD4;
                        -webkit-border-radius: 50%;
                        -moz-border-radius: 50%;
                        border-radius: 50%;
                        &:hover {
                            &+span {
                                display: initial;
                            }
                        }
                    }
                }
                .right-side {
                    .select-all-tags {
                        color: #00b1ff;
                        text-transform: uppercase;
                        font-weight: 700;
                        cursor: pointer;
                    }
                }
            }

            .info {
                font-size: 12px;
                color: #515B65;
            }

            .search-tags {
                display: flex;
                width: 270px;
                padding: 5px 14px;
                margin-bottom: 14px;
                border: 1px solid #C9CFD4;
                border-radius: 5px;
                background-color: #F0F3F5;
                input {
                    background-color: #F0F3F5;
                    border: 0;
                    outline: 0;
                }
                &:before {
                    content: '\f002';
                    display: inline-block;
                    font-family: "FontAwesome";
                    margin: 0 10px 0 0;
                    color: #727A82;
                }
            }

            .tags-list {
                display: flex;
                flex-wrap: wrap;
                max-height: 100px;
                overflow: auto;
                padding-top: 14px;
                .tag {
                    padding: 6px 16px;
                    margin: 0 10px 10px 0;
                    font-size: 14px;
                    border: 1px solid #C9CFD4;
                    -webkit-border-radius: 20px;
                    -moz-border-radius: 20px;
                    border-radius: 20px;
                    cursor: pointer;
                    &.selected {
                        color: #fff;
                        background-color: #0088ff;
                        border-color: #0088ff;
                    }
                    &.grey-out {
                        opacity: 0.5;
                        pointer-events: none;
                    }
                }
            }
            a {
                 &.sort-asc {
                     &::after {
                         background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10.002' viewBox='0 0 6 10.002'%3E%3Cg id='Group_21113' data-name='Group 21113' transform='translate(-843 -194)'%3E%3Cpath id='Path_13278' data-name='Path 13278' d='M5.6,9.766l-3-4h6Z' transform='translate(851.6 203.767) rotate(180)' fill='%2308f'/%3E%3Cpath id='Path_13396' data-name='Path 13396' d='M3,4,0,0H6Z' transform='translate(843 200.003)' fill='%23515b65'/%3E%3C/g%3E%3C/svg%3E%0A");
                     }
                 }

                 &.sort-desc {
                     &::after {
                         background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10.002' viewBox='0 0 6 10.002'%3E%3Cg id='Group_21114' data-name='Group 21114' transform='translate(-860 -194.001)'%3E%3Cpath id='Path_13278' data-name='Path 13278' d='M5.6,9.766l-3-4h6Z' transform='translate(857.4 194.237)' fill='%2308f'/%3E%3Cpath id='Path_13396' data-name='Path 13396' d='M3,4,0,0H6Z' transform='translate(866 198.001) rotate(180)' fill='%23515b65'/%3E%3C/g%3E%3C/svg%3E%0A");
                     }
                 }

                 i {
                     margin-left: 8px;
                     color: #0088FF;
                 }

                 cursor: pointer;
             }
        }
    }

    .instructions-box {
        padding: 0 20px 10px;
        h3 {
            font-size: 15px;
            margin: 0 0 4px;
            font-weight: 700;
        }
        .instructions {
            display: flex;
            .step {
                margin-right: 16px;
            }
        }
    }

    .sims-failed-validation-from-file {
        margin: 0 20px;
        padding: 20px;
        background-color: #ffe3e3;
        border: 1px solid #FC4D4D;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        margin-bottom: 20px;

        h3 {
            margin: 0 0 4px;
            font-size: 15px;
            font-weight: 700;
        }
        h4 {
            font-size: 12px;
            color: #515B65;
            margin: 0 0 30px;
            font-weight: 400;
        }
        .error-type {
            margin-bottom: 10px;
            .name {
                margin: 0 0 4px;
                font-size: 15px;
                font-weight: 700;
            }
            .desc {
                margin: 0 0 15px;
                font-size: 12px;
                color: #515B65;
                font-weight: 400;
            }
            .list-of-sims {
                display: flex;
                flex-wrap: wrap;
                .sim {
                    display: flex;
                    align-items: center;
                    margin: 0 50px 12px 0;
                    i {
                        margin-right: 12px;
                        &:before {
                            color: #515B65;
                        }
                    }
                }
            }
        }
    }

    .states-box {
        .states-header {
            margin: 20px 0;
            h3 {
                margin-bottom: 6px;
                font-size: 14px;
                font-weight: 700;
            }
        }
        .states {
            display: flex;
            .state {
                width: 144px;
                margin-right: 10px;
                padding: 14px 0;
                text-align: center;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                border: 1px solid #C9CFD4;
                font-size: 14px;
                line-height: 1;
                cursor: pointer;
                input {
                    display: none;
                }
                &:hover {
                    border-color: #0088ff;
                }
                &.selected {
                    border-color: #0088FF;
                    -webkit-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    -moz-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                }
            }
        }
    }

    .siot-table-wrapper {
        .siot-table-footer {
            .siot-table-footer-right {
                .siot-table-footer-buttons {
                    position: relative;
                    .hints {
                        display: none;
                        position: absolute;
                        bottom: 40px;
                        right: 0;
                        .hint {
                            padding: 6px 12px;
                            background-color: #241717;
                            color: #fff;
                            -webkit-border-radius: 5px;
                            -moz-border-radius: 5px;
                            border-radius: 5px;
                        }
                    }
                    button {
                        &:hover {
                            &+.hints {
                                display: initial;
                            }
                        }
                    }
                }
            }
        }
    }

    .dgo-bulk {
        .dgo-settings-box {
            width: calc(50% - 10px);
            padding: 20px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            border: 1px solid #C9CFD4;
            h3 {
                font-size: 14px;
            }
            .dgo-settings {
                display: flex;
                .column {
                    margin-right: 115px;
                    &:last-child {
                        margin-right: 0;
                    }
                    .dgo-setting-field {
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 10px;
                        &:last-child {
                            margin-bottom: 0;
                        }
                        h3 {
                            font-weight: 700;
                        }
                        .inputs-row {
                            display: flex;
                            input[type="number"] {
                                width: 120px;
                                margin-right: 10px;
                            }
                            .custom-select {
                                width: 70px;
                            }
                        }
                        &.speed-box {
                            .custom-select {
                                width: 200px;
                            }
                        }
                        .dgo-warn {
                            font-size: 12px;
                            color: #979A9C;
                            &.hidden {
                                visibility: hidden;
                            }
                        }
                    }
                    .unlimited-row {
                        display: flex;
                        align-items: center;
                        margin-top: 20px;
                        .unlimited-label {
                            margin-left: 12px;
                        }
                    }
                }
            }
        }
    }

    .migrate-plan,
    .dgo-bulk {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 20px;
        padding: 0 20px;

        .migrate-from-outer,
        .migrate-to-outer {
            width: calc(50% - 10px);
            h3 {
                flex-grow: 1;
                font-size: 14px;
                line-height: 22px;
            }
        }

        .plan-selectors {
            display: flex;
            justify-content: space-between;
            width: 100%;
            .migrate-from,
            .migrate-to {
                min-height: 200px;
                height: 100%;

                display: flex;
                justify-content: center;
                align-items: center;
                align-content: center;
                text-align: center;

                border: 1px solid #C9CFD4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;

                button {
                    margin-bottom: 8px;
                    box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
                }

                label {
                    margin-top: 20px;

                    input {
                        margin-right: 20px;
                    }
                }
            }
        }
    }

    .migrate-plan {
        margin-bottom: 50px;
    }

    .sims-list-wrapper {
        position: relative;
        .col-md-2 {
            label {
                margin-right: 10px;
            }
        }
    }

    .cold-sims-list {
        .col-md-2.text-right {
            label {
                margin-right: 10px;
            }
        }
    }


    .bottom-table {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        align-content: flex-end;
        padding: 20px 20px 0;
        margin-bottom: 5px;

        nav {
            ul {
                margin-bottom: 0;
            }
        }

        .button-wrapper {
            position: relative;
            .hint-box {
                display: none;
            }
            .migrate {
                &:hover {
                    +.hint-box {
                        display: block;
                        position: absolute;
                        bottom: calc(100% + 10px);
                        right: 0;
                        white-space: nowrap;
                        padding: 8px 16px;
                        background-color: #292a2d;
                        color: #fff;
                        -webkit-border-radius: 5px;
                        -moz-border-radius: 5px;
                        border-radius: 5px;
                    }
                }
            }
            button {
                margin-left: 10px;

                &.migrate {
                    background-color: #55CD6C;
                    border-color: #55CD6C;
                }
            }
            .vodafone-change-state-control-box {
                position: relative;
                display: flex;
                align-items: center;
                span {
                    margin-right: 10px;
                    white-space: nowrap;
                }
                .select-state {
                    max-width: none;
                    select {
                        outline: none;
                        &:focus {
                            outline: none;
                        }
                    }
                }
                .hint-box {
                    position: absolute;
                    bottom: calc(100% + 20px);
                    right: 0;
                    display: none;
                    max-width: 300px;
                    padding: 20px;
                    background-color: #241717;
                    color: #fff;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    p {
                        margin: 0;
                    }
                }
                .change-state-btn {
                    &:hover {
                        +.hint-box {
                            display: block;
                        }
                    }
                }
            }
        }
    }

    .fts-table-wrapper,
    .cold-stock-list-wrapper {
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        border-radius: 0;
        .row {
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #c9cfd4;
            border-bottom: 1px solid #c9cfd4;
            padding: 20px;
            margin: 0;
            .text-right {
                label {
                    margin-right: 10px;
                }
            }
        }
        .sim-swap-header {
            padding: 0 20px;
        }
        .search-box {
            max-width: 314px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #f0f3f5;
            border: 1px solid #c9cfd4;
            color: #edeeef;
            border-radius: 5px;

            &::before {
                content: "\f002";
                display: inline-block;
                font-family: 'FontAwesome';
                margin: 0 0 0 10px;
                color: #727a82;
            }

            input {
                display: inline-block;
                width: 88%;
                margin: 0;
                border: 0;
                background-color: transparent;
                padding-left: 20px;

                &:focus {
                    box-shadow: none;
                }
            }
        }
    }

    .fts-table-wrapper {
        .fts-table {
            th {
                white-space: nowrap;
            }
            .tags-cell {
                .tags-number {
                    position: relative;
                    padding: 4px 20px;
                    border: 1px solid #c9cfd4;
                    -webkit-border-radius: 15px;
                    -moz-border-radius: 15px;
                    border-radius: 15px;
                    text-align: center;
                    white-space: nowrap;
                    overflow: visible;

                    .tags-list {
                        display: none;
                        position: absolute;
                        top: 0;
                        left: 110%;
                        flex-wrap: wrap;
                        background-color: #241717;
                        color: #fff;
                        -webkit-border-radius: 5px;
                        -moz-border-radius: 5px;
                        border-radius: 5px;
                        padding: 4px 10px;

                        .tag {
                            &::after {
                                content: ',';
                                margin-right: 4px;
                            }

                            &:last-child {
                                &::after {
                                    content: none;
                                }
                            }
                        }
                    }

                    &:hover {
                        .tags-list {
                            display: flex;
                        }
                    }
                }
            }
        }
    }
}

.change-tags-summary {
    margin: 0 0 20px;
    background-color: #fff;
    border: 1px solid #C9CFD4;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    h1 {
        padding: 20px 20px 0;
        margin: 0;
        font-size: 15px;
        font-weight: 700;
    }
    .summary-boxes {
        display: flex;
        padding: 20px;
        .summary-box {
            width: 240px;
            margin-right: 20px;
            padding: 20px;
            background-color: #F5F5F5;
            border: 1px solid #C9CFD4;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            h3 {
                margin: 0 0 10px;
                font-size: 20px;
            }
            h5 {
                margin: 0;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }
    .table-tags {
        td,th {
            &:nth-child(1) {
                max-width: none !important;
            }
        }
        th {
            &:nth-child(2) {
                width: 25%;
            }
            &:nth-child(3) {
                width: 25%;
            }
            &:nth-child(4) {
                width: 15%;
            }
            &:nth-child(5) {
                width: 15%;
            }
        }
        .tags-added-removed {
            span {
                &:after {
                    content: ', '
                }
                &:last-child {
                    &:after {
                        content: none;
                    }
                }
            }
        }
        .tags-after-before {
            .tags-label {
                position: relative;
                padding: 8px 20px;
                font-size: 14px;
                border: 1px solid #C9CFD4;
                -webkit-border-radius: 20px;
                -moz-border-radius: 20px;
                border-radius: 20px;
                cursor: pointer;
                .tags-hint {
                    position: absolute;
                    display: none;
                    flex-wrap: wrap;
                    left: calc(100% - 25px);
                    top: 50%;
                    padding: 6px 12px;
                    margin-left: 12px;
                    color: #fff;
                    background-color: #241717;
                    border: 1px solid #707070;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    z-index: 10;
                    span {
                        white-space: nowrap;
                        &:after {
                            content: ',';
                            margin-right: 2px;
                        }
                        &:last-child {
                            &:after {
                                content: none;
                            }
                        }
                    }
                }
                &:hover {
                    .tags-hint {
                        display: flex;
                    }
                }
            }
        }
        tr {
            &:last-child {
                .tags-after-before {
                    .tags-label {
                        .tags-hint {
                            top: initial;
                            bottom: 50%;
                        }
                    }
                }
            }
        }
    }
    .siot-table-footer {
        display: flex;
        justify-content: flex-end;
        padding: 20px;
        border-top: 1px solid #c9cfd4;
        .siot-table-footer-right {
            .btn {
                margin-left: 10px;
            }
        }
    }
}


.sim-action-validation {
    padding: 20px 0 20px 0;
    z-index: 3020;
    border-radius: 5px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    height: 100%;
    overflow-y: auto;
    background-color: #fff;
    h3 {
        font-size: 15px;
        margin: 0 0 17px 20px;
        font-weight: 700;
    }
    h4 {
        font-size: 14px;
        margin: 0 0 23px 20px;
        font-weight: 400;
    }

    &.dgo-summary {
        margin-bottom: 20px;
        h1 {
            margin: 0 20px 20px;
            font-size: 15px;
            font-weight: 700;
        }
        .dgo-summary-box {
            max-height: calc(100vh - 274px);
            overflow: auto;
        }
        .sim-action-control-bar {
            padding-top: 20px;
        }
    }

    .validation-passed,
    .validation-failed {
        margin-bottom: 30px;
        .validation-passed-simlist,
        .validation-failed-simlist {
            display: flex;
            flex-wrap: wrap;
            padding: 0 20px;
            .sim {
                display: flex;
                align-items: center;
                margin-right: 30px;
                margin-bottom: 25px;
                .fts-icon-sim {
                    margin-right: 12px;
                    &:before {
                        color: #515B65;
                    }
                }
                .remove-sim-icon {
                    margin-left: 14px;
                    cursor: pointer;
                }
            }
        }
    }

    .validation-failed {
        .validation-failed-category {
            &.hidden-list {
                display: none;
            }
            h3 {
                font-size: 15px;
                font-weight: 700;
                margin: 0 0 8px 20px;
            }
            h4 {
                font-size: 12px;
                margin: 0 0 20px 20px;
                font-weight: 400;
            }
        }
    }


    .validation-passed-header,
    .validation-failed-header {
        padding: 20px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        cursor: pointer;
        h3 {
            margin: 0;
            color: #ffffff;
            font-weight: 700;
        }
        i {
            color: #fff;
            cursor: pointer;
        }
    }

    .validation-passed-header {
        background-color: #55cd6c;
    }

    .validation-failed-header {
        background-color: #fc4d4d;
    }

    .sim-action-control-bar {
        display: flex;
        justify-content: flex-end;
        padding: 0 20px;
        .btn {
            margin-left: 10px;
        }
        .capitalize {
            text-transform: capitalize;
        }
    }
}

#select-from-plan,
#select-to-plan {
    z-index: 3050;

    .modal-header {
        padding-bottom: 0;

        .modal-title {
            font-size: 15px;
            line-height: 21px;
            font-weight: 700;
        }
    }
    .search-row {
        margin-bottom: 20px;
    }
    .modal-dialog {
        max-width: none;
        width: 95%;
        min-height: 93%;

        .modal-content {
            background-color: #F0F3F5;
            border: 0;
        }

        .modal-body {
            .modal-header {
                padding: 0;
                flex-direction: column;

                .rate-plan-name {
                    display: block;
                    margin-bottom: 20px;
                    font-size: 15px;
                    font-weight: 700;
                    color: #2F353A;
                }

                .filters-plan {
                    span {
                        margin-left: 10px;
                        cursor: pointer;

                        &.active {
                            font-weight: 700;
                        }
                    }
                }
            }

            .modal-content {
                .templates-wrap {
                    border: 0;

                    &.no-templates {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        align-items: center;
                    }

                    .simon-plans {
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                    }

                    .tmobile-plans,
                    .vodafone-plans {
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                    }

                    .template-item {
                        &.plan-filtered {
                            display: none;
                        }
                        cursor: pointer;
                        &.plan-inactive {
                            opacity: .5;
                        }
                        .sims-available {
                            padding: 12px 30px;
                            background-color: #0088ff;
                            font-size: 14px;
                            text-align: center;
                            color: #fff;
                            border-top-right-radius: 5px;
                            border-top-left-radius: 5px;
                        }
                        &.plan-selected {
                            -webkit-box-shadow: 0px 0px 0px 2px #0088ff;
                            box-shadow: 0px 0px 0px 2px #0088ff;
                        }
                    }
                }
            }
        }

    }

    .loader-plans-list {
        z-index: 4090;
        position: absolute;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 0;

        background-color: rgba(255, 255, 255, 0.7);

        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;

        .sk-wave {
            margin: 80px auto 20px;
            height: 60px;
            z-index: 45090;
            .sk-rect {
                width: 3px;
                background-color: #39c354;
                border-radius: 4px;
            }
        }

        .text {
            margin-top: 20px;
            text-align: center;
            font-size: 15px;
            font-weight: 700;
        }

        h2.text {
            margin-top: 180px;
        }
    }
}

#simActions___BV_modal_outer_ {
    z-index: 3040 !important;

    .modal-body {
        padding-top: 0;
        text-align: center;

        img {
            max-width: 16px;
            margin-bottom: 16px;
        }

        h3 {
            font-size: 15px;
            line-height: 20px;
            font-weight: 700;
            color: #2F353A;
        }

        h4 {
            display: block;
            margin-bottom: 40px;
            font-size: 14px;
            line-height: 24px;
            color: #515B65;
        }

        .button-wrapper {
            text-align: center;

            button {
                margin: 0 10px;
            }
        }
    }
}

.inner-migrate {
    width: 100%;
    padding: 20px;
    .header-plan {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;

        .title {
            width: 100%;
            text-align: left;
            h3 {
                margin: 0;
                font-size: 15px;
                line-height: 20px;
                font-weight: 700;
                color: #3A4149;
            }

            .category {
                display: flex;
                justify-content: space-between;

                h4 {
                    margin: 0;
                    padding: 0 12px;
                    color: #000;
                    -webkit-border-radius: 2px;
                    -moz-border-radius: 2px;
                    border-radius: 2px;
                    font-size: 22px;
                    line-height: 29px;
                    font-weight: 700;
                    text-transform: uppercase;
                }

                &.flex {
                    h4 {
                        background-color: #abe390 !important;
                    }
                }

                &.highbandwidth {
                    h4 {
                            background-color: #FF5ADE !important;
                    }
                }

                &.nb-iot {
                    h4 {
                        background-color: #8ac8ff !important;
                    }
                }

                &.cat-m1 {
                    h4 {
                        background-color: #ffc400 !important;
                    }
                }

                em {
                    font-size: 22px;
                    line-height: 29px;
                    font-weight: 700;
                    color: #2F353A;
                    font-style: normal;
                }

                &.magenta {
                    h4 {
                        color: #ffa1ec;
                    }
                }

                &.vodafone {
                    h4 {
                        color: #ffa1a1;
                    }
                }
            }
        }

        .button {
            width: 100%;
            text-align: right;
            .remove-plan {
                font-size: 20px;
                margin-left: 20px;
                cursor: pointer;
            }
        }
    }

    .body-plan {
        padding: 10px 0;
        margin: 10px 0;
        border-top: 1px solid #D5D6D7;
        border-bottom: 1px solid #D5D6D7;

        .list-options {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .item-options {
                width: 48%;
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;

                span {
                    font-size: 14px;
                }

                em {
                    font-style: normal;
                    font-weight: 700;
                    text-transform: uppercase;
                    font-weight: 14px;
                    color: #515B65;
                }

                &.true {
                    em {
                        color: #55CD6C;
                    }
                    .value-in-mb {
                        color: #000000;
                        font-weight: 400;
                    }
                }
            }
        }
    }

    .plan-description {
        text-align: left;
    }
}

#fileFormatModalTags___BV_modal_header_,
#fileFormatModal___BV_modal_header_ {
    padding-bottom: 0;
}

#fileFormatModalTags___BV_modal_body_,
#fileFormatModal___BV_modal_body_ {
    padding-top: 0;
    .file-format-popup {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        padding: 0 20px 20px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;

        h3 {
            font-size: 15px;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        .btn {
            width: 100px;
        }

        .btn-primary {
            margin: 0 10px 20px;
        }

        .btn-light {
            margin: 10px 0 0;
        }

        .csv {
            background-color: #00559F;
            border-color: #00559F;
        }
        .xls {
            background-color: #207245;
            border-color: #207245;
        }

        .close-icon {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
        }
    }
}

.sims-list-wrapper {
    &.fts-table-wrapper {
        padding-bottom: 0;
        margin-bottom: 0;
        border: none;
    }
}

#size-page {
    display: inline-block;
    width: auto;
}

#filtersModal___BV_modal_body_ {
    display: flex;
    flex-direction: column;
    padding: 0;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    .inner-modal {
        position: relative;
        flex-grow: 1;
        .close-filters-icon {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            &.light-mode {
                display: initial;
            }
            &.dark-mode {
                display: none;
            }
        }
        .filters-search {
            padding: 20px;
            border-bottom: 1px solid #c9cfd4;
            .FTSsearch {
                padding-right: 6px;
                .clear-filters-icon {
                    cursor: pointer;
                    &.light-mode {
                        display: initial;
                    }
                    &.dark-mode {
                        display: none;
                    }
                }
            }
        }
        .comapnies-statuses-row {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #c9cfd4;

            .company-statuses-box {
                flex-grow: 1;
                max-height: 350px;
                display: flex;
                flex-direction: column;
                padding: 20px;
                border-right: 1px solid #c9cfd4;

                &:last-child {
                    border-right: none;
                }

                .logo-switch-row {
                    display: flex;
                    justify-content: space-between;

                    img {
                        height: 26px;
                        width: auto;

                        &.light-mode {
                            display: block;
                        }

                        &.dark-mode {
                            display: none;
                        }
                    }
                }

                h4 {
                    margin: 22px 0 18px;
                    font-size: 15px;
                    font-weight: 700;
                }

                .statuses-list {
                    display: flex;
                    flex-direction: column;
                    flex-wrap: wrap;
                    max-height: 200px;

                    .FTScheckbox {
                        width: 25%;
                        &.hidden {
                            display: none;
                        }
                    }
                }

                .select-all-row {
                    flex-grow: 1;
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-end;

                    a {
                        color: #00b1ff;
                        text-transform: uppercase;
                        font-weight: 700;
                        cursor: pointer;
                    }
                }
            }
        }

        .tags-plans-row {
            height: 400px;
            display: flex;
            background-color: #f9f9f9;
            .tags-box {
                flex-grow: 1;
                max-width: 50%;
                padding: 20px;
                border-right: 1px solid #c9cfd4;
                overflow: auto;

                .tags-title {
                    margin: 0 0 10px;
                    font-size: 15px;
                    font-weight: 700;
                }

                .selected-tags-count {
                    margin: 0 0 12px;
                }

                .tags-list-header {
                    margin: 0 0 12px;
                    font-size: 15px;
                    font-weight: 700;
                }

                .FTSsearch {
                    display: flex;
                    align-items: center;
                    width: 300px;
                    height: 35px;
                    padding: 6px 18px;
                    background-color: #e4e5e6;
                    border: 1px solid #c9cfd4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;

                    input {
                        flex-grow: 1;
                        margin-left: 14px;
                        background-color: #e4e5e6;
                        border: none;

                        &:focus {
                            outline: none;
                        }
                    }
                }

                .tag-list-sort {
                    margin-bottom: 14px;

                    span {
                        margin-right: 8px;
                    }

                    a {
                        margin-right: 50px;

                        &.sort-asc {
                            &::after {
                                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10.002' viewBox='0 0 6 10.002'%3E%3Cg id='Group_21113' data-name='Group 21113' transform='translate(-843 -194)'%3E%3Cpath id='Path_13278' data-name='Path 13278' d='M5.6,9.766l-3-4h6Z' transform='translate(851.6 203.767) rotate(180)' fill='%2308f'/%3E%3Cpath id='Path_13396' data-name='Path 13396' d='M3,4,0,0H6Z' transform='translate(843 200.003)' fill='%23515b65'/%3E%3C/g%3E%3C/svg%3E%0A");
                            }
                        }

                        &.sort-desc {
                            &::after {
                                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10.002' viewBox='0 0 6 10.002'%3E%3Cg id='Group_21114' data-name='Group 21114' transform='translate(-860 -194.001)'%3E%3Cpath id='Path_13278' data-name='Path 13278' d='M5.6,9.766l-3-4h6Z' transform='translate(857.4 194.237)' fill='%2308f'/%3E%3Cpath id='Path_13396' data-name='Path 13396' d='M3,4,0,0H6Z' transform='translate(866 198.001) rotate(180)' fill='%23515b65'/%3E%3C/g%3E%3C/svg%3E%0A");
                            }
                        }

                        i {
                            margin-left: 8px;
                            color: #0088FF;
                        }

                        cursor: pointer;

                        &.sorting {
                            font-weight: 700;
                        }
                    }
                }

                .selected-tags-list {
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 12px;

                    .selected-tag {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        color: #fff;
                        border: 1px solid #0088ff;
                        -webkit-border-radius: 16px;
                        -moz-border-radius: 16px;
                        border-radius: 16px;
                        font-size: 15px;
                        line-height: 19px;
                        padding: 6px 20px;
                        margin: 0 8px 8px;
                        background-color: #0088ff;
                        cursor: pointer;

                        &.hidden {
                            display: none;
                        }

                        .close-cross {
                            width: 14px;
                            height: 14px;
                            margin-left: 6px;
                        }
                    }
                }

                .FTSsearch {
                    margin-bottom: 14px;
                }

                .tags-list {
                    display: flex;
                    flex-wrap: wrap;

                    .tag {
                        color: #2F353A;
                        border: 1px solid #C9CFD4;
                        -webkit-border-radius: 16px;
                        -moz-border-radius: 16px;
                        border-radius: 16px;
                        font-size: 15px;
                        line-height: 19px;
                        padding: 6px 20px;
                        margin: 0 8px 8px;
                        background-color: #fff;
                        cursor: pointer;

                        &.selected,
                        &.hidden {
                            display: none;
                        }

                        &:hover {
                            border-color: #0088ff;
                        }
                    }
                }
            }

            .plans-box {
                max-width: 50%;
                flex-grow: 1;
                padding: 20px;
                overflow: auto;

                .plans-title {
                    margin: 0 0 10px;
                    font-size: 15px;
                    font-weight: 700;
                }

                .plans-alpha-box {
                    &.hidden {
                        display: none;
                    }
                }

                .selected-plans-box {
                    display: flex;
                    margin-bottom: 10px;
                    flex-wrap: wrap;

                    .selected-plan {
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                        margin-right: 10px;
                        color: #ffffff;
                        padding: 6px;
                        -webkit-border-radius: 5px;
                        -moz-border-radius: 5px;
                        border-radius: 5px;

                        &.simon-plan {
                            background-color: #00B1FF;
                        }

                        &.tmobile-plan {
                            background-color: #E20074;
                        }

                        &.vodafone-plan {
                            background-color: #EE3023;
                        }

                        .company-plan-logo {
                            margin-right: 16px;
                        }

                        .close-cross {
                            margin-left: 8px;
                            cursor: pointer;
                        }
                    }
                }

                .plans-filters-box {
                    margin-top: 12px;
                    margin-bottom: 20px;

                    a {
                        margin-right: 20px;
                        color: #2F353A;
                        cursor: pointer;

                        &:hover {
                            color: #0088FF;
                        }

                        &.active-filter {
                            color: #0088FF;
                        }
                    }
                }

                .plans-list {
                    .plans-alpha-box {
                        h6 {
                            margin-top: 12px;
                            margin-bottom: 12px;
                        }
                    }
                }

                .FTSsearch {
                    display: flex;
                    align-items: center;
                    width: 300px;
                    height: 35px;
                    padding: 6px 18px;
                    background-color: #e4e5e6;
                    border: 1px solid #c9cfd4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;

                    input {
                        flex-grow: 1;
                        margin-left: 14px;
                        background-color: #e4e5e6;
                        border: none;

                        &:focus {
                            outline: none;
                        }
                    }
                }

                .FTScheckbox {
                    &.hidden {
                        display: none;
                    }
                }
            }
        }
    }
    .filters-control-bar {
        display: flex;
        justify-content: space-between;
        padding: 12px 20px;
        background-color: #f9f9f9;
        .right-side {
            .btn-primary {
                margin-left: 10px;
            }
        }
    }
}

.search-filter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;

    .search-box {
        margin-right: 20px;
    }

    .checkbox {
        margin-right: 20px;
        cursor: pointer;
        label {
            cursor: pointer;
            margin: 0;

            input {
                margin-right: 10px;
            }
        }
    }
}

#select-from-plan .templates-wrap .template-item.plan-inactive {
    pointer-events: auto;
}

#DGOwarn___BV_modal_body_ {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .fa-close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
    img {
        margin-bottom: 12px;
    }
    h3 {
        margin-bottom: 20px;
        font-size: 15px;
        text-transform: uppercase;
    }
    p {
        text-align: center;
    }
}

.dark-theme {
    .sim-action-validation {
        background-color: #3a4149;
        h3, h4 {
            color: #fff;
        }
        .validation-passed {
            .validation-passed-simlist {
                .sim {
                    color: #fff;
                    .fts-icon-sim {
                        &:before {
                            color: #fff;
                        }
                    }
                }
            }
        }
        .validation-failed {
            .validation-failed-simlist {
                .sim {
                    color: #fff;
                    .fts-icon-sim {
                        &:before {
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
    #bulk-modal___BV_modal_content_ {
        background-color: #3A4149;
        #bulk-modal___BV_modal_header_ {
            color: #edeeef;
            .close {
                color: #edeeef;
                opacity: 1;
            }
        }
        #bulk-modal___BV_modal_body_ {
            .select-actions {
                .btn-link {
                    color: #edeeef;
                    &.active {
                        color: #0088ff;
                    }
                }
            }
            .dnd-area {
                border-color: #edeeef;
                .text {
                    h3 {
                        color: #edeeef;
                    }
                }
            }
            .sims-list-wrapper {
                .row {
                    .form-control {
                        background-color: #515b65;
                        border-color: #1a1c1d;
                        color: #EDEEEF;
                    }
                    .text-right {
                        color: #edeeef;
                    }
                }
            }
            .bottom-table {
                .selected-sim {
                    color: #edeeef;
                }
            }
        }
    }
    .tags-list-header {
        background-color: #343a41;
    }
}

.dark-theme {
    #simActions {
        .modal-content {
            background-color: #515b65;
            border: 1px solid #1a1c1d;
            color: #fff;

            h3,
            h4 {
                color: #fff;
            }
        }
    }
    .close {
        color: #fff;
    }
    .inner-migrate {
        .header-plan {
            .title {
                h3 {
                    color: #fff;
                }
                .category {
                    em {
                        color: #fff;
                    }
                }
            }
        }
        .body-plan {
            border-color: #1a1c1d;
            .list-options {
                .item-options {
                    em {
                        color: #fff;
                    }
                    &.true {
                        .value-in-mb {
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
    #select-from-plan,
    #select-to-plan {
        z-index: 5090;
        .modal-content {
            background-color: #515b65;
            border: 1px solid #1a1c1d;
            color: #fff;

            .modal-content {
                border: 0;
            }
        }
        .modal-dialog .modal-body .modal-header .rate-plan-name {
            color: #fff;
        }
    }
    #bulk-change .migrate-plan .migrate-from,
    #bulk-change .migrate-plan .migrate-to {
        border: 1px solid #1a1c1d;
    }
    .fts-table-wrapper {
        .search-box {
            background-color: #515b65;
            border: 1px solid #1a1c1d;
            color: #edeeef;

            &::before {
                color: #fff;
            }

            input {
                color: #fff;
                &::placeholder {
                    color: #fff;
                }
            }
        }

        #size-page {
            background-color: #515b65;
            border: 1px solid #1a1c1d;
            color: #edeeef;
        }
    }
    #bulk-change {
        background-color: #3a4149;
        color: #edeeef;
        border: 1px solid #1a1c1d;

        .sims-failed-validation-from-file {
            background-color: #6b3d3d;
            h4 {
                color: #fff;
            }
            .error-type {
                .desc {
                    color: #fff;
                }
                .list-of-sims {
                    .sim {
                        i {
                            &:before {
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }

        .boxhead {
            h3 {
                color: #edeeef;
            }
        }

        .dgo-bulk {
            .plan-selectors {
                .migrate-from {
                    border-color: #1a1c1d;
                }

                .dgo-settings-box {
                    border-color: #1a1c1d;
                }
            }
        }
    }

    #bulk-change .select-actions button {
        color: #fff;
        font-weight: 700;
        &.active {
            color: #0088FF;
        }
    }

    #bulk-change {
        .upload-sims-areas {
            .input-sims-area {
                border-color: #1a1c1d;

                .sims-input {
                    .add-sims-input {
                        color: #fff;
                        background-color: #505a64;
                        border-color: #1a1c1d;
                    }

                    .add-sims-btn {
                        border-color: #1a1c1d;
                    }
                }
            }
            .dnd-area {
                border-color: #1A1C1D;
                .text {
                    h3 {
                        color: #fff;
                    }
                }
            }
        }
    }

    #bulk-change {
        .upload-sims-areas {
            .input-sims-area {
                border-color: #1a1c1d;

                .sims-input {
                    .add-sims-input {
                        color: #fff;
                        background-color: #505a64;
                        border-color: #1a1c1d;
                    }

                    .add-sims-btn {
                        border-color: #1a1c1d;
                    }
                }
            }
        }

        .fts-table-wrapper,
        .cold-stock-list-wrapper {
            .row {
                border-top: 1px solid #1a1c1d;
                border-bottom: 1px solid #1a1c1d;
            }
            .search-box {
                background-color: #515b65;
                border: 1px solid #1a1c1d;
                color: #edeeef;

                &::before {
                    color: #fff;
                }

                input {
                    color: #fff;
                    &::placeholder {
                        color: #fff;
                    }
                }
            }

            #size-page {
                background-color: #515b65;
                border: 1px solid #1a1c1d;
                color: #edeeef;
            }
        }

        .cold-stock-list-wrapper {
            .table-coldstock {
                color: #fff;
                thead {
                    tr {
                        th {
                            border-color: #1a1c1d;
                        }
                    }
                }
                tbody {
                    tr {
                        td {
                            border-color: #1a1c1d;
                        }
                        &:nth-child(odd) {
                            td {
                                background-color: #2f353a;
                            }
                        }
                        &:nth-child(even) {
                            td {
                                background-color: #3a4149;
                            }
                        }
                        &[aria-selected="true"] {
                            td {
                                background-color: #bfe1ff;
                                color: #000;
                            }
                        }
                        &:hover {
                            td {
                                background-color: #0088ff;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }


        .sim-action-validation {
            background-color: #3a4149;
            color: #fff;
            .validation-passed,
            .validation-failed {
                .validation-passed-simlist,
                .validation-failed-simlist {
                    .sim {
                        .fts-icon-sim:before {
                            color: #fff;
                        }
                    }
                }
            }
        }
        .select-tags-areas {
            .select-tags {
                border: 1px solid #1a1c1d;
                .header-row {
                    .left-side {
                        .fa-info {
                            &+span {
                                background-color: #2f353a;
                                border-color: #1a1c1d;
                            }
                        }
                    }
                }
            }
            .select-tags {
                .info {
                    color: #fff;
                }
                .search-tags {
                    border-color: #1a1c1d;
                    background-color: #515b65;
                    input {
                        color: #fff;
                        background-color: #515b65;
                        &::placeholder {
                            color: #fff;
                        }
                    }
                }
                .tags-list {
                    .tag {
                        background-color: #2f353a;
                        border-color: #1a1c1d;
                        &.selected {
                            color: #fff;
                            background-color: #0088ff;
                            border-color: #0088ff;
                        }
                    }
                }
            }
        }
    }

    .change-tags-summary {
        background-color: #3a4149;
        border-color: #1a1c1d;
        color: #fff;
        .summary-boxes {
            .summary-box {
                background-color: #333941;
                border-color: #1a1c1d;
            }
        }
        .table-tags {
            .tags-after-before {
                .tags-label {
                    border-color: #1a1c1d;
                }
            }
        }
        .siot-table-footer {
            border-color: #1a1c1d;
        }
    }

    .sims-list-wrapper {
        .form-group {
            max-width: 314px;
            background-color: #515b65;
            color: #EDEEEF;

            input {
                background-color: transparent;
                color: #EDEEEF;
                border: 1px solid #1a1c1d;

                &::placeholder {
                    color: #EDEEEF;
                }

                &:focus {
                    box-shadow: none;
                }
            }
        }
    }
    #filtersModal___BV_modal_body_ {
        .inner-modal {
            .filters-search {
                border-color: #1a1c1d;
            }
            .close-filters-icon {
                &.light-mode {
                    display: none;
                }
                &.dark-mode {
                    display: initial;
                }
            }
            .FTSsearch {
                .clear-filters-icon {
                    &.light-mode {
                        display: none;
                    }
                    &.dark-mode {
                        display: initial;
                    }
                }
            }
        }
        .comapnies-statuses-row {
            border-color: #1a1c1d;
            .company-statuses-box {
                .logo-switch-row {
                    img {
                        &.light-mode {
                            display: none;
                        }
                        &.dark-mode {
                            display: block;
                        }
                    }
                }
            }
        }
        .tags-plans-row {
            background-color: #343a41;
            .tags-box {
                border-color: #1a1c1d !important;
                .tags-list {
                    .tag {
                        background-color: #2f353a;
                        color: #fff;
                        border-color: #1a1c1d;
                    }
                }
                .FTSsearch {
                    background-color: #515b65;
                    border-color: #1a1c1d;
                    input {
                        background-color: #515b65;
                    }
                }
                .tag {
                    background-color: #3a4149;
                    border-color: #1a1c1d;
                    color: #fff;
                }
            }
            .plans-box {
                .FTSsearch {
                    background-color: #515b65;
                    border-color: #1a1c1d;
                    input {
                        background-color: #515b65;
                    }
                }
                .plans-filters-box {
                    a {
                        color: #fff;
                        &.active-filter {
                            color: #0088FF;
                        }
                    }
                }
            }
        }
        .filters-control-bar {
            background-color: #2f353a;
        }
    }

    #bulk-modal___BV_modal_content_ {
        background-color: #3A4149;
        #bulk-modal___BV_modal_header_ {
            color: #edeeef;
            .close {
                color: #edeeef;
                opacity: 1;
            }
        }
        #bulk-modal___BV_modal_body_ {
            .select-actions {
                .btn-link {
                    color: #edeeef;
                    &.active {
                        color: #0088ff;
                    }
                }
            }
            .dnd-area {
                border-color: #edeeef;
                .text {
                    h3 {
                        color: #edeeef;
                    }
                }
            }
            .sims-list-wrapper {
                .row {
                    .form-control {
                        background-color: #515b65;
                        border-color: #1a1c1d;
                        color: #EDEEEF;
                    }
                    .text-right {
                        color: #edeeef;
                    }
                }
            }
            .bottom-table {
                .selected-sim {
                    color: #edeeef;
                }
            }
        }
    }

    #fileFormatModalTags {
        .modal-body {
            .file-format-popup {
                background-color: #3a4149;
            }
        }
    }
}

.mobile-text,
.mobile-actions-wrapper {
    display: none;
}

.selected-vodafone {
    >.btn {
        display: none;
    }
}

.cold-stock-mobile {
    width: 100%;
}
</style>
